import React, { useState, useEffect, useRef, useCallback } from 'react'; // <<< Důležité: Přidán useCallback
import AdminCalendar from './components/AdminCalendar';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics'; 
import { 
    getAuth, 
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword, 
    sendPasswordResetEmail, 
    onAuthStateChanged,
    signInWithCustomToken,
    signOut 
} from 'firebase/auth';
import { 
    getFirestore, 
    doc, 
    setDoc, 
    getDoc, 
    collection, 
    query, 
    onSnapshot, 
    addDoc,
    deleteDoc, 
    getDocs, 
    where, 
    orderBy, // <<< Důležité: Přidán orderBy
    updateDoc // <<< Důležité: Přidán updateDoc
} from 'firebase/firestore'; 
import { 
    getStorage, 
    ref, 
    uploadBytesResumable, 
    getDownloadURL 
} from 'firebase/storage';

import devcoreLogo from './devcore_logo_transparentv5.png'; // Import your logo image
import ClientSupport from './components/ClientSupport'; // Adjust path if needed
import AdminSupport from './components/AdminSupport'; // Adjust path if needed
import AdminNotes from './components/AdminNotes';
import AdminInfo from './components/AdminInfo'; // Import AdminInfo component
import Overview from './components/Overview';
import ServerLogs from './components/ServerLogs';
import ServerSettings from './components/ServerSettings';
import ServerEconomy from './components/ServerEconomy';
import CustomOrders from './components/CustomOrders'; // Updated import to use named export
import CustomOrdersAdmin from './components/CustomOrdersAdmin'; // Import the new admin component
import CustomOrderChatModal from './components/CustomOrderChatModal'; // Import chat modal for full-screen rendering
import EventModal from './components/EventModal'; // Import EventModal for full-screen rendering
import NotesModal from './components/NotesModal'; // Import NotesModal for full-screen rendering
import MyScripts from './components/MyScripts'; // Import MyScripts component
import AdminTodoList from './components/AdminTodoList'; // Import AdminTodoList component
import TodoPage from './components/TodoPage'; // Import the epic TodoPage component

// IMPORTANT: You will need to create a file named 'firebaseConfig.js'
// in the same directory as this App.js file (or adjust the path accordingly).
// This file should export your Firebase configuration object.
// Example firebaseConfig.js content:
// const firebaseConfig = {
//   apiKey: "YOUR_API_KEY",
//   authDomain: "YOUR_AUTH_DOMAIN",
//   projectId: "YOUR_PROJECT_ID",
//   storageBucket: "YOUR_STORAGE_BUCKET",
//   messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
//   appId: "YOUR_APP_ID"
// };
// export default firebaseConfig;
import firebaseConfig from './firebaseConfig'; // Import your Firebase configuration

// Define custom styles globally to avoid re-creation on every render
const customGlobalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    
    body {
        font-family: 'Poppins', sans-serif;
        background-color: #111111;
        color: white;
        /* Ensure body takes full height and width, and hides overflow */
        min-height: 100vh;
        width: 100vw;
        overflow-x: hidden;
        overflow-y: auto; /* Allow vertical scrolling if content exceeds viewport */
    }
    
    .glass-card {
        background: rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
    }
    
    .gradient-text {
        background: linear-gradient(90deg, #316dae, #4d9eff);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }
    
    .gradient-bg {
        background: linear-gradient(135deg, rgba(49, 109, 174, 0.2), rgba(77, 158, 255, 0.1));
    }
    
    /* Tailwind animations from original config */
    @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-20px); }
    }
    @keyframes float-reverse {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(20px); }
    }
    @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: .5; }
    }
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
    }
    @keyframes slideInLeft {
        from { opacity: 0; transform: translateX(-30px); }
        to { opacity: 1; transform: translateX(0); }
    }
    @keyframes slideInRight {
        from { opacity: 0; transform: translateX(30px); }
        to { opacity: 1; transform: translateX(0); }
    }
    @keyframes bounceIn {
        0% { opacity: 0; transform: scale(0.3) translateY(20px); }
        50% { opacity: 1; transform: scale(1.05); }
        70% { transform: scale(0.9); }
        100% { opacity: 1; transform: scale(1); }
    }
    @keyframes glow {
        0%, 100% { box-shadow: 0 0 5px rgba(79, 172, 254, 0.2), 0 0 10px rgba(79, 172, 254, 0.1); }
        50% { box-shadow: 0 0 20px rgba(79, 172, 254, 0.4), 0 0 30px rgba(79, 172, 254, 0.2); }
    }
    @keyframes shimmer {
        0% { transform: translateX(-100%) rotate(45deg); }
        100% { transform: translateX(200%) rotate(45deg); }
    }
    @keyframes heartbeat {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.03); }
    }
    @keyframes width-expand {
        from { width: 0; }
        to { width: 100%; }
    }
    
    .animate-float { animation: float 6s ease-in-out infinite; }
    .animate-float-reverse { animation: float-reverse 5s ease-in-out infinite; }
    .animate-pulse-slow { animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
    .animate-fadeIn { animation: fadeIn 0.5s ease-out forwards; }
    .animate-slideInLeft { animation: slideInLeft 0.6s ease-out forwards; }
    .animate-slideInRight { animation: slideInRight 0.6s ease-out forwards; }
    .animate-bounceIn { animation: bounceIn 0.8s ease-out forwards; }
    .animate-glow { animation: glow 2s ease-in-out infinite; }
    .animate-shimmer { animation: shimmer 2s infinite; }
    .animate-heartbeat { animation: heartbeat 2s ease-in-out infinite; }
    
    /* Enhanced hover effects */
    .hover-lift {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .hover-lift:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    }
    
    /* Glowing border effect */
    .glow-border {
        position: relative;
        overflow: hidden;
    }
    .glow-border::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, transparent, rgba(79, 172, 254, 0.5), transparent);
        border-radius: inherit;
        opacity: 0;
        transition: opacity 0.3s;
        z-index: -1;
    }
    .glow-border:hover::before {
        opacity: 1;
    }
    
    /* Smooth transitions for all interactive elements */
    * {
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
    }
`;

// Custom Modal Component (replacement for alert())
const CustomModal = ({ message, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="glass-card p-6 rounded-xl shadow-lg max-w-sm w-full text-center">
                <p className="text-white text-lg mb-6">{message}</p>
                <button
                    onClick={onClose}
                    className="bg-[#316dae] hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300"
                >
                    OK
                </button>
            </div>
        </div>
    );
};

// Discord Integration Component
// ...existing code...

// Discord Integration Component
const DiscordSettings = ({ user, db, userDiscordData, setUserDiscordData, setModalMessage }) => {
    const [isConnecting, setIsConnecting] = useState(false);
    const [isDisconnecting, setIsDisconnecting] = useState(false);
    const [notificationSettings, setNotificationSettings] = useState({
        serverAlerts: true,
        maintenanceNotices: true,
        securityAlerts: true,
        customOrders: false,
        directMessages: true
    });

    // Discord OAuth configuration - Updated to use implicit flow
    const DISCORD_CLIENT_ID = '1407118898498895976';
    const DISCORD_REDIRECT_URI = encodeURIComponent(`${window.location.origin}/panel`);
    // Changed: Use token response_type instead of code (implicit flow)
    const DISCORD_OAUTH_URL = `https://discord.com/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&response_type=token&redirect_uri=${DISCORD_REDIRECT_URI}&scope=identify`;

    // Update the Discord callback handler to handle tokens instead of codes
    useEffect(() => {
        // Check for Discord OAuth callback with access token (implicit flow)
        const urlFragment = window.location.hash.substring(1);
        const urlParams = new URLSearchParams(urlFragment);
        const accessToken = urlParams.get('access_token');
        
        if (accessToken && user && !userDiscordData) {
            console.log('Discord access token found, fetching user data...');
            handleDiscordCallback(accessToken);
            
            // Clean up URL
            window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        }
    }, [user, userDiscordData]);

    // Fetch user's Discord data from Firestore
    useEffect(() => {
        const fetchDiscordData = async () => {
            if (!user || !db) return;

            try {
                const userDocRef = doc(db, `users/${user.uid}`);
                const userDocSnap = await getDoc(userDocRef);
                
                if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    if (userData.discordData) {
                        setUserDiscordData(userData.discordData);
                        // Load notification preferences
                        if (userData.discordNotifications) {
                            setNotificationSettings(userData.discordNotifications);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching Discord data:", error);
            }
        };

        fetchDiscordData();
    }, [user, db, setUserDiscordData]);

    const handleConnectDiscord = () => {
        setIsConnecting(true);
        // Redirect to Discord OAuth
        window.location.href = DISCORD_OAUTH_URL;
    };

// ...existing code...

// ...existing code...

// Add the claimDiscordRole function inside the main App component
const claimDiscordRole = async (scriptId, scriptName) => {
    if (!userDiscordData || !userDiscordData.id) {
        setModalMessage('❌ Please connect your Discord account first to claim roles.');
        return;
    }

    setModalMessage('🔄 Claiming Discord role...');
    
    try {
        // Connect to your VPS bot API
        const response = await fetch('http://185.91.116.105:3004/api/discord/assign-role', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                discordId: userDiscordData.id,
                scriptId: scriptId,
                scriptName: scriptName
            }),
        });

        const data = await response.json();

        if (data.success) {
            setModalMessage(`🎉 ${data.message}`);
        } else {
            setModalMessage(`❌ Failed to claim role: ${data.error}`);
        }
    } catch (error) {
        console.error('Error claiming Discord role:', error);
        setModalMessage('❌ Failed to connect to Discord bot. Please try again later.');
    }
};

// Add bot status checking function
const [botStatus, setBotStatus] = useState({ online: false, loading: true });

const checkBotStatus = async () => {
    try {
        const response = await fetch('http://185.91.116.105:3004/api/discord/status');
        const data = await response.json();
        setBotStatus({ 
            online: data.success && data.botOnline, 
            loading: false,
            botTag: data.botTag,
            memberCount: data.memberCount
        });
    } catch (error) {
        setBotStatus({ online: false, loading: false });
    }
};

// Check bot status on component mount and periodically
useEffect(() => {
    checkBotStatus();
    const interval = setInterval(checkBotStatus, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
}, []);

// Update the MyScripts component with role claiming functionality
// ...existing code...

// Update the MyScripts component to accept props

// Updated Discord callback handler to handle undefined values
const handleDiscordCallback = async (accessToken) => {
    if (!user || !db) {
        console.error('User not authenticated or database not available');
        return;
    }

    console.log('Starting Discord OAuth callback processing with access token');
    setIsConnecting(true);
    
    try {
        console.log('Fetching Discord user data with access token...');
        
        // Make direct API call to Discord with the access token
        const response = await fetch('https://discord.com/api/v10/users/@me', {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Discord API request failed: ${response.status}`);
        }

        const discordUser = await response.json();
        console.log('Discord user data received:', discordUser);

        // Helper function to filter out undefined values
        const filterUndefined = (obj) => {
            const filtered = {};
            Object.keys(obj).forEach(key => {
                if (obj[key] !== undefined && obj[key] !== null) {
                    filtered[key] = obj[key];
                }
            });
            return filtered;
        };

        // Create Discord data object with real data, filtering undefined values
        const discordDataRaw = {
            id: discordUser.id,
            username: discordUser.username,
            discriminator: discordUser.discriminator || '0',
            globalName: discordUser.global_name || discordUser.username,
            avatar: discordUser.avatar,
            avatarUrl: discordUser.avatar 
                ? `https://cdn.discordapp.com/avatars/${discordUser.id}/${discordUser.avatar}.${discordUser.avatar.startsWith('a_') ? 'gif' : 'png'}?size=128`
                : `https://cdn.discordapp.com/embed/avatars/${parseInt(discordUser.discriminator || '0') % 5}.png`,
            email: discordUser.email, // This might be undefined
            verified: discordUser.verified || false,
            mfaEnabled: discordUser.mfa_enabled || false,
            banner: discordUser.banner,
            accentColor: discordUser.accent_color,
            locale: discordUser.locale,
            flags: discordUser.flags,
            publicFlags: discordUser.public_flags,
            premiumType: discordUser.premium_type || 0,
            connectedAt: new Date().toISOString(),
            accessToken: accessToken
        };

        // Filter out undefined values before saving to Firestore
        const discordData = filterUndefined(discordDataRaw);

        console.log('Saving Discord data to Firestore...', discordData);
        
        // Save to Firestore
        const userDocRef = doc(db, 'users', user.uid);
        await updateDoc(userDocRef, {
            discordData: discordData
        });

        // Update local state
        setUserDiscordData(discordData);
        setModalMessage(`Discord account connected successfully! Welcome, ${discordData.globalName || discordData.username}!`);
        
        console.log('Discord integration completed successfully');

    } catch (error) {
        console.error('Error connecting Discord account:', error);
        setModalMessage(`Failed to connect Discord account: ${error.message}`);
    } finally {
        setIsConnecting(false);
    }
};

// ...existing code...

    const handleDisconnectDiscord = async () => {
        if (!user || !db) return;

        setIsDisconnecting(true);
        
        try {
            // Remove Discord data from Firestore
            const userDocRef = doc(db, `users/${user.uid}`);
            await updateDoc(userDocRef, {
                discordData: null,
                discordNotifications: null
            });

            setUserDiscordData(null);
            setNotificationSettings({
                serverAlerts: true,
                maintenanceNotices: true,
                securityAlerts: true,
                customOrders: false,
                directMessages: true
            });
            setModalMessage('Discord account disconnected successfully!');
            
        } catch (error) {
            console.error('Error disconnecting Discord account:', error);
            setModalMessage('Failed to disconnect Discord account. Please try again.');
        } finally {
            setIsDisconnecting(false);
        }
    };

    const handleNotificationSettingChange = async (setting, value) => {
        const newSettings = { ...notificationSettings, [setting]: value };
        setNotificationSettings(newSettings);

        if (userDiscordData && user && db) {
            try {
                const userDocRef = doc(db, `users/${user.uid}`);
                await updateDoc(userDocRef, {
                    discordNotifications: newSettings
                });
            } catch (error) {
                console.error('Error saving notification preferences:', error);
                setModalMessage('Failed to save notification preferences.');
            }
        }
    };

    return (
        <div className="space-y-8 animate-fadeIn">
            {/* Hot Header with Floating Elements */}
            <div className="relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-[#5865F2]/10 via-transparent to-[#5865F2]/10 animate-pulse-slow rounded-2xl"></div>
                <div className="relative flex items-center justify-between p-6 glass-card border border-[#5865F2]/30 rounded-2xl">
                    <div className="flex items-center space-x-4">
                        <div className="relative">
                            <div className="w-16 h-16 bg-gradient-to-br from-[#5865F2] to-[#4752C4] rounded-2xl flex items-center justify-center shadow-xl animate-float">
                                <i className="fab fa-discord text-white text-2xl"></i>
                            </div>
                            <div className="absolute -top-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center animate-pulse">
                                <i className="fas fa-bolt text-white text-xs"></i>
                            </div>
                        </div>
                        <div>
                            <h4 className="text-2xl font-bold gradient-text animate-slideInLeft">Discord Integration</h4>
                            <p className="text-gray-400 animate-slideInLeft" style={{ animationDelay: '0.1s' }}>
                                Connect your Discord for enhanced features
                            </p>
                        </div>
                    </div>
                    {/* <div className="hidden md:flex items-center space-x-2 animate-slideInRight">
                        <div className="px-3 py-1 bg-[#5865F2]/20 rounded-full text-[#5865F2] text-sm font-semibold">
                            Premium Feature
                        </div>
                    </div> */}
                </div>
            </div>
            
            {userDiscordData ? (
                // Connected state - Ultra hot design
                <div className="space-y-8">
                    {/* Connected Status Card with Premium Animation */}
                    <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 via-emerald-500/20 to-green-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500 animate-pulse-slow"></div>
                        <div className="relative glass-card border border-green-500/40 rounded-2xl p-8 hover:border-green-400/60 transition-all duration-500 hover-lift">
                            {/* Floating particles effect */}
                            <div className="absolute top-4 right-4 w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
                            <div className="absolute top-8 right-8 w-2 h-2 bg-green-300 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                            
                            <div className="flex items-start justify-between mb-6">
                                <div className="flex items-center space-x-6">
                                    <div className="relative">
                                        {userDiscordData.avatarUrl ? (
                                            <div className="relative group">
                                                <img 
                                                    src={userDiscordData.avatarUrl}
                                                    alt="Discord Avatar"
                                                    className="w-20 h-20 rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-300"
                                                    onError={(e) => {
                                                        e.target.src = `https://cdn.discordapp.com/embed/avatars/${parseInt(userDiscordData.discriminator || '0') % 5}.png`;
                                                    }}
                                                />
                                                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-transparent to-white/20 rounded-2xl"></div>
                                                <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shadow-lg animate-heartbeat">
                                                    <i className="fas fa-check text-white text-sm"></i>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="w-20 h-20 bg-gradient-to-br from-[#5865F2] to-[#4752C4] rounded-2xl flex items-center justify-center shadow-2xl">
                                                <i className="fab fa-discord text-white text-3xl"></i>
                                                <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shadow-lg animate-heartbeat">
                                                    <i className="fas fa-check text-white text-sm"></i>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="space-y-2">
                                        <div className="flex items-center space-x-3">
                                            <h5 className="text-2xl font-bold text-white animate-slideInLeft">
                                                {userDiscordData.globalName ? userDiscordData.globalName : userDiscordData.username}
                                            </h5>
                                            <div className="flex items-center space-x-2">
                                                {userDiscordData.verified && (
                                                    <div className="bg-blue-500/20 border border-blue-500/40 rounded-full px-3 py-1 flex items-center space-x-1 animate-bounceIn">
                                                        <i className="fas fa-check-circle text-blue-400 text-sm"></i>
                                                        <span className="text-blue-300 text-xs font-semibold">Verified</span>
                                                    </div>
                                                )}
                                                {userDiscordData.premiumType && userDiscordData.premiumType > 0 && (
                                                    <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/40 rounded-full px-3 py-1 flex items-center space-x-1 animate-bounceIn" style={{ animationDelay: '0.1s' }}>
                                                        <i className="fas fa-crown text-purple-400 text-sm"></i>
                                                        <span className="text-purple-300 text-xs font-semibold">Nitro</span>
                                                    </div>
                                                )}
                                                {userDiscordData.mfaEnabled && (
                                                    <div className="bg-green-500/20 border border-green-500/40 rounded-full px-3 py-1 flex items-center space-x-1 animate-bounceIn" style={{ animationDelay: '0.2s' }}>
                                                        <i className="fas fa-shield-alt text-green-400 text-sm"></i>
                                                        <span className="text-green-300 text-xs font-semibold">2FA</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex items-center space-x-2 text-gray-400">
                                            <i className="fas fa-at text-[#5865F2]"></i>
                                            <span className="font-mono text-sm">
                                                {userDiscordData.globalName ? `@${userDiscordData.username}` : 
                                                 `${userDiscordData.username}${userDiscordData.discriminator !== '0' ? `#${userDiscordData.discriminator}` : ''}`}
                                            </span>
                                        </div>
                                        <div className="flex items-center space-x-2 text-gray-400">
                                            <i className="fas fa-calendar text-green-400"></i>
                                            <span className="text-sm">Connected {new Date(userDiscordData.connectedAt).toLocaleDateString('en-US', { 
                                                year: 'numeric', 
                                                month: 'long', 
                                                day: 'numeric' 
                                            })}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center space-x-3">
                                    <div className="flex items-center space-x-2 bg-green-500/20 border border-green-500/40 rounded-full px-4 py-2 animate-glow">
                                        <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                                        <span className="text-green-300 font-semibold text-sm">Active</span>
                                    </div>
                                </div>
                            </div>

                            {/* Account Details Grid with Hot Design */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                                <div className="group relative overflow-hidden">
                                    <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    <div className="relative glass-card border border-white/10 group-hover:border-blue-400/40 rounded-xl p-6 transition-all duration-300 hover-lift">
                                        <div className="flex items-center space-x-3 mb-3">
                                            <div className="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl flex items-center justify-center">
                                                <i className="fas fa-id-card text-blue-400"></i>
                                            </div>
                                            <span className="text-gray-400 text-sm font-medium">Discord ID</span>
                                        </div>
                                        <div className="relative overflow-hidden">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                            <p className="relative text-white font-mono text-lg">{userDiscordData.id}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="group relative overflow-hidden">
                                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    <div className="relative glass-card border border-white/10 group-hover:border-green-400/40 rounded-xl p-6 transition-all duration-300 hover-lift">
                                        <div className="flex items-center space-x-3 mb-3">
                                            <div className="w-10 h-10 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-xl flex items-center justify-center">
                                                <i className="fas fa-envelope text-green-400"></i>
                                            </div>
                                            <span className="text-gray-400 text-sm font-medium">Email</span>
                                        </div>
                                        <div className="relative overflow-hidden">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                            <p className="relative text-white text-sm flex items-center">
                                                {userDiscordData.email ? (
                                                    <>
                                                        <span className="truncate">{userDiscordData.email}</span>
                                                        {userDiscordData.verified && (
                                                            <i className="fas fa-check-circle text-green-400 ml-2 flex-shrink-0" title="Verified"></i>
                                                        )}
                                                    </>
                                                ) : (
                                                    <span className="text-gray-500">Not provided</span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="group relative overflow-hidden">
                                    <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-red-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    <div className="relative glass-card border border-white/10 group-hover:border-orange-400/40 rounded-xl p-6 transition-all duration-300 hover-lift">
                                        <div className="flex items-center space-x-3 mb-3">
                                            <div className="w-10 h-10 bg-gradient-to-br from-orange-500/20 to-red-500/20 rounded-xl flex items-center justify-center">
                                                <i className="fas fa-chart-line text-orange-400"></i>
                                            </div>
                                            <span className="text-gray-400 text-sm font-medium">Account Status</span>
                                        </div>
                                        <div className="relative overflow-hidden">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                            <div className="relative flex items-center space-x-2">
                                                <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                                                <span className="text-white font-semibold">Active & Secure</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Success Message with Animation */}
                            <div className="relative overflow-hidden group">
                                <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 via-emerald-500/20 to-green-500/20 rounded-xl blur-lg group-hover:blur-2xl transition-all duration-500"></div>
                                <div className="relative glass-card border border-green-500/40 rounded-xl p-6 hover:border-green-400/60 transition-all duration-300">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 bg-gradient-to-br from-green-500/30 to-emerald-500/30 rounded-full flex items-center justify-center animate-heartbeat">
                                            <i className="fas fa-check-circle text-green-400 text-xl"></i>
                                        </div>
                                        <div className="flex-1">
                                            <h6 className="text-green-300 font-bold text-lg mb-1">Discord Account Connected!</h6>
                                            <p className="text-green-200/80 text-sm">
                                                Your Discord account is securely linked to your DEVCORE panel. You now have access to exclusive features, 
                                                notifications, and community servers.
                                            </p>
                                        </div>
                                        <div className="hidden md:flex items-center space-x-2">
                                            <div className="w-2 h-2 bg-green-400 rounded-full animate-ping"></div>
                                            <div className="w-2 h-2 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
                                            <div className="w-2 h-2 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Disconnect Button with Hot Design */}
                            <div className="flex justify-end mt-8">
                                <button
                                    onClick={handleDisconnectDiscord}
                                    disabled={isDisconnecting}
                                    className="group relative overflow-hidden bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 disabled:from-gray-600 disabled:to-gray-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 disabled:opacity-50 shadow-lg hover:shadow-xl hover:-translate-y-1 disabled:hover:translate-y-0"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                    <div className="relative flex items-center space-x-3">
                                        {isDisconnecting ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin"></i>
                                                <span>Disconnecting...</span>
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-unlink group-hover:rotate-12 transition-transform duration-300"></i>
                                                <span>Disconnect Discord</span>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Notification Preferences with Ultra Hot Design */}
                    <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 via-blue-500/10 to-indigo-500/10 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500 animate-pulse-slow"></div>
                        <div className="relative glass-card border border-blue-500/30 rounded-2xl p-8 hover:border-blue-400/50 transition-all duration-500 hover-lift">
                            {/* Header with Floating Animation */}
                            <div className="flex items-center justify-between mb-8">
                                <div className="flex items-center space-x-4">
                                    <div className="relative">
                                        <div className="w-16 h-16 bg-gradient-to-br from-blue-500/20 via-purple-500/20 to-indigo-500/20 rounded-2xl flex items-center justify-center animate-float">
                                            <i className="fas fa-bell text-blue-400 text-2xl"></i>
                                        </div>
                                        <div className="absolute -top-1 -right-1 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center animate-pulse">
                                            <i className="fas fa-cog text-white text-xs animate-spin"></i>
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="text-2xl font-bold gradient-text animate-slideInLeft">Notification Center</h5>
                                        <p className="text-gray-400 animate-slideInLeft" style={{ animationDelay: '0.1s' }}>
                                            Customize your Discord notification experience
                                        </p>
                                    </div>
                                </div>
                                <div className="hidden md:block">
                                    <div className="bg-blue-500/20 border border-blue-500/40 rounded-full px-4 py-2 animate-bounceIn">
                                        <span className="text-blue-300 text-sm font-semibold">Smart Notifications</span>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Notification Options with Premium Toggles */}
                            <div className="space-y-6">
                                {[
                                    {
                                        key: 'serverAlerts',
                                        title: 'Server Alerts',
                                        description: 'Real-time notifications for server status changes, crashes, and connectivity issues',
                                        icon: 'fas fa-server',
                                        color: 'from-red-500/20 to-orange-500/20',
                                        iconColor: 'text-red-400',
                                        delay: '0s'
                                    },
                                    {
                                        key: 'maintenanceNotices',
                                        title: 'Maintenance Notices',
                                        description: 'Scheduled maintenance alerts and system update notifications',
                                        icon: 'fas fa-tools',
                                        color: 'from-yellow-500/20 to-orange-500/20',
                                        iconColor: 'text-yellow-400',
                                        delay: '0.1s'
                                    },
                                    {
                                        key: 'securityAlerts',
                                        title: 'Security Alerts',
                                        description: 'Critical security notifications including login attempts and account changes',
                                        icon: 'fas fa-shield-alt',
                                        color: 'from-green-500/20 to-emerald-500/20',
                                        iconColor: 'text-green-400',
                                        delay: '0.2s'
                                    },
                                    {
                                        key: 'customOrders',
                                        title: 'Custom Order Updates',
                                        description: 'Status updates and progress notifications for your custom script orders',
                                        icon: 'fas fa-shopping-cart',
                                        color: 'from-purple-500/20 to-pink-500/20',
                                        iconColor: 'text-purple-400',
                                        delay: '0.3s'
                                    },
                                    {
                                        key: 'directMessages',
                                        title: 'Direct Messages',
                                        description: 'Allow DEVCORE bot to send you direct messages and personalized updates',
                                        icon: 'fas fa-comment-dots',
                                        color: 'from-blue-500/20 to-indigo-500/20',
                                        iconColor: 'text-blue-400',
                                        delay: '0.4s'
                                    }
                                ].map((setting) => (
                                    <div key={setting.key} className="group/item relative overflow-hidden animate-slideInLeft" style={{ animationDelay: setting.delay }}>
                                        <div className={`absolute inset-0 bg-gradient-to-r ${setting.color} rounded-xl opacity-0 group-hover/item:opacity-100 transition-opacity duration-300`}></div>
                                        <div className="relative glass-card border border-white/10 group-hover/item:border-blue-400/30 rounded-xl p-6 transition-all duration-300">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-start space-x-4 flex-1">
                                                    <div className={`w-12 h-12 bg-gradient-to-br ${setting.color} rounded-xl flex items-center justify-center group-hover/item:scale-110 transition-transform duration-300`}>
                                                        <i className={`${setting.icon} ${setting.iconColor} text-lg`}></i>
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <div className="flex items-center space-x-3 mb-2">
                                                            <h6 className="text-white font-bold text-lg">{setting.title}</h6>
                                                            {notificationSettings[setting.key] && (
                                                                <div className="bg-green-500/20 border border-green-500/40 rounded-full px-2 py-1 animate-pulse">
                                                                    <span className="text-green-300 text-xs font-semibold">Active</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <p className="text-gray-400 text-sm leading-relaxed">{setting.description}</p>
                                                    </div>
                                                </div>
                                                <div className="ml-6">
                                                    <label className="relative inline-flex items-center cursor-pointer group/toggle">
                                                        <input
                                                            type="checkbox"
                                                            checked={notificationSettings[setting.key]}
                                                            onChange={(e) => handleNotificationSettingChange(setting.key, e.target.checked)}
                                                            className="sr-only peer"
                                                        />
                                                        <div className="relative">
                                                            <div className="w-14 h-8 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300/50 rounded-full peer peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-blue-600 peer-checked:to-purple-600 group-hover/toggle:scale-105 transition-transform duration-200 shadow-lg"></div>
                                                            {notificationSettings[setting.key] && (
                                                                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400/30 to-purple-400/30 animate-pulse"></div>
                                                            )}
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                            {/* Hover effect shimmer */}
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover/item:translate-x-[100%] transition-transform duration-1000"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Info Card with Premium Design */}
                            <div className="mt-8 relative overflow-hidden group/info animate-bounceIn" style={{ animationDelay: '0.5s' }}>
                                <div className="absolute inset-0 bg-gradient-to-r from-amber-500/10 via-yellow-500/10 to-orange-500/10 rounded-xl opacity-0 group-hover/info:opacity-100 transition-opacity duration-300"></div>
                                <div className="relative glass-card border border-amber-500/30 rounded-xl p-6 hover:border-amber-400/50 transition-all duration-300">
                                    <div className="flex items-start space-x-4">
                                        <div className="w-12 h-12 bg-gradient-to-br from-amber-500/20 to-orange-500/20 rounded-xl flex items-center justify-center animate-pulse">
                                            <i className="fas fa-lightbulb text-amber-400 text-xl"></i>
                                        </div>
                                        <div className="flex-1">
                                            <div className="flex items-center space-x-2 mb-2">
                                                <h6 className="text-amber-300 font-bold text-lg">Pro Tip</h6>
                                                <div className="w-2 h-2 bg-amber-400 rounded-full animate-ping"></div>
                                            </div>
                                            <p className="text-amber-200/90 text-sm leading-relaxed">
                                                Changes are automatically saved in real-time. Make sure to enable DMs from server members 
                                                in your Discord privacy settings to receive notifications. You can customize notification 
                                                frequency in your Discord server settings.
                                            </p>
                                        </div>
                                        <div className="hidden md:flex items-center space-x-1">
                                            <div className="w-3 h-3 bg-amber-400 rounded-full animate-bounce"></div>
                                            <div className="w-3 h-3 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                                            <div className="w-3 h-3 bg-amber-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                                        </div>
                                    </div>
                                    {/* Shine effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-amber-400/10 to-transparent translate-x-[-100%] group-hover/info:translate-x-[100%] transition-transform duration-700"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                // Not connected state - Ultra Hot Onboarding Experience
                <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-r from-[#5865F2]/10 via-purple-500/10 to-indigo-500/10 rounded-2xl blur-2xl group-hover:blur-3xl transition-all duration-500 animate-pulse-slow"></div>
                    <div className="relative glass-card border border-[#5865F2]/30 rounded-2xl p-12 text-center hover:border-[#5865F2]/50 transition-all duration-500 hover-lift overflow-hidden">
                        {/* Background Animation Elements */}
                        <div className="absolute top-6 left-6 w-4 h-4 bg-[#5865F2] rounded-full animate-ping opacity-20"></div>
                        <div className="absolute top-12 right-12 w-3 h-3 bg-purple-500 rounded-full animate-pulse opacity-30"></div>
                        <div className="absolute bottom-12 left-12 w-2 h-2 bg-blue-400 rounded-full animate-bounce opacity-40"></div>
                        <div className="absolute bottom-6 right-6 w-5 h-5 bg-indigo-500 rounded-full animate-pulse opacity-20" style={{ animationDelay: '1s' }}></div>
                        
                        {/* Hero Discord Icon with Multiple Animations */}
                        <div className="relative mb-8 animate-bounceIn">
                            <div className="absolute inset-0 bg-[#5865F2] rounded-3xl blur-2xl opacity-30 animate-pulse"></div>
                            <div className="relative w-24 h-24 bg-gradient-to-br from-[#5865F2] to-[#4752C4] rounded-3xl flex items-center justify-center mx-auto shadow-2xl animate-float hover:scale-105 transition-transform duration-300">
                                <i className="fab fa-discord text-white text-4xl animate-pulse"></i>
                                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center animate-bounce">
                                    <i className="fas fa-plus text-white text-sm"></i>
                                </div>
                            </div>
                            {/* Orbiting elements */}
                            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-4">
                                <div className="w-3 h-3 bg-blue-400 rounded-full animate-ping"></div>
                            </div>
                            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-4">
                                <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse"></div>
                            </div>
                        </div>
                        
                        {/* Dynamic Title with Gradient Animation */}
                        <div className="mb-6 space-y-3">
                            <h5 className="text-3xl font-bold bg-gradient-to-r from-white via-blue-100 to-purple-100 bg-clip-text text-transparent animate-slideInLeft">
                                Connect Your Discord Account
                            </h5>
                            <div className="w-24 h-1 bg-gradient-to-r from-[#5865F2] to-purple-500 rounded-full mx-auto animate-width-expand"></div>
                        </div>
                        
                        <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto leading-relaxed animate-slideInRight">
                            Transform your DEVCORE experience with Discord integration. Get instant notifications, 
                            exclusive access, and seamless server management - all through Discord.
                        </p>
                        
                        {/* Premium Benefits Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
                            {[
                                {
                                    icon: 'fas fa-bell',
                                    title: 'Smart Notifications',
                                    description: 'Real-time alerts directly in Discord with customizable preferences',
                                    color: 'from-blue-500/20 to-indigo-500/20',
                                    iconColor: 'text-blue-400',
                                    delay: '0s'
                                },
                                {
                                    icon: 'fas fa-shield-alt',
                                    title: 'Enhanced Security',
                                    description: 'Two-factor authentication and advanced account protection',
                                    color: 'from-green-500/20 to-emerald-500/20',
                                    iconColor: 'text-green-400',
                                    delay: '0.1s'
                                },
                                {
                                    icon: 'fas fa-users',
                                    title: 'Exclusive Communities',
                                    description: 'Access to private Discord servers and premium support channels',
                                    color: 'from-purple-500/20 to-pink-500/20',
                                    iconColor: 'text-purple-400',
                                    delay: '0.2s'
                                },
                                {
                                    icon: 'fas fa-robot',
                                    title: 'Bot Commands',
                                    description: 'Manage your servers with powerful Discord bot integration',
                                    color: 'from-orange-500/20 to-red-500/20',
                                    iconColor: 'text-orange-400',
                                    delay: '0.3s'
                                }
                            ].map((benefit, index) => (
                                <div key={index} className="group/benefit relative animate-slideInLeft" style={{ animationDelay: benefit.delay }}>
                                    <div className={`absolute inset-0 bg-gradient-to-r ${benefit.color} rounded-xl opacity-0 group-hover/benefit:opacity-100 transition-opacity duration-300`}></div>
                                    <div className="relative glass-card border border-white/10 group-hover/benefit:border-blue-400/40 rounded-xl p-6 transition-all duration-300 hover-lift">
                                        <div className="flex items-start space-x-4">
                                            <div className={`w-12 h-12 bg-gradient-to-br ${benefit.color} rounded-xl flex items-center justify-center group-hover/benefit:scale-110 transition-transform duration-300`}>
                                                <i className={`${benefit.icon} ${benefit.iconColor} text-xl`}></i>
                                            </div>
                                            <div className="text-left flex-1">
                                                <h6 className="text-white font-bold text-lg mb-2">{benefit.title}</h6>
                                                <p className="text-gray-400 text-sm leading-relaxed">{benefit.description}</p>
                                            </div>
                                        </div>
                                        {/* Shimmer effect */}
                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover/benefit:translate-x-[100%] transition-transform duration-1000"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        {/* Premium Connect Button with Multiple Effects */}
                        <div className="relative animate-bounceIn" style={{ animationDelay: '0.4s' }}>
                            <div className="absolute inset-0 bg-gradient-to-r from-[#5865F2] to-purple-600 rounded-2xl blur-xl opacity-50 animate-pulse"></div>
                            <button
                                onClick={handleConnectDiscord}
                                disabled={isConnecting}
                                className="relative group/button overflow-hidden bg-gradient-to-r from-[#5865F2] via-[#4752C4] to-purple-600 hover:from-[#4752C4] hover:via-purple-600 hover:to-[#5865F2] disabled:from-gray-600 disabled:to-gray-700 text-white font-bold py-6 px-12 rounded-2xl transition-all duration-500 disabled:opacity-50 shadow-2xl hover:shadow-[#5865F2]/50 hover:shadow-3xl hover:scale-105 disabled:hover:scale-100 text-lg"
                            >
                                {/* Button shine effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover/button:translate-x-[100%] transition-transform duration-700"></div>
                                
                                <div className="relative flex items-center space-x-4">
                                    {isConnecting ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin text-2xl"></i>
                                            <span>Connecting to Discord...</span>
                                            <div className="flex space-x-1">
                                                <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                                                <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                                                <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <i className="fab fa-discord text-2xl group-hover/button:rotate-12 transition-transform duration-300"></i>
                                            <span className="group-hover/button:scale-105 transition-transform duration-300">Connect with Discord</span>
                                            <i className="fas fa-arrow-right text-xl group-hover/button:translate-x-2 transition-transform duration-300"></i>
                                        </>
                                    )}
                                </div>
                            </button>
                        </div>
                        
                        {/* Privacy Notice with Premium Styling */}
                        <div className="mt-8 relative animate-fadeIn" style={{ animationDelay: '0.6s' }}>
                            <div className="glass-card border border-white/10 rounded-xl p-4 max-w-lg mx-auto">
                                <div className="flex items-center justify-center space-x-2 mb-2">
                                    <div className="w-6 h-6 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-full flex items-center justify-center">
                                        <i className="fas fa-shield-alt text-green-400 text-xs"></i>
                                    </div>
                                    <span className="text-green-300 text-sm font-semibold">Secure & Private</span>
                                </div>
                                <p className="text-gray-400 text-xs leading-relaxed">
                                    We only access your Discord username, ID, and avatar. Your privacy is our priority. 
                                    You can disconnect at any time from your settings.
                                </p>
                            </div>
                        </div>
                        
                        {/* Floating Elements for Visual Appeal */}
                        <div className="absolute top-1/4 left-8 w-20 h-20 bg-[#5865F2]/5 rounded-full animate-float opacity-30"></div>
                        <div className="absolute bottom-1/4 right-8 w-16 h-16 bg-purple-500/5 rounded-full animate-float-reverse opacity-40"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

// Logo component to reuse
const DevcoreLogo = () => (
    <div className="flex items-center justify-center mb-6">
        <img src={devcoreLogo} alt="Devcore Logo" className="w-128 h-30 ml-4" />
    </div>
);

// Login Component
const Login = ({ onLogin, onSwitchToRegister, onSwitchToForgotPassword, onNavigateHome, loading }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear previous errors

        if (!email || !password) {
            setError('Please enter both email and password.');
            return;
        }
        
        onLogin(email, password, setError); // Pass email, password, and setError to parent handler
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#111111] p-4 relative overflow-hidden">
            {/* Background blur circles for design aesthetic */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg w-full max-w-md relative z-10 animate-fadeIn">
                <DevcoreLogo /> {/* Added Logo */}
                <h2 className="text-3xl font-bold text-center gradient-text mb-6">Login</h2>
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="your@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="********"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            type="submit"
                            className="bg-[#316dae] hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:shadow-outline transition duration-300"
                            disabled={loading}
                        >
                            {loading ? 'Signing In...' : 'Sign In'}
                        </button>
                        <button
                            type="button"
                            onClick={onSwitchToRegister}
                            className="inline-block align-baseline font-bold text-sm text-[#316dae] hover:text-blue-400 transition duration-300"
                            disabled={loading}
                        >
                            Don't have an account? Register
                        </button>
                    </div>
                    <div className="text-center mt-4">
                        <button
                            type="button"
                            onClick={onSwitchToForgotPassword}
                            className="inline-block align-baseline font-bold text-sm text-gray-400 hover:text-white transition duration-300"
                            disabled={loading}
                        >
                            Forgot Password?
                        </button>
                    </div>
                </form>
                <div className="text-center mt-6">
                    <button
                        type="button"
                        onClick={() => onNavigateHome()} // Use onNavigateHome directly
                        className="inline-block align-baseline font-bold text-sm text-gray-400 hover:text-white transition duration-300"
                        disabled={loading}
                    >
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

// Register Component
const Register = ({ onRegister, onSwitchToLogin, onNavigateHome, loading }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false); // New state for terms
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear previous errors

        if (!username || !email || !password || !confirmPassword) {
            setError('All fields are required.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        if (!termsAccepted) { // Check if terms are accepted
            setError('You must accept the terms and conditions.');
            return;
        }

        onRegister(username, email, password, setError); // Pass username, email, password, and setError to parent handler
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#111111] p-4 relative overflow-hidden">
            {/* Background blur circles for design aesthetic */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg w-full max-w-md relative z-10 animate-fadeIn">
                <DevcoreLogo /> {/* Added Logo */}
                <h2 className="text-3xl font-bold text-center gradient-text mb-6">Register</h2>
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="username">
                            Username
                        </label>
                        <input
                            type="text"
                            id="username"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="Your Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="your@example.2com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="password">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="********"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="confirm-password">
                            Confirm Password
                        </label>
                        <input
                            type="password"
                            id="confirm-password"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="********"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    {/* Consent with Terms Checkbox */}
                    <div className="mb-6 flex items-center">
                        <input
                            type="checkbox"
                            id="terms-consent"
                            className="form-checkbox h-5 w-5 text-[#316dae] rounded-md border-gray-700 bg-gray-800"
                            checked={termsAccepted}
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                            required
                        />
                        <label htmlFor="terms-consent" className="ml-2 text-gray-300 text-sm">
                            I agree to the <a href="#" className="text-[#316dae] hover:underline">terms and conditions</a>
                        </label>
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            type="submit"
                            className="bg-[#316dae] hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:shadow-outline transition duration-300"
                            disabled={loading || !termsAccepted} 
                        >
                            {loading ? 'Registering...' : 'Register'}
                        </button>
                        <button
                            type="button"
                            onClick={onSwitchToLogin}
                            className="inline-block align-baseline font-bold text-sm text-[#316dae] hover:text-blue-400 transition duration-300"
                            disabled={loading}
                        >
                            Already have an account? Login
                        </button>
                    </div>
                </form>
                <div className="text-center mt-6">
                    <button
                        type="button"
                        onClick={() => onNavigateHome()} // Use onNavigateHome directly
                        className="inline-block align-baseline font-bold text-sm text-gray-400 hover:text-white transition duration-300"
                        disabled={loading}
                    >
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

// ForgotPassword Component
const ForgotPassword = ({ onResetPassword, onSwitchToLogin, onNavigateHome, loading }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!email) {
            setError('Please enter your email address.');
            return;
        }

        onResetPassword(email, setMessage, setError); // Pass email, setMessage, and setError to parent handler
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#111111] p-4 relative overflow-hidden">
            {/* Background blur circles for design aesthetic */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg w-full max-w-md relative z-10 animate-fadeIn">
                <DevcoreLogo /> {/* Added Logo */}
                <h2 className="text-3xl font-bold text-center gradient-text mb-6">Forgot Password</h2>
                {message && <p className="text-green-500 text-center mb-4">{message}</p>}
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-300 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-800 border-gray-700 text-white"
                            placeholder="your@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            type="submit"
                            className="bg-[#316dae] hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:shadow-outline transition duration-300"
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Reset Password'}
                        </button>
                        <button
                            type="button"
                            onClick={onSwitchToLogin}
                            className="inline-block align-baseline font-bold text-sm text-[#316dae] hover:text-blue-400 transition duration-300"
                            disabled={loading}
                        >
                            Back to Login
                        </button>
                    </div>
                </form>
                <div className="text-center mt-6">
                    <button
                        type="button"
                        onClick={() => onNavigateHome()} // Use onNavigateHome directly
                        className="inline-block align-baseline font-bold text-sm text-gray-400 hover:text-white transition duration-300"
                        disabled={loading}
                    >
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

// New AddNewServerModal Component
const AddNewServerModal = ({ onClose, onAddServer, setModalMessage }) => {
    const [serverName, setServerName] = useState('');
    const [serverIp, setServerIp] = useState('');
    const [serverRegion, setServerRegion] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (!serverName.trim() || !serverIp.trim() || !serverRegion.trim()) {
            setError('All fields are required.');
            return;
        }
        onAddServer(serverName, serverIp, serverRegion);
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="glass-card p-8 rounded-2xl shadow-lg w-full max-w-lg animate-fadeIn border border-white/20">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center">
                        <i className="fas fa-server text-blue-400 text-2xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold gradient-text">Add New Server</h3>
                    <p className="text-gray-400 text-sm mt-2">Register a new FiveM server to your panel</p>
                </div>

                {error && (
                    <div className="mb-6 p-4 bg-red-900/20 border border-red-600/30 rounded-xl">
                        <div className="flex items-center space-x-2 text-red-400">
                            <i className="fas fa-exclamation-triangle"></i>
                            <span className="text-sm font-medium">{error}</span>
                        </div>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="serverName" className="block text-gray-300 text-sm font-bold mb-3">
                            Server Name *
                        </label>
                        <input
                            type="text"
                            id="serverName"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                            placeholder="e.g., My Awesome FiveM Server"
                            value={serverName}
                            onChange={(e) => setServerName(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="serverIp" className="block text-gray-300 text-sm font-bold mb-3">
                            Server IP *
                        </label>
                        <input
                            type="text"
                            id="serverIp"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                            placeholder="e.g., 192.168.1.100"
                            value={serverIp}
                            onChange={(e) => setServerIp(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="serverRegion" className="block text-gray-300 text-sm font-bold mb-3">
                            Region *
                        </label>
                        <select
                            id="serverRegion"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                            value={serverRegion}
                            onChange={(e) => setServerRegion(e.target.value)}
                            required
                        >
                            <option value="">Select a Region</option>
                            <option value="US-East">US-East</option>
                            <option value="US-West">US-West</option>
                            <option value="EU-Central">EU-Central</option>
                            <option value="Asia-Pacific">Asia-Pacific</option>
                            <option value="South-America">South America</option>
                        </select>
                    </div>
                    <div className="flex space-x-4 mt-8">
                        <button
                            type="button"
                            onClick={onClose}
                            className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                        >
                            <i className="fas fa-times"></i>
                            <span>Cancel</span>
                        </button>
                        <button
                            type="submit"
                            className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                        >
                            <i className="fas fa-plus"></i>
                            <span>Add Server</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// Script Updates Modal Component
const ScriptUpdatesModal = ({ script, onClose }) => {
    // Mock updates data - in a real app this would come from your backend
    const mockUpdates = [
        {
            id: 1,
            version: "v2.1.0",
            date: "2025-08-15",
            title: "Major Performance Update",
            description: "Improved script performance by 40%, fixed memory leaks, and added new configuration options.",
            type: "major",
            changes: [
                "Performance improvements",
                "Memory leak fixes",
                "New configuration options",
                "Bug fixes for compatibility issues"
            ]
        },
        {
            id: 2,
            version: "v2.0.5",
            date: "2025-08-01",
            title: "Bug Fixes & Stability",
            description: "Critical bug fixes and stability improvements for better server performance.",
            type: "patch",
            changes: [
                "Fixed crash issue on server restart",
                "Improved error handling",
                "Enhanced logging system",
                "Minor UI adjustments"
            ]
        },
        {
            id: 3,
            version: "v2.0.0",
            date: "2025-07-20",
            title: "New Features Release",
            description: "Major feature update with new functionality and improved user experience.",
            type: "major",
            changes: [
                "New user interface",
                "Advanced configuration panel",
                "Multi-language support",
                "Database optimization",
                "New API endpoints"
            ]
        }
    ];

    const getUpdateTypeColor = (type) => {
        switch (type) {
            case 'major':
                return 'bg-gradient-to-br from-red-500 to-red-600';
            case 'minor':
                return 'bg-gradient-to-br from-blue-500 to-blue-600';
            case 'patch':
                return 'bg-gradient-to-br from-green-500 to-green-600';
            default:
                return 'bg-gradient-to-br from-gray-500 to-gray-600';
        }
    };

    const getUpdateTypeIcon = (type) => {
        switch (type) {
            case 'major':
                return 'fas fa-rocket';
            case 'minor':
                return 'fas fa-plus-circle';
            case 'patch':
                return 'fas fa-wrench';
            default:
                return 'fas fa-info-circle';
        }
    };

    if (!script) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="glass-card p-8 rounded-2xl shadow-lg w-full max-w-3xl max-h-[85vh] overflow-hidden animate-fadeIn flex flex-col border border-white/20">
                <div className="text-center mb-6">
                    <div className="w-20 h-20 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-blue-500/30 to-purple-600/30 flex items-center justify-center">
                        <i className="fas fa-cube text-blue-400 text-3xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold gradient-text">{script.name} - Updates</h3>
                    <p className="text-gray-400 text-sm mt-2">
                        <i className="fas fa-calendar mr-2"></i>
                        Claimed on {script.claimedAt ? new Date(script.claimedAt).toLocaleDateString() : 'Unknown date'}
                    </p>
                </div>
                <div className="flex-1 overflow-y-auto custom-scrollbar pr-2">
                    <div className="space-y-6">
                        {mockUpdates.map((update, index) => (
                            <div key={update.id} className="bg-white/5 border border-white/10 rounded-xl p-6 hover:border-[#4d9eff] transition duration-200">
                                <div className="flex items-start justify-between mb-3">
                                    <div className="flex items-center space-x-3">
                                        <div className={`${getUpdateTypeColor(update.type)} p-3 rounded-full shadow-lg`}>
                                            <i className={`${getUpdateTypeIcon(update.type)} text-white text-base`}></i>
                                        </div>
                                        <div>
                                            <h4 className="text-lg font-semibold text-white">{update.title}</h4>
                                            <div className="flex items-center space-x-4 text-sm text-gray-400 mt-1">
                                                <span className="font-mono bg-gray-700 px-2 py-1 rounded">{update.version}</span>
                                                <span><i className="fas fa-calendar mr-1"></i>{update.date}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {index === 0 && (
                                        <span className="bg-green-600 text-white text-xs px-2 py-1 rounded-full font-semibold">
                                            Latest
                                        </span>
                                    )}
                                </div>
                                <p className="text-gray-300 mb-4">{update.description}</p>
                                <div>
                                    <h5 className="text-white font-semibold mb-2 flex items-center">
                                        <i className="fas fa-list mr-2"></i>
                                        What's Changed:
                                    </h5>
                                    <ul className="space-y-1">
                                        {update.changes.map((change, changeIndex) => (
                                            <li key={changeIndex} className="text-gray-300 text-sm flex items-start">
                                                <i className="fas fa-check text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                                                {change}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                    {mockUpdates.length === 0 && (
                        <div className="text-center py-12 text-gray-400">
                            <i className="fas fa-history text-4xl mb-4 opacity-50"></i>
                            <p className="text-lg font-semibold mb-2">No Updates Yet</p>
                            <p>Check back later for updates to this script.</p>
                        </div>
                    )}
                </div>
                <div className="mt-8 flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className="fas fa-times"></i>
                        <span>Close</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

// Claim Script Modal Component
const ClaimScriptModal = ({ onClose, onClaim, setModalMessage }) => {
    const [purchaseId, setPurchaseId] = useState('');
    const [error, setError] = useState('');

    const handleClaim = () => {
        setError('');
        if (!purchaseId.trim()) {
            setError('Purchase ID cannot be empty.');
            return;
        }
        if (!purchaseId.startsWith('tbx-')) {
            setError('Invalid purchase ID format. It should start with "tbx-"');
            return;
        }
        onClaim(purchaseId);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="glass-card p-8 rounded-2xl shadow-lg w-full max-w-md animate-fadeIn border border-white/20">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center">
                        <i className="fas fa-receipt text-blue-400 text-2xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold gradient-text mb-2">Claim Your Script</h3>
                    <p className="text-gray-400 text-sm">Enter your Tebex transaction ID from your purchase confirmation email.</p>
                </div>
                {error && (
                    <div className="mb-6 p-4 bg-red-900/20 border border-red-600/30 rounded-xl">
                        <div className="flex items-center space-x-2 text-red-400">
                            <i className="fas fa-exclamation-triangle"></i>
                            <span className="text-sm font-medium">{error}</span>
                        </div>
                    </div>
                )}
                <div className="mb-8">
                    <input
                        type="text"
                        id="purchaseId"
                        className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                        placeholder="tbx-xxxxxxxxxxxxxxx-xxxxxx"
                        value={purchaseId}
                        onChange={(e) => setPurchaseId(e.target.value)}
                        required
                    />
                </div>
                <div className="flex space-x-4 mt-8">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className="fas fa-times"></i>
                        <span>Cancel</span>
                    </button>
                    <button
                        type="button"
                        onClick={handleClaim}
                        className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className="fas fa-download"></i>
                        <span>Claim Script</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

// Custom Order Modal Component
const CustomOrderModal = ({ onClose, onSave, orderToEdit, setModalMessage }) => {
    const [title, setTitle] = useState(orderToEdit?.title || '');
    const [description, setDescription] = useState(orderToEdit?.description || '');
    const [budget, setBudget] = useState(orderToEdit?.budget || '');
    const [error, setError] = useState('');

    const handleSave = () => {
        setError('');
        if (!title.trim() || !description.trim() || !budget.trim()) {
            setError('All fields are required.');
            return;
        }
        onSave({ id: orderToEdit?.id, title: title.trim(), description: description.trim(), budget: budget.trim() });
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="glass-card p-8 rounded-2xl shadow-lg w-full max-w-lg animate-fadeIn border border-white/20">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center">
                        <i className="fas fa-shopping-basket text-blue-400 text-2xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold gradient-text">
                        {orderToEdit ? 'Edit Custom Order' : 'Create New Custom Order'}
                    </h3>
                    <p className="text-gray-400 text-sm mt-2">
                        {orderToEdit ? 'Update your custom development request' : 'Describe your custom script requirements'}
                    </p>
                </div>

                {error && (
                    <div className="mb-6 p-4 bg-red-900/20 border border-red-600/30 rounded-xl">
                        <div className="flex items-center space-x-2 text-red-400">
                            <i className="fas fa-exclamation-triangle"></i>
                            <span className="text-sm font-medium">{error}</span>
                        </div>
                    </div>
                )}

                <div className="space-y-6">
                    <div>
                        <label htmlFor="orderTitle" className="block text-gray-300 text-sm font-bold mb-3">
                            Order Title *
                        </label>
                        <input
                            type="text"
                            id="orderTitle"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                            placeholder="e.g., Custom Police MDT Script"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>
                    
                    <div>
                        <label htmlFor="orderDescription" className="block text-gray-300 text-sm font-bold mb-3">
                            Detailed Description *
                        </label>
                        <textarea
                            id="orderDescription"
                            rows="5"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300 resize-none"
                            placeholder="Describe your script idea, features, desired functionalities, specific requirements, and any reference materials..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                        ></textarea>
                    </div>
                    
                    <div>
                        <label htmlFor="orderBudget" className="block text-gray-300 text-sm font-bold mb-3">
                            Budget / Price Expectation *
                        </label>
                        <input
                            type="text"
                            id="orderBudget"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                            placeholder="e.g., $100-$200, Negotiable, Contact for Quote"
                            value={budget}
                            onChange={(e) => setBudget(e.target.value)}
                            required
                        />
                    </div>
                </div>
                
                <div className="flex space-x-4 mt-8">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className="fas fa-times"></i>
                        <span>Cancel</span>
                    </button>
                    <button
                        type="button"
                        onClick={handleSave}
                        className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className={`fas ${orderToEdit ? 'fa-save' : 'fa-paper-plane'}`}></i>
                        <span>{orderToEdit ? 'Save Changes' : 'Submit Order'}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

// NewTicketModal Component
const NewTicketModal = ({ onClose, onCreate }) => {
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [department, setDepartment] = useState('');
    const [scriptName, setScriptName] = useState('');
    const [discordLink, setDiscordLink] = useState('');
    const [error, setError] = useState('');

    const departments = [
        { name: 'Choose a Department', value: '', disabled: true, subjectPlaceholder: 'Select a department to get started' },
        { name: 'Script Support', value: 'Script Support', icon: 'fas fa-code', subjectPlaceholder: 'e.g., Bug, Feature Request' },
        { name: 'Collaboration', value: 'Collaboration', icon: 'fas fa-hands-helping', subjectPlaceholder: 'e.g., Studio Name, Partnership Proposal' },
        { name: 'Other', value: 'Other', icon: 'fas fa-question-circle', subjectPlaceholder: 'e.g., General question, Website issue' },
    ];

    // Mock script list - in a real app, this would come from your data
    const mockScripts = [
        'Banking System',
        'Realistic Smoking',
        'Realistic Needs',
        'Multijob',
        'Water Gun',
        'Drug Sales',
        'Mileage Meter',
        'Tags System',
        'Key Interactions',
    ];

    const currentSubjectPlaceholder = departments.find(dept => dept.value === department)?.subjectPlaceholder || 'Enter subject for your ticket';

    // Effect to clear subject if department changes
    useEffect(() => {
        setSubject(''); // Always clear the subject when department changes for placeholder to show
    }, [department]);

    const handleSubmit = () => {
        setError('');
        if (!subject.trim() || !description.trim() || !department.trim() || department === '') { // Check department value
            setError('Subject, description, and department are required.');
            return;
        }
        if (department === 'Script Support' && !scriptName.trim()) {
            setError('Please select a script for Script Support.');
            return;
        }
        if (department === 'Collaboration' && (!discordLink.trim() || !discordLink.startsWith('https://discord.gg/'))) {
            setError('Please provide a valid Discord invite link for Collaboration.');
            return;
        }
        onCreate(subject, description, department, scriptName, discordLink);
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="glass-card p-8 rounded-2xl shadow-lg w-full max-w-lg animate-fadeIn border border-white/20">
                <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="fas fa-plus text-2xl text-blue-400"></i>
                    </div>
                    <h2 className="text-2xl font-bold gradient-text">Create Support Ticket</h2>
                    <p className="text-gray-400 mt-2">Get help from our support team</p>
                </div>

                {error && (
                    <div className="mb-6 p-4 bg-red-900/20 border border-red-600/30 rounded-xl">
                        <div className="flex items-center space-x-2 text-red-400">
                            <i className="fas fa-exclamation-triangle"></i>
                            <span className="text-sm font-medium">{error}</span>
                        </div>
                    </div>
                )}

                <div className="space-y-6">
                    <div>
                        <label htmlFor="department" className="block text-gray-300 text-sm font-bold mb-3">
                            <i className="fas fa-building mr-2 text-blue-400"></i>
                            Support Department *
                        </label>
                        <div className="relative">
                            <select
                                id="department"
                                className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300 cursor-pointer"
                                value={department}
                                onChange={(e) => { setDepartment(e.target.value); setScriptName(''); setDiscordLink(''); }}
                                required
                            >
                                {departments.map((dept, index) => (
                                    <option key={index} value={dept.value} disabled={dept.disabled} className="bg-gray-800">
                                        {dept.name}
                                    </option>
                                ))}
                            </select>
                            <i className="fas fa-chevron-down absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                        </div>
                    </div>

                    {department === 'Script Support' && (
                        <div className="animate-fadeIn">
                            <label htmlFor="scriptName" className="block text-gray-300 text-sm font-bold mb-3">
                                <i className="fas fa-code mr-2 text-purple-400"></i>
                                Select Script *
                            </label>
                            <div className="relative">
                                <select
                                    id="scriptName"
                                    className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-purple-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300 cursor-pointer"
                                    value={scriptName}
                                    onChange={(e) => setScriptName(e.target.value)}
                                    required
                                >
                                    <option value="" disabled className="bg-gray-800">Choose a Script</option>
                                    {mockScripts.map((script, index) => (
                                        <option key={index} value={script} className="bg-gray-800">{script}</option>
                                    ))}
                                </select>
                                <i className="fas fa-chevron-down absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                            </div>
                        </div>
                    )}

                    {department === 'Collaboration' && (
                        <div className="animate-fadeIn">
                            <label htmlFor="discordLink" className="block text-gray-300 text-sm font-bold mb-3">
                                <i className="fab fa-discord mr-2 text-indigo-400"></i>
                                Discord Invite Link *
                            </label>
                            <input
                                type="url"
                                id="discordLink"
                                className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-indigo-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                                placeholder="https://discord.gg/yourinvite"
                                value={discordLink}
                                onChange={(e) => setDiscordLink(e.target.value)}
                                required
                            />
                        </div>
                    )}

                    <div>
                        <label htmlFor="ticketSubject" className="block text-gray-300 text-sm font-bold mb-3">
                            <i className="fas fa-tag mr-2 text-green-400"></i>
                            Subject *
                        </label>
                        <input
                            type="text"
                            id="ticketSubject"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-green-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                            placeholder={currentSubjectPlaceholder}
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                        />
                    </div>

                    <div>
                        <label htmlFor="ticketDescription" className="block text-gray-300 text-sm font-bold mb-3">
                            <i className="fas fa-align-left mr-2 text-yellow-400"></i>
                            Description *
                        </label>
                        <textarea
                            id="ticketDescription"
                            rows="5"
                            className="shadow appearance-none border rounded-xl w-full py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300 resize-none"
                            placeholder="Describe your issue in detail..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                        />
                    </div>
                </div>

                <div className="flex space-x-4 mt-8">
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className="fas fa-times"></i>
                        <span>Cancel</span>
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    >
                        <i className="fas fa-paper-plane"></i>
                        <span>Submit Ticket</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

// ServerDetail Component - Ultra Hot Design for managing a specific server
const ServerDetail = ({ serverId, onBackToPanel, user, db, setModalMessage }) => {
    const [server, setServer] = useState(null);
    const [loadingServer, setLoadingServer] = useState(true);
    const [activeServerDetailTab, setActiveServerDetailTab] = useState('info');

    // Mock player data for the player list
    const mockPlayers = [
        { id: '1', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '2', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '3', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '4', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '5', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '6', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '7', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
        { id: '8', name: 'Bary', identifier: 'char1:00d68486a31cf21323f34914602e94b7e1d40efd', ping: 12 },
    ];

    // Fetch specific server data from Firestore
    useEffect(() => {
        if (!user || !db || !serverId) {
            setLoadingServer(false);
            return;
        }

        const serverDocRef = doc(db, `servers`, serverId);

        const unsubscribe = onSnapshot(serverDocRef, (docSnap) => {
            if (docSnap.exists()) {
                const serverData = { id: docSnap.id, ...docSnap.data() };
                if (serverData.owner === user.uid) {
                    setServer(serverData);
                    console.log("Server detail fetched:", serverData);
                } else {
                    console.log("User does not own this server or is not admin.");
                    setServer(null);
                    setModalMessage("You do not have permission to view this server.");
                    onBackToPanel();
                }
            } else {
                console.log("No such server document!");
                setServer(null);
                setModalMessage("Server not found.");
                onBackToPanel();
            }
            setLoadingServer(false);
        }, (error) => {
            console.error("Error fetching server detail:", error);
            setModalMessage(`Error loading server details: ${error.message}`);
            setLoadingServer(false);
        });

        return () => unsubscribe();
    }, [serverId, user, db, onBackToPanel, setModalMessage]);

    const handleServerAction = useCallback((action) => {
        setModalMessage(`Simulating server ${action} for ${server.name}...`);
    }, [server, setModalMessage]);

const renderServerDetailContent = useCallback(() => { 
        if (loadingServer) {
            return (
                <div className="h-full flex items-center justify-center animate-fadeIn">
                    <div className="text-center">
                        <div className="relative">
                            <div className="w-20 h-20 border-4 border-blue-500/20 border-t-blue-500 rounded-full animate-spin mx-auto mb-6"></div>
                            <div className="absolute inset-0 w-20 h-20 border-4 border-purple-500/20 border-b-purple-500 rounded-full animate-spin mx-auto" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
                        </div>
                        <h3 className="text-2xl font-bold gradient-text mb-3">Loading Server Details</h3>
                        <p className="text-gray-400 animate-pulse">Gathering server information...</p>
                        <div className="flex justify-center space-x-1 mt-4">
                            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                            <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                        </div>
                    </div>
                </div>
            );
        }
        if (!server) {
            return (
                <div className="h-full flex items-center justify-center animate-fadeIn">
                    <div className="text-center">
                        <div className="relative group mb-6">
                            <div className="absolute inset-0 bg-red-500/20 rounded-full blur-xl animate-pulse"></div>
                            <div className="relative w-20 h-20 bg-gradient-to-br from-red-500/20 to-orange-500/20 rounded-full flex items-center justify-center mx-auto animate-bounce">
                                <i className="fas fa-exclamation-triangle text-3xl text-red-400"></i>
                            </div>
                        </div>
                        <h3 className="text-2xl font-bold text-white mb-3">Server Not Found</h3>
                        <p className="text-gray-400">Server data could not be loaded or you don't have access</p>
                    </div>
                </div>
            );
        }

        const playersParts = server.players ? String(server.players).split('/') : ['0', '0'];
        const currentPlayerCount = parseInt(playersParts[0], 10);
        const maxPlayerCount = parseInt(playersParts[1], 10);
        const displayPlayers = isNaN(currentPlayerCount) ? 0 : currentPlayerCount;
        const displayMaxPlayers = isNaN(maxPlayerCount) ? 0 : maxPlayerCount;

        switch (activeServerDetailTab) {
            case 'info':
                return (
            <div className="space-y-8 animate-fadeIn">
                {/* Ultra Hot Server Status & Info Card */}
                <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-indigo-500/10 rounded-2xl blur-xl opacity-50 group-hover:opacity-100 transition-opacity duration-500 animate-pulse-slow"></div>
                    <div className="relative glass-card border border-blue-500/30 rounded-2xl p-8 hover:border-blue-400/50 transition-all duration-500 hover-lift">
                        {/* Floating particles */}
                        <div className="absolute top-4 right-4 w-3 h-3 bg-blue-400 rounded-full animate-ping opacity-30"></div>
                        <div className="absolute top-8 right-8 w-2 h-2 bg-purple-400 rounded-full animate-pulse opacity-40"></div>
                        
                        <div className="flex items-center justify-between mb-8">
                            <div className="flex items-center space-x-4">
                                <div className="relative">
                                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-2xl flex items-center justify-center animate-float">
                                        <i className="fas fa-server text-blue-400 text-2xl"></i>
                                    </div>
                                    <div className={`absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center animate-heartbeat ${server.status === 'online' ? 'bg-green-500' : 'bg-red-500'}`}>
                                        <div className={`w-3 h-3 rounded-full animate-ping ${server.status === 'online' ? 'bg-green-300' : 'bg-red-300'}`}></div>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="text-2xl font-bold gradient-text animate-slideInLeft">Server Information</h3>
                                    <p className="text-gray-400 animate-slideInLeft" style={{ animationDelay: '0.1s' }}>
                                        Complete server details and metrics
                                    </p>
                                </div>
                            </div>
                            <div className="hidden md:flex items-center space-x-3">
                                <div className={`px-4 py-2 rounded-full text-sm font-semibold border animate-glow ${server.status === 'online' ? 'bg-green-500/20 border-green-500/40 text-green-300' : 'bg-red-500/20 border-red-500/40 text-red-300'}`}>
                                    <i className={`fas fa-circle mr-2 text-xs ${server.status === 'online' ? 'animate-pulse' : ''}`}></i>
                                    {server.status.charAt(0).toUpperCase() + server.status.slice(1)}
                                </div>
                            </div>
                        </div>
                    
                        {/* Premium Server Information Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                            {[
                                { 
                                    icon: 'fas fa-globe', 
                                    title: 'IP Address', 
                                    value: server.ip, 
                                    color: 'from-blue-500/20 to-indigo-500/20',
                                    iconColor: 'text-blue-400',
                                    delay: '0s'
                                },
                                { 
                                    icon: 'fas fa-map-marker-alt', 
                                    title: 'Region', 
                                    value: server.region, 
                                    color: 'from-purple-500/20 to-pink-500/20',
                                    iconColor: 'text-purple-400',
                                    delay: '0.1s'
                                },
                                { 
                                    icon: 'fas fa-heartbeat', 
                                    title: 'Status', 
                                    value: server.status.charAt(0).toUpperCase() + server.status.slice(1), 
                                    color: server.status === 'online' ? 'from-green-500/20 to-emerald-500/20' : 'from-red-500/20 to-orange-500/20',
                                    iconColor: server.status === 'online' ? 'text-green-400' : 'text-red-400',
                                    delay: '0.2s',
                                    special: true
                                }
                            ].map((item) => (
                                <div key={item.title} className="group/item relative animate-slideInLeft" style={{ animationDelay: item.delay }}>
                                    <div className={`absolute inset-0 bg-gradient-to-r ${item.color} rounded-xl opacity-0 group-hover/item:opacity-100 transition-opacity duration-300`}></div>
                                    <div className="relative glass-card border border-white/10 group-hover/item:border-blue-400/40 rounded-xl p-6 transition-all duration-500 hover-lift">
                                        <div className="flex items-center space-x-4">
                                            <div className={`w-12 h-12 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center group-hover/item:scale-110 transition-transform duration-300`}>
                                                <i className={`${item.icon} ${item.iconColor} text-xl ${item.special && server.status === 'online' ? 'animate-pulse' : ''}`}></i>
                                            </div>
                                            <div className="flex-1">
                                                <p className="text-gray-400 text-sm font-medium mb-1">{item.title}</p>
                                                <div className="relative overflow-hidden">
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover/item:translate-x-[100%] transition-transform duration-1000"></div>
                                                    <p className="relative text-white font-bold text-lg">
                                                        {item.special && server.status === 'online' ? (
                                                            <span className="flex items-center">
                                                                <i className="fas fa-circle text-green-400 text-xs mr-2 animate-pulse"></i>
                                                                {item.value}
                                                            </span>
                                                        ) : (
                                                            item.value
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Premium Current Metrics Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {[
                                { 
                                    icon: 'fas fa-users', 
                                    title: 'Players Online', 
                                    value: server.players, 
                                    color: 'from-green-500/20 to-emerald-500/20',
                                    iconColor: 'text-green-400',
                                    delay: '0.3s'
                                },
                                { 
                                    icon: 'fas fa-cubes', 
                                    title: 'Resources', 
                                    value: '162', 
                                    color: 'from-blue-500/20 to-cyan-500/20',
                                    iconColor: 'text-blue-400',
                                    delay: '0.4s'
                                },
                                { 
                                    icon: 'fas fa-users-line', 
                                    title: 'Players Today', 
                                    value: '0', 
                                    color: 'from-yellow-500/20 to-orange-500/20',
                                    iconColor: 'text-yellow-400',
                                    delay: '0.5s'
                                },
                                { 
                                    icon: 'fas fa-clipboard-list', 
                                    title: 'Logs Today', 
                                    value: '120', 
                                    color: 'from-purple-500/20 to-pink-500/20',
                                    iconColor: 'text-purple-400',
                                    delay: '0.6s'
                                }
                            ].map((metric) => (
                                <div key={metric.title} className="group/metric relative animate-slideInLeft" style={{ animationDelay: metric.delay }}>
                                    <div className={`absolute inset-0 bg-gradient-to-r ${metric.color} rounded-xl opacity-0 group-hover/metric:opacity-100 transition-opacity duration-300`}></div>
                                    <div className="relative glass-card border border-white/10 group-hover/metric:border-green-400/40 rounded-xl p-6 transition-all duration-300 hover-lift text-center">
                                        <div className="flex flex-col items-center space-y-3">
                                            <div className={`w-12 h-12 bg-gradient-to-br ${metric.color} rounded-xl flex items-center justify-center group-hover/metric:scale-110 transition-transform duration-300`}>
                                                <i className={`${metric.icon} ${metric.iconColor} text-xl`}></i>
                                            </div>
                                            <div>
                                                <p className="text-gray-400 text-sm font-medium mb-1">{metric.title}</p>
                                                <p className="text-2xl font-bold text-white group-hover/metric:text-green-300 transition-colors">{metric.value}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Ultra Hot Connected Players Card */}
                <div className="relative group animate-slideInLeft" style={{ animationDelay: '0.7s' }}>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 via-emerald-500/10 to-teal-500/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <div className="relative glass-card border border-green-500/30 rounded-2xl p-8 hover:border-green-400/50 transition-all duration-500 hover-lift">
                        <div className="flex items-center justify-between mb-8">
                            <div className="flex items-center space-x-4">
                                <div className="w-16 h-16 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-2xl flex items-center justify-center animate-pulse">
                                    <i className="fas fa-users text-green-400 text-2xl"></i>
                                </div>
                                <div>
                                    <h3 className="text-2xl font-bold gradient-text">Connected Players</h3>
                                    <p className="text-gray-400">{mockPlayers.length} players currently online</p>
                                </div>
                            </div>
                            <div className="bg-green-500/20 border border-green-500/40 rounded-full px-4 py-2 animate-glow">
                                <span className="text-green-300 font-semibold text-sm">
                                    <i className="fas fa-circle mr-2 text-xs animate-pulse"></i>
                                    {mockPlayers.length} Online
                                </span>
                            </div>
                        </div>
                        
                        <div className="glass-card border border-white/10 rounded-xl max-h-96 overflow-y-auto">
                            {mockPlayers.length === 0 ? (
                                <div className="p-12 text-center animate-bounceIn">
                                    <div className="w-16 h-16 bg-gradient-to-br from-gray-500/20 to-gray-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <i className="fas fa-user-slash text-gray-400 text-2xl"></i>
                                    </div>
                                    <p className="text-gray-400 font-semibold">No players currently connected</p>
                                    <p className="text-gray-500 text-sm">Server is ready for players to join</p>
                                </div>
                            ) : (
                                <div className="divide-y divide-white/10">
                                    {mockPlayers.map((player, index) => (
                                        <div key={player.id} className="group/player p-4 hover:bg-gradient-to-r hover:from-green-500/10 hover:to-emerald-500/10 transition-all duration-300 animate-fadeIn" style={{ animationDelay: `${0.8 + index * 0.1}s` }}>
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-full flex items-center justify-center group-hover/player:scale-110 transition-transform duration-300">
                                                        <i className="fas fa-user text-green-400"></i>
                                                    </div>
                                                    <div>
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <i className="fas fa-circle text-green-500 text-xs animate-pulse"></i>
                                                            <span className="text-white font-semibold group-hover/player:text-green-300 transition-colors">
                                                                {player.name}
                                                            </span>
                                                        </div>
                                                        <p className="text-xs text-gray-400 font-mono bg-gray-800/50 px-2 py-1 rounded group-hover/player:bg-green-500/20 transition-colors">
                                                            {player.identifier}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-6 text-sm">
                                                    <div className="text-center">
                                                        <p className="text-gray-400 text-xs">ID</p>
                                                        <p className="text-white font-semibold">{player.id}</p>
                                                    </div>
                                                    <div className="text-center">
                                                        <p className="text-gray-400 text-xs">Ping</p>
                                                        <div className="flex items-center space-x-1">
                                                            <div className={`w-2 h-2 rounded-full animate-pulse ${player.ping < 50 ? 'bg-green-400' : player.ping < 100 ? 'bg-yellow-400' : 'bg-red-400'}`}></div>
                                                            <p className={`font-semibold ${
                                                                player.ping < 50 ? 'text-green-400' :
                                                                player.ping < 100 ? 'text-yellow-400' : 'text-red-400'
                                                            }`}>
                                                                {player.ping}ms
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
                );
            case 'overview': 
                return (
                    <Overview db={db} setModalMessage={setModalMessage} />
                );
            case 'logs':
                return (
                    <ServerLogs db={db} setModalMessage={setModalMessage} server={server} />
                );
            case 'analytics':
                return (
                    <div className="h-full flex flex-col items-center justify-center animate-fadeIn">
                        <div className="relative group">
                            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 via-pink-500/20 to-indigo-500/20 rounded-3xl blur-2xl opacity-50 animate-pulse-slow"></div>
                            <div className="relative w-32 h-32 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-3xl flex items-center justify-center mb-8 shadow-2xl animate-float hover:scale-105 transition-transform duration-300">
                                <i className="fas fa-chart-line text-6xl text-purple-400 animate-pulse"></i>
                            </div>
                        </div>
                        <h4 className="text-3xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-indigo-400 bg-clip-text text-transparent mb-4 animate-slideInLeft">
                            Server Analytics
                        </h4>
                        <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mb-6 animate-width-expand"></div>
                        <p className="text-gray-300 text-center text-lg leading-relaxed animate-slideInRight">
                            Detailed performance metrics, player behavior analytics, and trend analysis.
                        </p>
                    </div>
                );
            case 'economy':
                return (
                    <ServerEconomy db={db} setModalMessage={setModalMessage} />
                );
            case 'settings':
                return (
                    <ServerSettings db={db} setModalMessage={setModalMessage} server={server} currentUser={user} />
                );
            default:
                return (
                    <div className="h-full flex items-center justify-center animate-fadeIn">
                        <div className="text-center">
                            <div className="w-20 h-20 bg-gradient-to-br from-gray-500/20 to-slate-500/20 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                                <i className="fas fa-question-circle text-3xl text-gray-400"></i>
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-3">No Content Selected</h3>
                            <p className="text-gray-400">Please select a tab from the sidebar to view content</p>
                        </div>
                    </div>
                );
        }
    }, [activeServerDetailTab, server, setModalMessage, handleServerAction]);

    return (
        <div className="min-h-screen w-screen flex bg-[#111111] relative overflow-hidden p-4">
            {/* Ultra Hot Background Animation */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
                <div className="absolute bottom-1/4 left-1/3 w-56 h-56 rounded-full bg-purple-500 filter blur-3xl opacity-25 animate-float"></div>
            </div>

            {/* Background Animation Elements */}
            <div className="absolute top-8 left-8 w-6 h-6 bg-blue-500/20 rounded-full animate-ping"></div>
            <div className="absolute top-16 right-16 w-4 h-4 bg-purple-500/20 rounded-full animate-pulse"></div>
            <div className="absolute bottom-16 left-16 w-3 h-3 bg-green-500/20 rounded-full animate-bounce"></div>
            <div className="absolute bottom-8 right-8 w-5 h-5 bg-indigo-500/20 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>

            <div className="w-full h-full flex relative z-10 animate-fadeIn flex-col md:flex-row gap-6">
                {/* Ultra Hot Sidebar Navigation */}
                <div className="w-full md:w-80 flex-shrink-0 relative group animate-slideInLeft">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-indigo-500/10 rounded-2xl blur-xl opacity-50 animate-pulse-slow"></div>
                    <div className="relative glass-card border border-blue-500/30 rounded-2xl p-6 flex flex-col hover:border-blue-400/50 transition-all duration-500 h-full">
                        
                        {/* Server Header */}
                        <div className="text-center mb-8 animate-bounceIn">
                            <div className="relative inline-block">
                                <div className="w-20 h-20 bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-2xl animate-float hover:scale-105 transition-transform duration-300">
                                    <i className={`fas fa-server text-white text-3xl ${server?.status === 'online' ? 'animate-pulse' : ''}`}></i>
                                </div>
                                <div className={`absolute -top-1 -right-1 w-7 h-7 rounded-full flex items-center justify-center animate-heartbeat ${server?.status === 'online' ? 'bg-green-500' : 'bg-red-500'}`}>
                                    <div className={`w-3 h-3 rounded-full animate-ping ${server?.status === 'online' ? 'bg-green-300' : 'bg-red-300'}`}></div>
                                </div>
                            </div>
                            <h3 className="text-2xl font-bold bg-gradient-to-r from-white via-blue-100 to-purple-100 bg-clip-text text-transparent mb-2">
                                {server ? server.name : 'Server'}
                            </h3>
                            <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mx-auto animate-width-expand"></div>
                        </div>

                        {/* Ultra Hot Navigation Menu */}
                        <nav className="space-y-3 flex-grow">
                            {[
                                { key: 'info', icon: 'fas fa-info-circle', title: 'General Info', color: 'from-blue-500/20 to-indigo-500/20', delay: '0s' },
                                { key: 'overview', icon: 'fas fa-tachometer-alt', title: 'Dashboard', color: 'from-green-500/20 to-emerald-500/20', delay: '0.1s' },
                                { key: 'logs', icon: 'fas fa-clipboard-list', title: 'Server Logs', color: 'from-yellow-500/20 to-orange-500/20', delay: '0.2s' },
                                { key: 'economy', icon: 'fas fa-coins', title: 'Economy', color: 'from-green-500/20 to-teal-500/20', delay: '0.3s' },
                                { key: 'settings', icon: 'fas fa-cog', title: 'Settings', color: 'from-gray-500/20 to-slate-500/20', delay: '0.4s' }
                            ].map((item) => (
                                <div key={item.key} className="relative group/item animate-slideInLeft" style={{ animationDelay: item.delay }}>
                                    <div className={`absolute inset-0 bg-gradient-to-r ${item.color} rounded-xl opacity-0 group-hover/item:opacity-100 transition-opacity duration-300`}></div>
                                    <button
                                        onClick={() => setActiveServerDetailTab(item.key)}
                                        className={`relative w-full text-left px-6 py-4 rounded-xl transition-all duration-300 flex items-center space-x-4 font-medium border ${
                                            activeServerDetailTab === item.key 
                                                ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white border-blue-400/50 shadow-lg' 
                                                : 'text-gray-300 hover:text-white border-white/10 hover:border-blue-400/30 glass-card hover-lift'
                                        }`}
                                    >
                                        <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
                                            activeServerDetailTab === item.key 
                                                ? 'bg-white/20' 
                                                : 'bg-gray-800 group-hover/item:bg-blue-500/20'
                                        }`}>
                                            <i className={`${item.icon} text-lg ${
                                                activeServerDetailTab === item.key ? 'animate-pulse' : 'group-hover/item:scale-110 transition-transform duration-300'
                                            }`}></i>
                                        </div>
                                        <span className="flex-1">{item.title}</span>
                                        {activeServerDetailTab === item.key && (
                                            <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
                                        )}
                                        {/* Shimmer effect */}
                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover/item:translate-x-[100%] transition-transform duration-1000"></div>
                                    </button>
                                </div>
                            ))}
                        </nav>

                        {/* Premium Back Button */}
                        <div className="mt-8 animate-fadeIn" style={{ animationDelay: '0.5s' }}>
                            <button
                                onClick={onBackToPanel}
                                className="group/back w-full relative overflow-hidden bg-gradient-to-r from-gray-700 to-gray-800 hover:from-blue-600 hover:to-purple-600 text-white font-bold py-4 px-6 rounded-xl transition-all duration-500 shadow-lg hover:shadow-2xl hover:-translate-y-1 border border-gray-600 hover:border-blue-500/50"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 translate-x-[-100%] group-hover/back:translate-x-[100%] transition-transform duration-700"></div>
                                <div className="relative flex items-center justify-center space-x-3">
                                    <i className="fas fa-arrow-left group-hover/back:-translate-x-1 transition-transform duration-300"></i>
                                    <span>Back to My Servers</span>
                                    <div className="w-2 h-2 bg-white/50 rounded-full animate-pulse"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Ultra Hot Main Content Area */}
                <div className="flex-1 relative group animate-slideInRight">
                    <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 via-purple-500/10 to-blue-500/10 rounded-2xl blur-2xl opacity-30 animate-pulse-slow"></div>
                    <div className="relative glass-card border border-purple-500/30 rounded-2xl p-8 h-full hover:border-purple-400/50 transition-all duration-500 overflow-hidden">
                        {/* Floating particles */}
                        <div className="absolute top-6 right-6 w-3 h-3 bg-purple-400 rounded-full animate-ping opacity-30"></div>
                        <div className="absolute top-12 right-12 w-2 h-2 bg-blue-400 rounded-full animate-pulse opacity-40"></div>
                        <div className="absolute bottom-12 left-12 w-4 h-4 bg-indigo-400 rounded-full animate-bounce opacity-20"></div>
                        
                        {/* Dynamic Header */}
                        <div className="mb-8 animate-bounceIn">
                            <h2 className="text-4xl font-bold bg-gradient-to-r from-white via-blue-100 to-purple-100 bg-clip-text text-transparent mb-2">
                                {server ? server.name : 'Server'} - {activeServerDetailTab.charAt(0).toUpperCase() + activeServerDetailTab.slice(1)}
                            </h2>
                            <div className="w-32 h-1 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full animate-width-expand"></div>
                        </div>
                        
                        <div className="h-full">
                            {renderServerDetailContent()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper to format notes with bullet points
const formatNotes = (notes) => {
    if (!notes) return null;
    return notes.split('\n').map((line, index) => (
        <li key={index} className="flex items-start">
            <span className="mr-2 text-gray-400">•</span>
            <span>{line}</span>
        </li>
    ));
};



// Admin Components - COMMENTED OUT - USING IMPORTED VERSION
/* 
const AdminCalendar = ({ user, db, setModalMessage, userColor, appId }) => { // Added appId prop
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [events, setEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showEventModal, setShowEventModal] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null); // Null for new, object for edit

    // Fetch events from Firestore
    useEffect(() => {
        if (!user || !db || !appId) return; // Ensure appId is available

        // Fetch from the public calendarEvents collection
        const eventsCollectionRef = collection(db, `artifacts/${appId}/public/data/calendarEvents`);
        const q = query(eventsCollectionRef);

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedEvents = snapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    // Ensure date is a Date object for comparison
                    startDate: data.startDate, // Keep as string for input[type="date"]
                    endDate: data.endDate,
                    dateObj: new Date(data.startDate) // For calendar logic
                };
            });
            setEvents(fetchedEvents);
        }, (error) => {
            console.error("Error fetching calendar events:", error);
            setModalMessage(`Error loading calendar events: ${error.message}`);
        });

        return () => unsubscribe();
    }, [user, db, setModalMessage, appId]); // Add appId to dependencies

    const daysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    const firstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay(); // 0 for Sunday, 1 for Monday

    const days = [];
    const numDays = daysInMonth(currentMonth);
    const startDay = firstDayOfMonth(currentMonth); // Adjust for 0-indexed day of week (Sunday is 0)

    // Fill leading empty days
    for (let i = 0; i < startDay; i++) {
        days.push(<div key={`empty-start-${i}`} className="p-2 text-center text-gray-600"></div>);
    }

    // Fill days of the month
    for (let i = 1; i <= numDays; i++) {
        const dayDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), i);
        const eventsOnDay = events.filter(event => 
            event.dateObj.toDateString() === dayDate.toDateString()
        );
        const isSelected = selectedDate && selectedDate.toDateString() === dayDate.toDateString();
        const isToday = dayDate.toDateString() === new Date().toDateString();

        days.push(
            <div 
                key={`day-${i}`} 
                className={`p-2 text-center border border-gray-700 rounded-md hover:bg-gray-700 transition duration-200 cursor-pointer relative flex flex-col justify-between items-center min-h-[60px] sm:min-h-[70px] ${isToday ? 'bg-blue-900 bg-opacity-50 border-blue-500' : ''} ${isSelected ? 'border-blue-400 ring-2 ring-blue-400' : ''}`}
                onClick={() => setSelectedDate(dayDate)}
            >
                <span className="text-lg font-bold text-white">{i}</span>
                {eventsOnDay.length > 0 && (
                    <div className="flex flex-wrap justify-center mt-1">
                        {eventsOnDay.slice(0, 2).map((event, idx) => ( // Show up to 2 event indicators
                            <span 
                                key={idx} 
                                className="w-2 h-2 rounded-full mx-0.5" 
                                style={{ backgroundColor: event.color || userColor || '#4d9eff' }}
                                title={event.title}
                            ></span>
                        ))}
                        {eventsOnDay.length > 2 && (
                            <span className="text-xs text-gray-400 ml-1">+{eventsOnDay.length - 2}</span>
                        )}
                    </div>
                )}
            </div>
        );
    }

    const goToPreviousMonth = () => {
        setSelectedDate(null); // Clear selected date when changing month
        setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
    };

    const goToNextMonth = () => {
        setSelectedDate(null); // Clear selected date when changing month
        setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
    };

    const handleSaveEvent = async (eventDataToSave) => {
        if (!user || !db || !appId) { // Ensure appId is available
            setModalMessage("User not authenticated, database not available, or app ID missing.");
            return;
        }

        try {
            const eventsCollectionRef = collection(db, `artifacts/${appId}/public/data/calendarEvents`);
            if (eventDataToSave.id) {
                // Update existing event
                const eventDocRef = doc(db, `artifacts/${appId}/public/data/calendarEvents`, eventDataToSave.id);
                await setDoc(eventDocRef, eventDataToSave, { merge: true });
                setModalMessage("Event updated successfully!");
            } else {
                // Add new event: Destructure to exclude 'id' which would be undefined for new events
                const { id, ...dataWithoutId } = eventDataToSave; 
                await addDoc(eventsCollectionRef, {
                    ...dataWithoutId,
                    ownerId: user.uid, // Store the owner's UID
                    createdAt: new Date().toISOString()
                });
                setModalMessage("Event added successfully!");
            }
        } catch (error) {
            console.error("Error saving event:", error);
            setModalMessage(`Failed to save event: ${error.message}`);
        }
    };

    const handleDeleteEvent = async (eventId) => {
        if (!user || !db || !appId) { // Ensure appId is available
            setModalMessage("User not authenticated, database not available, or app ID missing.");
            return;
        }
        try {
            const eventDocRef = doc(db, `artifacts/${appId}/public/data/calendarEvents`, eventId);
            await deleteDoc(eventDocRef);
            setModalMessage("Event deleted successfully!");
            setShowEventModal(false); // Close modal after deletion
            setEditingEvent(null);
        } catch (error) {
            console.error("Error deleting event:", error);
            setModalMessage(`Failed to delete event: ${error.message}`);
        }
    };

    const openAddEventModal = (date) => {
        setEditingEvent(null); // Ensure no event is being edited
        setSelectedDate(date); // Pre-select the date
        setShowEventModal(true);
    };

    const openEditEventModal = (event) => {
        setEditingEvent(event);
        setSelectedDate(event.dateObj); // Set selected date to the event's date
        setShowEventModal(true);
    };

    const eventsForSelectedDate = selectedDate 
        ? events.filter(event => event.dateObj.toDateString() === selectedDate.toDateString())
        : [];

    return (
        <div className="glass-card rounded-2xl p-8 h-full flex flex-col">
            <div className="flex items-center mb-8">
                <div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center mr-4">
                    <i className="fas fa-calendar-alt text-xl text-purple-400"></i>
                </div>
                <h3 className="text-3xl font-bold gradient-text">Calendar</h3>
            </div>
            
            <div className="flex justify-between items-center mb-6">
                <button 
                    onClick={goToPreviousMonth} 
                    className="px-6 py-3 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105"
                >
                    <i className="fas fa-arrow-left mr-2"></i> Previous
                </button>
                <div className="text-center">
                    <h4 className="text-2xl font-bold text-white">
                        {currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}
                    </h4>
                </div>
                <button 
                    onClick={goToNextMonth} 
                    className="px-6 py-3 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105"
                >
                    Next <i className="fas fa-arrow-right ml-2"></i>
                </button>
            </div>
            
            <div className="glass-card rounded-2xl p-6 mb-6 flex-1 flex flex-col">
                <div className="grid grid-cols-7 gap-2 text-center text-gray-300 font-semibold mb-4 pb-3 border-b border-white/10">
                    <div className="py-2">Sun</div><div className="py-2">Mon</div><div className="py-2">Tue</div><div className="py-2">Wed</div><div className="py-2">Thu</div><div className="py-2">Fri</div><div className="py-2">Sat</div>
                </div>
                <div className="grid grid-cols-7 gap-2 flex-1 overflow-y-auto custom-scrollbar pr-2">
                    {days}
                </div>
            </div>
            
            {selectedDate && (
                <div className="glass-card rounded-2xl p-6">
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h4 className="text-xl font-bold text-white">Events</h4>
                            <p className="text-gray-400 text-sm">{selectedDate.toDateString()}</p>
                        </div>
                        <button
                            onClick={() => openAddEventModal(selectedDate)}
                            className="px-6 py-3 btn-gradient font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 text-white"
                        >
                            <i className="fas fa-plus mr-2"></i> Add Event
                        </button>
                    </div>
                    
                    <div className="space-y-3 overflow-y-auto custom-scrollbar pr-2 max-h-60">
                        {eventsForSelectedDate.length === 0 ? (
                            <div className="text-center py-8">
                                <div className="w-16 h-16 bg-gray-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <i className="fas fa-calendar-plus text-2xl text-gray-400"></i>
                                </div>
                                <p className="text-gray-400">No events for this day</p>
                                <p className="text-gray-500 text-sm">Click "Add Event" to create one</p>
                            </div>
                        ) : (
                            eventsForSelectedDate.map(event => (
                                <div 
                                    key={event.id} 
                                    className="bg-white/5 border border-white/10 rounded-xl p-4 cursor-pointer hover:bg-white/10 transition-all duration-300 transform hover:scale-105"
                                    style={{ borderLeftColor: event.color || userColor || '#4d9eff', borderLeftWidth: '4px' }}
                                    onClick={() => openEditEventModal(event)}
                                >
                                    <div className="flex justify-between items-start mb-2">
                                        <h5 className="text-white font-semibold text-lg">{event.title}</h5>
                                        {!event.allDay && (
                                            <span className="text-xs text-gray-400 bg-gray-600/50 px-2 py-1 rounded-lg">
                                                {event.startTime} - {event.endTime}
                                            </span>
                                        )}
                                    </div>
                                    {event.description && (
                                        <p className="text-gray-300 text-sm mb-2">{event.description}</p>
                                    )}
                                    {event.notes && (
                                        <div className="text-gray-300 text-sm space-y-1">
                                            {formatNotes(event.notes)}
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
            <EventModal
                isOpen={showEventModal}
                onClose={() => setShowEventModal(false)}
                onSave={handleSaveEvent}
                onDelete={handleDeleteEvent}
                eventData={editingEvent}
                userColor={userColor}
                setModalMessage={setModalMessage}
            />
        </div>
    );
};
*/

// New TodoModal Component for adding/editing todos
const TodoModal = ({ isOpen, onClose, onSave, onDelete, todoData, allAdmins, userColor, userUid, setModalMessage }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('low'); // Default priority
    const [dueDate, setDueDate] = useState('');
    const [selectedAdmins, setSelectedAdmins] = useState([]); // Array of UIDs
    const [todos, setTodos] = useState([]); // Array of todo items with subtasks
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState('details'); // details, tasks, assignments

    useEffect(() => {
        if (todoData) {
            setTitle(todoData.title || '');
            setDescription(todoData.description || '');
            setPriority(todoData.priority || 'low');
            setDueDate(todoData.dueDate || '');
            setSelectedAdmins(todoData.assignedTo || []);
            setTodos(todoData.todos || []);
        } else {
            // Reset form for new todo
            setTitle('');
            setDescription('');
            setPriority('low');
            setDueDate('');
            setSelectedAdmins([userUid]); // Default to current user as assigned
            setTodos([]);
        }
        setError('');
        setActiveTab('details');
    }, [todoData, isOpen, userUid]);

    const handleAdminToggle = (adminUid) => {
        setSelectedAdmins(prev => 
            prev.includes(adminUid)
                ? prev.filter(uid => uid !== adminUid)
                : [...prev, adminUid]
        );
    };

    const addTodoItem = () => {
        const newTodo = {
            id: Date.now(),
            text: '',
            completed: false,
            subtasks: []
        };
        setTodos(prev => [...prev, newTodo]);
    };

    const addSubtask = (todoId) => {
        const newSubtask = {
            id: Date.now(),
            text: '',
            completed: false,
            subSubtasks: []
        };
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? { ...todo, subtasks: [...todo.subtasks, newSubtask] }
                : todo
        ));
    };

    const addSubSubtask = (todoId, subtaskId) => {
        const newSubSubtask = {
            id: Date.now(),
            text: '',
            completed: false
        };
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? {
                    ...todo,
                    subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                            ? { ...subtask, subSubtasks: [...subtask.subSubtasks, newSubSubtask] }
                            : subtask
                    )
                }
                : todo
        ));
    };

    const updateTodoText = (todoId, text) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId ? { ...todo, text } : todo
        ));
    };

    const updateSubtaskText = (todoId, subtaskId, text) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? {
                    ...todo,
                    subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId ? { ...subtask, text } : subtask
                    )
                }
                : todo
        ));
    };

    const updateSubSubtaskText = (todoId, subtaskId, subSubtaskId, text) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? {
                    ...todo,
                    subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                            ? {
                                ...subtask,
                                subSubtasks: subtask.subSubtasks.map(subSubtask =>
                                    subSubtask.id === subSubtaskId ? { ...subSubtask, text } : subSubtask
                                )
                            }
                            : subtask
                    )
                }
                : todo
        ));
    };

    const toggleTodoCompleted = (todoId) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId ? { ...todo, completed: !todo.completed } : todo
        ));
    };

    const toggleSubtaskCompleted = (todoId, subtaskId) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? {
                    ...todo,
                    subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId ? { ...subtask, completed: !subtask.completed } : subtask
                    )
                }
                : todo
        ));
    };

    const toggleSubSubtaskCompleted = (todoId, subtaskId, subSubtaskId) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? {
                    ...todo,
                    subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                            ? {
                                ...subtask,
                                subSubtasks: subtask.subSubtasks.map(subSubtask =>
                                    subSubtask.id === subSubtaskId ? { ...subSubtask, completed: !subSubtask.completed } : subSubtask
                                )
                            }
                            : subtask
                    )
                }
                : todo
        ));
    };

    const removeTodoItem = (todoId) => {
        setTodos(prev => prev.filter(todo => todo.id !== todoId));
    };

    const removeSubtask = (todoId, subtaskId) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? { ...todo, subtasks: todo.subtasks.filter(subtask => subtask.id !== subtaskId) }
                : todo
        ));
    };

    const removeSubSubtask = (todoId, subtaskId, subSubtaskId) => {
        setTodos(prev => prev.map(todo => 
            todo.id === todoId 
                ? {
                    ...todo,
                    subtasks: todo.subtasks.map(subtask =>
                        subtask.id === subtaskId
                            ? { ...subtask, subSubtasks: subtask.subSubtasks.filter(subSubtask => subSubtask.id !== subSubtaskId) }
                            : subtask
                    )
                }
                : todo
        ));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (!title.trim()) {
            setError('Task title is required.');
            return;
        }
        if (!dueDate) {
            setError('Due date is required.');
            return;
        }
        if (selectedAdmins.length === 0) {
            setError('At least one admin must be assigned.');
            return;
        }

        onSave({
            id: todoData?.id, // Pass ID if editing
            title: title.trim(),
            description: description.trim(),
            priority: priority,
            dueDate: dueDate,
            assignedTo: selectedAdmins,
            color: userColor || '#4d9eff', // Creator's color
            todos: todos
        });
        onClose();
    };

    if (!isOpen) return null;

    const getPriorityIcon = (priority) => {
        switch (priority) {
            case 'high': return { icon: 'fas fa-fire', color: 'from-red-500/20 to-pink-500/20', text: 'text-red-400', border: 'border-red-500/40' };
            case 'medium': return { icon: 'fas fa-bolt', color: 'from-yellow-500/20 to-orange-500/20', text: 'text-yellow-400', border: 'border-yellow-500/40' };
            case 'low': return { icon: 'fas fa-leaf', color: 'from-green-500/20 to-emerald-500/20', text: 'text-green-400', border: 'border-green-500/40' };
            default: return { icon: 'fas fa-circle', color: 'from-gray-500/20 to-gray-600/20', text: 'text-gray-400', border: 'border-gray-500/40' };
        }
    };

    const currentPriorityStyle = getPriorityIcon(priority);

    const tabs = [
        { id: 'details', label: 'Task Details', icon: 'fas fa-info-circle' },
        { id: 'tasks', label: 'Task Breakdown', icon: 'fas fa-list-check' },
        { id: 'assignments', label: 'Team Assignment', icon: 'fas fa-users' }
    ];

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
            <div className="relative w-full max-w-4xl max-h-[90vh] overflow-hidden animate-bounceIn">
                {/* Background with animated gradients */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-indigo-500/10 rounded-3xl blur-xl animate-pulse-slow"></div>
                <div className="absolute inset-0 bg-gradient-to-tl from-green-500/5 via-transparent to-pink-500/5 rounded-3xl blur-2xl animate-float"></div>
                
                <div className="relative glass-card border border-blue-500/30 rounded-3xl shadow-2xl overflow-hidden">
                    {/* Floating decorative elements */}
                    <div className="absolute top-8 right-8 w-4 h-4 bg-blue-400 rounded-full animate-ping opacity-30"></div>
                    <div className="absolute bottom-8 left-8 w-3 h-3 bg-purple-400 rounded-full animate-pulse opacity-40"></div>
                    <div className="absolute top-1/3 right-12 w-2 h-2 bg-green-400 rounded-full animate-bounce opacity-20"></div>
                    
                    {/* Header */}
                    <div className="relative p-8 border-b border-gray-700/50">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-4">
                                <div className="relative">
                                    <div className={`w-16 h-16 bg-gradient-to-br ${currentPriorityStyle.color} rounded-2xl flex items-center justify-center animate-float border ${currentPriorityStyle.border}`}>
                                        <i className={`${currentPriorityStyle.icon} ${currentPriorityStyle.text} text-2xl`}></i>
                                    </div>
                                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center animate-pulse">
                                        <i className="fas fa-plus text-white text-xs"></i>
                                    </div>
                                </div>
                                <div>
                                    <h3 className="text-3xl font-bold bg-gradient-to-r from-white via-blue-100 to-purple-100 bg-clip-text text-transparent">
                                        {todoData ? 'Edit Task' : 'Create New Task'}
                                    </h3>
                                    <p className="text-gray-400 text-lg mt-1">
                                        {todoData ? 'Update task details and progress' : 'Build something amazing with your team'}
                                    </p>
                                </div>
                            </div>
                            
                            <button
                                onClick={onClose}
                                className="group relative overflow-hidden w-12 h-12 bg-gradient-to-r from-red-600/20 to-pink-600/20 hover:from-red-600/40 hover:to-pink-600/40 border border-red-500/30 hover:border-red-400/50 rounded-xl transition-all duration-300 hover:scale-105"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></div>
                                <i className="fas fa-times relative text-red-400 group-hover:text-red-300 group-hover:rotate-90 transition-all duration-300"></i>
                            </button>
                        </div>
                        
                        {error && (
                            <div className="mt-6 relative overflow-hidden group/error animate-slideInLeft">
                                <div className="absolute inset-0 bg-gradient-to-r from-red-500/20 to-pink-500/20 rounded-xl opacity-0 group-hover/error:opacity-100 transition-opacity duration-300"></div>
                                <div className="relative bg-red-900/30 border border-red-500/40 rounded-xl p-4">
                                    <div className="flex items-center space-x-3">
                                        <div className="w-10 h-10 bg-gradient-to-br from-red-500/20 to-pink-500/20 rounded-full flex items-center justify-center animate-pulse">
                                            <i className="fas fa-exclamation-triangle text-red-400"></i>
                                        </div>
                                        <div>
                                            <h4 className="text-red-400 font-bold">Validation Error</h4>
                                            <p className="text-red-300 text-sm">{error}</p>
                                        </div>
                                    </div>
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-red-400/10 to-transparent translate-x-[-100%] group-hover/error:translate-x-[100%] transition-transform duration-700"></div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Tab Navigation */}
                    <div className="relative p-6 border-b border-gray-700/50">
                        <div className="flex space-x-1 bg-gray-800/50 rounded-xl p-2">
                            {tabs.map((tab, index) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`group relative overflow-hidden flex-1 flex items-center justify-center space-x-3 py-4 px-6 rounded-xl font-medium transition-all duration-300 ${
                                        activeTab === tab.id
                                            ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg scale-105'
                                            : 'text-gray-400 hover:text-white hover:bg-gray-700/50'
                                    }`}
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></div>
                                    <i className={`${tab.icon} relative ${activeTab === tab.id ? 'animate-pulse' : ''}`}></i>
                                    <span className="relative">{tab.label}</span>
                                    {activeTab === tab.id && (
                                        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-1 bg-white rounded-full animate-width-expand"></div>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Content Area */}
                    <div className="relative max-h-[60vh] overflow-y-auto custom-scrollbar">
                        <form onSubmit={handleSubmit}>
                            {/* Tab Content */}
                            {activeTab === 'details' && (
                                <div className="p-8 space-y-8 animate-fadeIn">
                                    {/* Task Title */}
                                    <div className="group relative">
                                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="relative">
                                            <label className="block text-gray-300 text-sm font-bold mb-3 flex items-center space-x-2">
                                                <i className="fas fa-heading text-blue-400"></i>
                                                <span>Task Title *</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                                className="w-full py-4 px-6 bg-gray-900/50 border border-gray-700 rounded-xl text-white text-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-400/50 transition-all duration-300"
                                                placeholder="e.g., Implement user authentication system"
                                                required
                                            />
                                            <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-blue-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
                                        </div>
                                    </div>

                                    {/* Task Description */}
                                    <div className="group relative">
                                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="relative">
                                            <label className="block text-gray-300 text-sm font-bold mb-3 flex items-center space-x-2">
                                                <i className="fas fa-align-left text-purple-400"></i>
                                                <span>Description</span>
                                            </label>
                                            <textarea
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                rows={4}
                                                className="w-full py-4 px-6 bg-gray-900/50 border border-gray-700 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-400/50 transition-all duration-300 resize-none"
                                                placeholder="Provide detailed description of the task, requirements, and expectations..."
                                            />
                                            <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-purple-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
                                        </div>
                                    </div>

                                    {/* Priority and Due Date */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                        <div className="group relative">
                                            <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-red-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                            <div className="relative">
                                                <label className="block text-gray-300 text-sm font-bold mb-3 flex items-center space-x-2">
                                                    <i className={`${currentPriorityStyle.icon} ${currentPriorityStyle.text}`}></i>
                                                    <span>Priority Level</span>
                                                </label>
                                                <select
                                                    value={priority}
                                                    onChange={(e) => setPriority(e.target.value)}
                                                    className="w-full py-4 px-6 bg-gray-900/50 border border-gray-700 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-orange-500/50 focus:border-orange-400/50 transition-all duration-300"
                                                >
                                                    <option value="low">🟢 Low Priority - Minor improvements</option>
                                                    <option value="medium">🟡 Medium Priority - Important features</option>
                                                    <option value="high">🔴 High Priority - Critical & urgent</option>
                                                </select>
                                                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-orange-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
                                            </div>
                                        </div>

                                        <div className="group relative">
                                            <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                            <div className="relative">
                                                <label className="block text-gray-300 text-sm font-bold mb-3 flex items-center space-x-2">
                                                    <i className="fas fa-calendar-alt text-green-400"></i>
                                                    <span>Due Date *</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    value={dueDate}
                                                    onChange={(e) => setDueDate(e.target.value)}
                                                    className="w-full py-4 px-6 bg-gray-900/50 border border-gray-700 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-green-500/50 focus:border-green-400/50 transition-all duration-300"
                                                    required
                                                />
                                                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-green-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'assignments' && (
                                <div className="p-8 space-y-6 animate-fadeIn">
                                    <div className="relative group">
                                        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-purple-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="relative">
                                            <div className="flex items-center space-x-3 mb-6">
                                                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-xl flex items-center justify-center animate-pulse">
                                                    <i className="fas fa-users text-indigo-400 text-xl"></i>
                                                </div>
                                                <div>
                                                    <h4 className="text-xl font-bold text-white">Team Assignment</h4>
                                                    <p className="text-gray-400">Select team members for this task</p>
                                                </div>
                                            </div>
                                            
                                            <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6 max-h-80 overflow-y-auto custom-scrollbar">
                                                {allAdmins.length === 0 ? (
                                                    <div className="text-center py-12">
                                                        <div className="w-16 h-16 bg-gradient-to-br from-gray-500/20 to-gray-600/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                                                            <i className="fas fa-user-slash text-gray-400 text-2xl"></i>
                                                        </div>
                                                        <p className="text-gray-400 text-lg">No team members found</p>
                                                        <p className="text-gray-500 text-sm">Add administrators to assign tasks</p>
                                                    </div>
                                                ) : (
                                                    <div className="space-y-4">
                                                        {allAdmins.map((admin, index) => (
                                                            <div key={admin.uid} className="group/admin relative animate-slideInLeft" style={{ animationDelay: `${index * 0.1}s` }}>
                                                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl opacity-0 group-hover/admin:opacity-100 transition-opacity duration-300"></div>
                                                                <div className="relative flex items-center justify-between p-4 border border-gray-600/30 rounded-xl hover:border-gray-500/50 transition-all duration-300">
                                                                    <div className="flex items-center space-x-4">
                                                                        <div 
                                                                            className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-lg"
                                                                            style={{ backgroundColor: admin.color || '#4d9eff' }}
                                                                        >
                                                                            {(admin.username || admin.email).charAt(0).toUpperCase()}
                                                                        </div>
                                                                        <div>
                                                                            <h5 className="text-white font-medium text-lg">{admin.username || admin.email}</h5>
                                                                            <p className="text-gray-400 text-sm">Team Member</p>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <label className="relative inline-flex items-center cursor-pointer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedAdmins.includes(admin.uid)}
                                                                            onChange={() => handleAdminToggle(admin.uid)}
                                                                            className="sr-only peer"
                                                                        />
                                                                        <div className="relative">
                                                                            <div className="w-12 h-7 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300/50 rounded-full peer peer-checked:after:translate-x-5 peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-blue-600 peer-checked:to-purple-600 shadow-lg hover:scale-105 transition-transform duration-200"></div>
                                                                            {selectedAdmins.includes(admin.uid) && (
                                                                                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400/30 to-purple-400/30 animate-pulse"></div>
                                                                            )}
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover/admin:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            
                                            {selectedAdmins.length > 0 && (
                                                <div className="mt-6 relative group/summary animate-bounceIn">
                                                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-xl opacity-0 group-hover/summary:opacity-100 transition-opacity duration-300"></div>
                                                    <div className="relative bg-green-900/20 border border-green-500/30 rounded-xl p-4">
                                                        <div className="flex items-center space-x-3">
                                                            <div className="w-10 h-10 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-full flex items-center justify-center">
                                                                <i className="fas fa-check-circle text-green-400"></i>
                                                            </div>
                                                            <div>
                                                                <h5 className="text-green-400 font-bold">
                                                                    {selectedAdmins.length} Team Member{selectedAdmins.length > 1 ? 's' : ''} Assigned
                                                                </h5>
                                                                <p className="text-green-200/80 text-sm">Task assignments are ready</p>
                                                            </div>
                                                        </div>
                                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/10 to-transparent translate-x-[-100%] group-hover/summary:translate-x-[100%] transition-transform duration-700"></div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'tasks' && (
                                <div className="p-8 space-y-6 animate-fadeIn">
                                    <div className="relative group">
                                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <div className="relative">
                                            <div className="flex items-center justify-between mb-6">
                                                <div className="flex items-center space-x-3">
                                                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-xl flex items-center justify-center animate-pulse">
                                                        <i className="fas fa-list-check text-purple-400 text-xl"></i>
                                                    </div>
                                                    <div>
                                                        <h4 className="text-xl font-bold text-white">Task Breakdown</h4>
                                                        <p className="text-gray-400">Break down your task into manageable subtasks</p>
                                                    </div>
                                                </div>
                                                
                                                <button
                                                    type="button"
                                                    onClick={addTodoItem}
                                                    className="group relative overflow-hidden bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
                                                >
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                                    <div className="relative flex items-center space-x-2">
                                                        <i className="fas fa-plus group-hover:rotate-90 transition-transform duration-300"></i>
                                                        <span>Add Task Item</span>
                                                    </div>
                                                </button>
                                            </div>
                                            
                                            <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6 max-h-80 overflow-y-auto custom-scrollbar">
                                                {todos.length === 0 ? (
                                                    <div className="text-center py-12">
                                                        <div className="w-16 h-16 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4 animate-float">
                                                            <i className="fas fa-clipboard-list text-purple-400 text-2xl"></i>
                                                        </div>
                                                        <h5 className="text-white text-lg font-bold mb-2">No task items yet</h5>
                                                        <p className="text-gray-400">Break down your task into smaller, actionable items</p>
                                                        <button
                                                            type="button"
                                                            onClick={addTodoItem}
                                                            className="mt-4 group relative overflow-hidden bg-gradient-to-r from-purple-600/20 to-pink-600/20 hover:from-purple-600/40 hover:to-pink-600/40 border border-purple-500/30 hover:border-purple-400/50 text-purple-400 hover:text-purple-300 py-2 px-4 rounded-lg transition-all duration-300"
                                                        >
                                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></div>
                                                            <div className="relative flex items-center space-x-2">
                                                                <i className="fas fa-plus"></i>
                                                                <span>Create First Item</span>
                                                            </div>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="space-y-4">
                                                        {todos.map((todo, index) => (
                                                            <div key={todo.id} className="group/todo relative animate-slideInLeft" style={{ animationDelay: `${index * 0.1}s` }}>
                                                                {/* Main Todo Item */}
                                                                <div className="relative overflow-hidden group/item">
                                                                    <div className="absolute inset-0 bg-gradient-to-r from-gray-700/20 to-gray-600/20 rounded-xl opacity-0 group-hover/item:opacity-100 transition-opacity duration-300"></div>
                                                                    <div className="relative flex items-center space-x-4 p-4 bg-gradient-to-r from-gray-800/50 to-gray-700/30 border border-gray-600/30 rounded-xl hover:border-gray-500/50 transition-all duration-300">
                                                                        {/* Checkbox */}
                                                                        <div className="relative">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={todo.completed}
                                                                                onChange={() => toggleTodoCompleted(todo.id)}
                                                                                className="sr-only peer"
                                                                            />
                                                                            <div className={`w-5 h-5 rounded-full border-2 ${todo.completed ? 'border-green-400 bg-green-500/20' : 'border-gray-500 bg-gray-700/50'} flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110`}>
                                                                                {todo.completed && (
                                                                                    <i className="fas fa-check text-green-400 text-xs animate-bounceIn"></i>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        {/* Task Input */}
                                                                        <input
                                                                            type="text"
                                                                            value={todo.text}
                                                                            onChange={(e) => updateTodoText(todo.id, e.target.value)}
                                                                            placeholder="Enter task item..."
                                                                            className="flex-1 bg-transparent text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500/50 rounded-lg p-2 transition-all duration-300"
                                                                        />
                                                                        
                                                                        {/* Action Buttons */}
                                                                        <div className="flex items-center space-x-2">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => addSubtask(todo.id)}
                                                                                className="group relative overflow-hidden w-8 h-8 bg-blue-600/20 hover:bg-blue-600/40 border border-blue-500/30 hover:border-blue-400/50 rounded-lg transition-all duration-300"
                                                                                title="Add Subtask"
                                                                            >
                                                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></div>
                                                                                <i className="fas fa-plus relative text-blue-400 text-xs"></i>
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => removeTodoItem(todo.id)}
                                                                                className="group relative overflow-hidden w-8 h-8 bg-red-600/20 hover:bg-red-600/40 border border-red-500/30 hover:border-red-400/50 rounded-lg transition-all duration-300"
                                                                                title="Remove Item"
                                                                            >
                                                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500"></div>
                                                                                <i className="fas fa-trash relative text-red-400 text-xs"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover/item:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
                                                                </div>

                                                                {/* Subtasks */}
                                                                {todo.subtasks && todo.subtasks.map((subtask, subIndex) => (
                                                                    <div key={subtask.id} className="ml-8 mt-3 group/subtask relative" style={{ animationDelay: `${(index + subIndex) * 0.05}s` }}>
                                                                        <div className="absolute inset-0 bg-gradient-to-r from-gray-600/20 to-gray-500/20 rounded-lg opacity-0 group-hover/subtask:opacity-100 transition-opacity duration-300"></div>
                                                                        <div className="relative flex items-center space-x-3 p-3 bg-gradient-to-r from-gray-700/30 to-gray-600/20 border border-gray-600/20 rounded-lg hover:border-gray-500/30 transition-all duration-300">
                                                                            <div className="relative">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={subtask.completed}
                                                                                    onChange={() => toggleSubtaskCompleted(todo.id, subtask.id)}
                                                                                    className="sr-only"
                                                                                />
                                                                                <div className={`w-4 h-4 rounded-full border ${subtask.completed ? 'border-green-400 bg-green-500/20' : 'border-gray-500 bg-gray-700/50'} flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110`}>
                                                                                    {subtask.completed && (
                                                                                        <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            
                                                                            <input
                                                                                type="text"
                                                                                value={subtask.text}
                                                                                onChange={(e) => updateSubtaskText(todo.id, subtask.id, e.target.value)}
                                                                                placeholder="Enter subtask..."
                                                                                className="flex-1 bg-transparent text-gray-200 text-sm placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500/50 rounded p-1 transition-all duration-300"
                                                                            />
                                                                            
                                                                            <div className="flex items-center space-x-1">
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => addSubSubtask(todo.id, subtask.id)}
                                                                                    className="group w-6 h-6 bg-indigo-600/20 hover:bg-indigo-600/40 border border-indigo-500/30 hover:border-indigo-400/50 rounded transition-all duration-300"
                                                                                    title="Add Sub-subtask"
                                                                                >
                                                                                    <i className="fas fa-plus text-indigo-400 text-xs"></i>
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => removeSubtask(todo.id, subtask.id)}
                                                                                    className="group w-6 h-6 bg-red-600/20 hover:bg-red-600/40 border border-red-500/30 hover:border-red-400/50 rounded transition-all duration-300"
                                                                                    title="Remove Subtask"
                                                                                >
                                                                                    <i className="fas fa-trash text-red-400 text-xs"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        {/* Sub-subtasks */}
                                                                        {subtask.subSubtasks && subtask.subSubtasks.map((subSubtask, subSubIndex) => (
                                                                            <div key={subSubtask.id} className="ml-6 mt-2">
                                                                                <div className="flex items-center space-x-2 p-2 bg-gray-600/20 border border-gray-600/10 rounded transition-all duration-300 hover:border-gray-500/20">
                                                                                    <div className="relative">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={subSubtask.completed}
                                                                                            onChange={() => toggleSubSubtaskCompleted(todo.id, subtask.id, subSubtask.id)}
                                                                                            className="sr-only"
                                                                                        />
                                                                                        <div className={`w-3 h-3 rounded-full ${subSubtask.completed ? 'bg-green-400' : 'bg-gray-500'} cursor-pointer transition-all duration-300 hover:scale-110`}></div>
                                                                                    </div>
                                                                                    
                                                                                    <input
                                                                                        type="text"
                                                                                        value={subSubtask.text}
                                                                                        onChange={(e) => updateSubSubtaskText(todo.id, subtask.id, subSubtask.id, e.target.value)}
                                                                                        placeholder="Enter sub-subtask..."
                                                                                        className="flex-1 bg-transparent text-gray-300 text-xs placeholder-gray-600 focus:outline-none focus:ring-1 focus:ring-purple-500/50 rounded p-1 transition-all duration-300"
                                                                                    />
                                                                                    
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => removeSubSubtask(todo.id, subtask.id, subSubtask.id)}
                                                                                        className="w-5 h-5 bg-red-600/20 hover:bg-red-600/40 border border-red-500/30 hover:border-red-400/50 rounded transition-all duration-300"
                                                                                        title="Remove Sub-subtask"
                                                                                    >
                                                                                        <i className="fas fa-trash text-red-400 text-xs"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>

                    {/* Footer Actions */}
                    <div className="relative p-8 border-t border-gray-700/50">
                        <div className="flex items-center space-x-4">
                            {todoData && (
                                <button
                                    type="button"
                                    onClick={() => onDelete(todoData.id)}
                                    className="group relative overflow-hidden flex-1 bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-500 shadow-lg hover:shadow-xl hover:scale-105"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                    <div className="relative flex items-center justify-center space-x-3">
                                        <i className="fas fa-trash group-hover:rotate-12 transition-transform duration-300"></i>
                                        <span>Delete Task</span>
                                    </div>
                                </button>
                            )}
                            
                            <button
                                type="button"
                                onClick={onClose}
                                className="group relative overflow-hidden flex-1 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-500 shadow-lg hover:shadow-xl hover:scale-105"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                <div className="relative flex items-center justify-center space-x-3">
                                    <i className="fas fa-times group-hover:rotate-90 transition-transform duration-300"></i>
                                    <span>Cancel</span>
                                </div>
                            </button>
                            
                            <button
                                type="submit"
                                onClick={handleSubmit}
                                className="group relative overflow-hidden flex-1 bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 hover:from-blue-700 hover:via-purple-700 hover:to-indigo-700 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-500 shadow-2xl hover:shadow-blue-500/50 hover:shadow-3xl hover:scale-105"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                <div className="relative flex items-center justify-center space-x-3">
                                    <i className="fas fa-rocket group-hover:translate-y-[-2px] transition-transform duration-300"></i>
                                    <span>{todoData ? 'Update Task' : 'Create Task'}</span>
                                    <div className="w-2 h-2 bg-white rounded-full animate-ping opacity-70"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                    
                    {/* Shimmer overlay effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-2000 pointer-events-none"></div>
                </div>
            </div>
        </div>
    );
}

const AdminTemplates = ({ user, db, setModalMessage, appId }) => {
    const [templates, setTemplates] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [error, setError] = useState('');

    // Fetch templates from Firestore
    useEffect(() => {
        if (!db || !appId) return;

        const templatesCollectionRef = collection(db, `artifacts/${appId}/public/data/templates`);
        const q = query(templatesCollectionRef);

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedTemplates = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setTemplates(fetchedTemplates);
        }, (err) => {
            console.error("Error fetching templates:", err);
            setModalMessage(`Error loading templates: ${err.message}`);
        });

        return () => unsubscribe();
    }, [db, setModalMessage, appId]);

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
            setError('');
        } else {
            setSelectedFile(null);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setError('Please select a file to upload.');
            return;
        }
        if (!user || !db || !appId) {
            setModalMessage("User not authenticated, database not available, or app ID missing.");
            return;
        }

        setUploading(true);
        setUploadProgress(0);
        setError('');

        try {
            const storage = getStorage();
            // Define the storage path: artifacts/{appId}/public/data/templates/{filename}
            const storageRef = ref(storage, `artifacts/${appId}/public/data/templates/${selectedFile.name}`);
            const uploadTask = uploadBytesResumable(storageRef, selectedFile);

            uploadTask.on('state_changed', 
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setUploadProgress(progress);
                    console.log('Upload is ' + progress.toFixed(2) + '% done'); // More detailed logging
                    console.log('Bytes transferred:', snapshot.bytesTransferred);
                    console.log('Total bytes:', snapshot.totalBytes);
                }, 
                (err) => {
                    console.error("Upload error:", err);
                    setError(`Upload failed: ${err.message}`);
                    setUploading(false);
                }, 
                async () => {
                    // Upload completed successfully, now get the download URL
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    
                    // Save template metadata to Firestore
                    const templatesCollectionRef = collection(db, `artifacts/${appId}/public/data/templates`);
                    await addDoc(templatesCollectionRef, {
                        name: selectedFile.name,
                        size: selectedFile.size,
                        type: selectedFile.type,
                        downloadURL: downloadURL,
                        storagePath: `artifacts/${appId}/public/data/templates/${selectedFile.name}`,
                        uploadedBy: user.uid,
                        uploadedByName: user.displayName || user.email,
                        uploadedAt: new Date().toISOString()
                    });

                    setModalMessage(`Template "${selectedFile.name}" uploaded successfully!`);
                    setSelectedFile(null);
                    setUploading(false);
                    setUploadProgress(0);
                }
            );
        } catch (err) {
            console.error("Error during upload process:", err);
            setError(`Failed to initiate upload: ${err.message}`);
            setUploading(false);
        }
    };

    const handleDownload = (url, fileName) => {
        // Create a temporary anchor element to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Suggests the filename for download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setModalMessage(`Downloading "${fileName}"...`);
    };

    return (
        <div className="glass-card rounded-2xl p-8 h-full flex flex-col relative overflow-hidden">
            {/* Ultra Hot Animated Background Effects */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-l from-blue-500/15 to-cyan-500/10 rounded-full blur-3xl opacity-60 animate-pulse-slow"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-r from-purple-500/15 to-indigo-500/10 rounded-full blur-3xl opacity-40 animate-float"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-full blur-2xl opacity-30 animate-spin-slow"></div>

            {/* Epic Header with Mind-Blowing Animations */}
            <div className="flex items-center justify-between mb-8 relative z-10">
                <div className="flex items-center group">
                    <div className="relative mr-6">
                        <div className="absolute inset-0 bg-gradient-to-r from-orange-500/40 to-yellow-500/40 rounded-2xl blur-xl group-hover:blur-2xl transition-all animate-pulse"></div>
                        <div className="relative w-16 h-16 bg-gradient-to-br from-orange-500/25 to-yellow-500/25 rounded-2xl flex items-center justify-center backdrop-blur-sm border-2 border-orange-400/40 transform transition-all duration-500 group-hover:scale-125 group-hover:rotate-12 shadow-xl group-hover:shadow-orange-500/50">
                            <i className="fas fa-file-alt text-2xl text-orange-400 animate-float transition-all duration-500 group-hover:text-orange-200 group-hover:animate-bounce"></i>
                        </div>
                        <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full animate-spin border-2 border-white/30 flex items-center justify-center">
                            <i className="fas fa-cloud text-white text-xs animate-pulse"></i>
                        </div>
                    </div>
                    <div className="transition-all duration-300 group-hover:translate-x-3">
                        <div className="flex items-center space-x-3 mb-2">
                            <h3 className="text-4xl font-bold bg-gradient-to-r from-orange-400 via-yellow-400 to-red-400 bg-clip-text text-transparent animate-fadeIn">
                                Templates Management
                            </h3>
                            <div className="px-4 py-2 bg-orange-500/20 text-orange-300 rounded-full text-sm font-semibold animate-pulse border border-orange-400/30">
                                {templates.length} Files
                            </div>
                        </div>
                        <p className="text-gray-400 text-lg animate-fadeIn" style={{ animationDelay: '0.2s' }}>
                            Upload, manage, and share templates with epic style ⚡
                        </p>
                        <div className="h-1 w-0 bg-gradient-to-r from-orange-400 to-yellow-400 animate-[width-expand_2s_ease-out_0.5s_forwards] rounded-full mt-2"></div>
                    </div>
                </div>
            </div>

            {/* Ultra Hot Upload Section */}
            <div className="relative group mb-8 z-10">
                {/* Floating Animation Container */}
                <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 via-emerald-500/15 to-teal-500/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-all duration-700 animate-pulse"></div>
                
                <div className="relative bg-gradient-to-br from-gray-900/80 via-gray-800/90 to-gray-900/80 backdrop-blur-xl p-8 rounded-2xl border-2 border-green-500/30 hover:border-green-400/50 transition-all duration-500 transform hover:scale-[1.02] hover:-translate-y-1 shadow-2xl hover:shadow-green-500/25">
                    
                    {/* Epic Header */}
                    <div className="flex items-center mb-6">
                        <div className="relative mr-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-green-500/30 to-emerald-500/30 rounded-xl flex items-center justify-center transition-all duration-500 group-hover:scale-110 group-hover:rotate-12 border border-green-400/40">
                                <i className="fas fa-upload text-green-400 text-xl group-hover:text-green-200 transition-colors duration-300 animate-bounce"></i>
                            </div>
                            <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-emerald-400 to-green-400 rounded-full animate-ping"></div>
                        </div>
                        <h4 className="text-2xl font-bold bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
                            Upload New Template
                        </h4>
                    </div>
                    
                    {error && (
                        <div className="mb-6 p-4 bg-red-500/20 border border-red-500/40 rounded-xl text-red-300 text-center animate-slideInDown backdrop-blur-sm">
                            <i className="fas fa-exclamation-triangle mr-2 animate-bounce"></i>
                            {error}
                        </div>
                    )}
                    
                    <div className="space-y-6">
                        {/* Epic File Upload Area */}
                        <div className="relative group/drop">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-xl blur-md opacity-0 group-hover/drop:opacity-100 transition-all duration-500"></div>
                            <div className="relative border-2 border-dashed border-white/30 hover:border-blue-400/60 rounded-2xl p-12 text-center transition-all duration-500 transform hover:scale-105 backdrop-blur-sm">
                                <input 
                                    type="file" 
                                    onChange={handleFileChange} 
                                    className="hidden"
                                    id="file-upload"
                                />
                                <label htmlFor="file-upload" className="cursor-pointer group/label">
                                    <div className="relative mb-6">
                                        <div className="absolute inset-0 bg-blue-500/20 rounded-2xl blur-lg opacity-0 group-hover/label:opacity-100 transition-all duration-500 animate-pulse"></div>
                                        <div className="relative w-20 h-20 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-2xl flex items-center justify-center mx-auto transition-all duration-500 group-hover/label:scale-110 group-hover/label:rotate-6 border border-blue-400/40">
                                            <i className="fas fa-cloud-upload-alt text-3xl text-blue-400 group-hover/label:text-blue-200 transition-colors duration-300 animate-float"></i>
                                        </div>
                                    </div>
                                    <p className="text-white font-bold text-lg mb-2 group-hover/label:text-blue-300 transition-colors duration-300">Choose file to upload</p>
                                    <p className="text-gray-400 text-base group-hover/label:text-gray-300 transition-colors duration-300">Click to browse files or drag & drop</p>
                                </label>
                            </div>
                        </div>
                        
                        {selectedFile && (
                            <div className="p-6 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl border border-blue-500/30 animate-slideInLeft backdrop-blur-sm">
                                <div className="flex items-center space-x-4">
                                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500/30 to-purple-500/30 rounded-2xl flex items-center justify-center animate-pulse border border-blue-400/40">
                                        <i className="fas fa-file text-blue-400 text-2xl"></i>
                                    </div>
                                    <div className="flex-1">
                                        <p className="text-white font-bold text-lg">Selected File:</p>
                                        <p className="text-blue-300 font-semibold text-base">{selectedFile.name}</p>
                                        <p className="text-gray-400 text-sm">
                                            {(selectedFile.size / 1024 / 1024).toFixed(2)} MB • {selectedFile.type || 'Unknown type'}
                                        </p>
                                    </div>
                                    <div className="ml-auto">
                                        <div className="w-16 h-16 bg-gradient-to-r from-green-500/20 to-emerald-500/20 rounded-full flex items-center justify-center animate-spin-slow border-2 border-green-400/30">
                                            <i className="fas fa-check text-green-400 text-xl animate-pulse"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        {/* Epic Upload Button */}
                        <button
                            onClick={handleUpload}
                            className={`group/btn relative w-full py-4 font-bold rounded-2xl transition-all duration-500 transform overflow-hidden ${
                                !selectedFile || uploading 
                                    ? 'bg-white/10 text-gray-400 cursor-not-allowed' 
                                    : 'bg-gradient-to-r from-green-500/25 to-emerald-500/25 hover:from-green-500/40 hover:to-emerald-500/40 border-2 border-green-500/40 hover:border-green-400/60 text-white hover:scale-110 hover:-translate-y-2 hover:rotate-1 shadow-xl hover:shadow-2xl hover:shadow-green-500/40 animate-glow'
                            }`}
                            disabled={!selectedFile || uploading}
                        >
                            <div className="absolute inset-0 bg-gradient-to-r from-green-600/30 to-emerald-600/30 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-500"></div>
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-200%] group-hover/btn:translate-x-[200%] transition-transform duration-1000"></div>
                            <div className="relative z-10 flex items-center justify-center space-x-3">
                                {uploading ? (
                                    <>
                                        <div className="w-6 h-6 bg-emerald-400/30 rounded-lg flex items-center justify-center">
                                            <i className="fas fa-spinner fa-spin text-emerald-300 animate-spin"></i>
                                        </div>
                                        <span className="text-lg">Uploading ({uploadProgress.toFixed(0)}%)</span>
                                    </>
                                ) : (
                                    <>
                                        <div className="w-6 h-6 bg-green-400/30 rounded-lg flex items-center justify-center transition-all duration-300 group-hover/btn:rotate-180 group-hover/btn:scale-125">
                                            <i className="fas fa-cloud-upload-alt text-green-400 group-hover/btn:text-green-200"></i>
                                        </div>
                                        <span className="text-lg">Upload Template</span>
                                        <div className="flex space-x-1">
                                            <div className="w-1 h-1 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '0s' }}></div>
                                            <div className="w-1 h-1 bg-emerald-400 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
                                            <div className="w-1 h-1 bg-teal-400 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </button>
                        
                        {uploading && (
                            <div className="relative w-full bg-gray-700/50 rounded-full h-4 overflow-hidden animate-slideInUp backdrop-blur-sm border border-gray-600/50">
                                <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-emerald-500/20 animate-pulse"></div>
                                <div 
                                    className="bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 h-full rounded-full transition-all duration-300 animate-glow shadow-lg shadow-green-500/50" 
                                    style={{ width: `${uploadProgress}%` }}
                                >
                                    <div className="h-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Ultra Hot Templates List Section */}
            <div className="relative flex-grow overflow-hidden z-10">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 via-purple-500/5 to-pink-500/10 rounded-2xl blur-xl opacity-50 animate-pulse-slow"></div>
                
                <div className="relative h-full bg-gradient-to-br from-gray-900/90 via-gray-800/95 to-gray-900/90 backdrop-blur-xl p-8 rounded-2xl border-2 border-purple-500/30 hover:border-purple-400/50 transition-all duration-500 shadow-2xl hover:shadow-purple-500/25">
                    
                    {/* Epic List Header */}
                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center">
                            <div className="relative mr-4">
                                <div className="w-12 h-12 bg-gradient-to-br from-purple-500/30 to-pink-500/30 rounded-xl flex items-center justify-center transition-all duration-500 hover:scale-110 hover:rotate-6 border border-purple-400/40">
                                    <i className="fas fa-list-alt text-purple-400 text-xl hover:text-purple-200 transition-colors duration-300"></i>
                                </div>
                                <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full animate-bounce"></div>
                            </div>
                            <h4 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                                Available Templates
                            </h4>
                        </div>
                        
                        {/* Stats Badge */}
                        {templates.length > 0 && (
                            <div className="px-4 py-2 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 rounded-full border border-indigo-400/30 animate-pulse backdrop-blur-sm">
                                <span className="text-indigo-300 font-semibold text-sm">
                                    {templates.length} Template{templates.length !== 1 ? 's' : ''} Available
                                </span>
                            </div>
                        )}
                    </div>
                    
                    <div className="h-full overflow-y-auto custom-scrollbar pr-2">
                        {templates.length === 0 ? (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center animate-fadeIn">
                                    <div className="relative mb-8">
                                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-full blur-2xl animate-pulse"></div>
                                        <div className="relative w-32 h-32 bg-gradient-to-br from-purple-500/10 to-pink-500/10 rounded-full flex items-center justify-center mx-auto border-2 border-purple-500/30">
                                            <i className="fas fa-folder-open text-6xl text-purple-400 animate-float"></i>
                                        </div>
                                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full flex items-center justify-center animate-bounce border-2 border-white/20">
                                            <i className="fas fa-plus text-white text-sm"></i>
                                        </div>
                                    </div>
                                    <h3 className="text-3xl font-bold text-white mb-4 animate-pulse">No Templates Yet</h3>
                                    <p className="text-gray-400 text-lg mb-6 max-w-md mx-auto">
                                        Start building your template library! Upload your first template to get started. 🚀
                                    </p>
                                    <div className="flex justify-center space-x-2">
                                        <div className="w-2 h-2 bg-purple-400 rounded-full animate-ping"></div>
                                        <div className="w-2 h-2 bg-pink-400 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
                                        <div className="w-2 h-2 bg-indigo-400 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 gap-6">
                                {templates.map((template, index) => (
                                    <div
                                        key={template.id}
                                        className="group relative bg-gradient-to-r from-gray-800/50 via-gray-700/60 to-gray-800/50 backdrop-blur-sm p-6 rounded-2xl border-2 border-indigo-500/30 hover:border-indigo-400/50 transition-all duration-500 transform hover:scale-105 hover:-translate-y-2 hover:shadow-2xl hover:shadow-indigo-500/25 animate-fadeIn overflow-hidden"
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                    >
                                        {/* Animated Background Effects */}
                                        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 via-purple-500/5 to-pink-500/10 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>
                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1200"></div>
                                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-l from-purple-400/15 to-transparent rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                        
                                        <div className="relative z-10 flex items-start justify-between">
                                            <div className="flex items-start space-x-4 flex-1">
                                                {/* File Type Icon */}
                                                <div className="relative flex-shrink-0">
                                                    <div className="w-16 h-16 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-2xl flex items-center justify-center transition-all duration-500 group-hover:scale-110 group-hover:rotate-6 border-2 border-indigo-500/30 hover:border-indigo-400/50 shadow-lg group-hover:shadow-indigo-500/25">
                                                        <i className={`text-2xl text-indigo-400 group-hover:text-indigo-200 transition-colors duration-300 ${
                                                            template.type?.includes('image') ? 'fas fa-image' :
                                                            template.type?.includes('video') ? 'fas fa-video' :
                                                            template.type?.includes('pdf') ? 'fas fa-file-pdf' :
                                                            template.type?.includes('text') ? 'fas fa-file-alt' :
                                                            template.type?.includes('zip') || template.type?.includes('compressed') ? 'fas fa-file-archive' :
                                                            'fas fa-file'
                                                        }`}></i>
                                                    </div>
                                                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full text-xs flex items-center justify-center text-white font-bold animate-pulse border-2 border-white/20">
                                                        <i className="fas fa-check text-xs"></i>
                                                    </div>
                                                </div>
                                                
                                                <div className="min-w-0 flex-1">
                                                    {/* File Name */}
                                                    <h5 className="text-xl font-bold text-white group-hover:text-indigo-200 transition-all duration-300 transform group-hover:translate-x-1 leading-tight mb-3 break-words">
                                                        {template.name}
                                                    </h5>
                                                    
                                                    {/* File Details */}
                                                    <div className="space-y-2 text-sm text-gray-400 group-hover:text-gray-300 transition-colors duration-300">
                                                        <div className="flex items-center">
                                                            <i className="fas fa-user mr-2 text-blue-400"></i>
                                                            <span className="font-medium">{template.uploadedByName}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <i className="fas fa-calendar mr-2 text-purple-400"></i>
                                                            <span>{new Date(template.uploadedAt).toLocaleDateString()}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <i className="fas fa-weight-hanging mr-2 text-orange-400"></i>
                                                            <span>{(template.size / 1024 / 1024).toFixed(2)} MB</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <i className="fas fa-file-code mr-2 text-green-400"></i>
                                                            <span className="px-2 py-1 bg-green-500/20 text-green-300 rounded-md text-xs font-medium">
                                                                {template.type || 'Unknown'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Epic Download Button */}
                                            <button
                                                onClick={() => handleDownload(template.downloadURL, template.name)}
                                                className="group/download relative px-6 py-3 bg-gradient-to-r from-green-500/25 to-emerald-500/25 hover:from-green-500/40 hover:to-emerald-500/40 border-2 border-green-500/40 hover:border-green-400/60 backdrop-blur-xl text-green-300 hover:text-green-200 font-bold rounded-xl transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 hover:rotate-3 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 animate-glow overflow-hidden ml-4"
                                            >
                                                <div className="absolute inset-0 bg-gradient-to-r from-green-600/30 to-emerald-600/30 opacity-0 group-hover/download:opacity-100 transition-opacity duration-500"></div>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover/download:translate-x-[100%] transition-transform duration-700"></div>
                                                <div className="relative z-10 flex items-center space-x-2">
                                                    <div className="w-5 h-5 bg-green-400/20 rounded-lg flex items-center justify-center transition-all duration-300 group-hover/download:rotate-180 group-hover/download:scale-125">
                                                        <i className="fas fa-download text-sm"></i>
                                                    </div>
                                                    <span>Download</span>
                                                    <div className="flex space-x-0.5">
                                                        <div className="w-0.5 h-0.5 bg-green-400 rounded-full animate-ping opacity-0 group-hover/download:opacity-100" style={{ animationDelay: '0s' }}></div>
                                                        <div className="w-0.5 h-0.5 bg-emerald-400 rounded-full animate-ping opacity-0 group-hover/download:opacity-100" style={{ animationDelay: '0.1s' }}></div>
                                                        <div className="w-0.5 h-0.5 bg-teal-400 rounded-full animate-ping opacity-0 group-hover/download:opacity-100" style={{ animationDelay: '0.2s' }}></div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                        
                                        {/* Progress Indicator */}
                                        <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const AdminAllServers = ({ db, setModalMessage }) => {
    const [allServers, setAllServers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');

    useEffect(() => {
        if (!db) return;

        // Fetch from the top-level 'servers' collection
        const allServersCollectionRef = collection(db, `servers`);
        const q = query(allServersCollectionRef);

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const serversData = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setAllServers(serversData);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching all servers:", error);
            setModalMessage(`Error loading all servers: ${error.message}`);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [db, setModalMessage]);

    const filteredServers = allServers.filter(server => {
        const matchesSearch = server.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            server.ip?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            server.owner?.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === 'all' || server.status === statusFilter;
        return matchesSearch && matchesStatus;
    });

    if (loading) {
        return (
            <div className="relative overflow-hidden h-full">
                {/* Epic Loading Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 via-blue-500/5 to-indigo-500/10 animate-pulse"></div>
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-cyan-500/20 to-transparent opacity-30 animate-float"></div>
                
                {/* Floating Loading Particles */}
                <div className="absolute top-10 left-10 w-3 h-3 bg-cyan-400/60 rounded-full animate-bounce"></div>
                <div className="absolute top-20 right-20 w-2 h-2 bg-blue-400/60 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
                <div className="absolute bottom-20 left-20 w-4 h-4 bg-indigo-400/40 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>

                <div className="relative h-full bg-gradient-to-br from-gray-900/95 via-gray-800/98 to-gray-900/95 backdrop-blur-2xl p-8 rounded-3xl border-2 border-cyan-500/30 shadow-2xl flex items-center justify-center">
                    <div className="text-center animate-fadeIn">
                        {/* Epic Loading Spinner */}
                        <div className="relative mb-8">
                            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/30 to-blue-500/30 rounded-full blur-xl animate-pulse"></div>
                            <div className="relative w-20 h-20 border-4 border-cyan-500/30 border-t-cyan-400 border-r-blue-400 border-b-indigo-400 border-l-purple-400 rounded-full animate-spin mx-auto shadow-2xl"></div>
                        </div>
                        
                        <h3 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-4 animate-pulse">
                            Loading Epic Servers...
                        </h3>
                        <p className="text-gray-300 text-lg animate-pulse">
                            Fetching all the powerful server data! 🚀
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative overflow-hidden h-full">
            {/* Epic Animated Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-blue-500/3 to-indigo-500/5 animate-pulse-slow"></div>
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-cyan-500/10 to-transparent opacity-30 animate-float"></div>
            
            {/* Floating Background Particles */}
            <div className="absolute top-10 left-10 w-2 h-2 bg-cyan-400/60 rounded-full animate-ping"></div>
            <div className="absolute top-20 right-20 w-1 h-1 bg-blue-400/60 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
            <div className="absolute bottom-20 left-20 w-3 h-3 bg-indigo-400/40 rounded-full animate-bounce" style={{ animationDelay: '2s' }}></div>
            <div className="absolute bottom-10 right-40 w-1.5 h-1.5 bg-cyan-300/50 rounded-full animate-ping" style={{ animationDelay: '3s' }}></div>

            <div className="relative h-full bg-gradient-to-br from-gray-900/95 via-gray-800/98 to-gray-900/95 backdrop-blur-2xl p-6 rounded-3xl border-2 border-cyan-500/30 hover:border-cyan-400/50 transition-all duration-700 shadow-2xl hover:shadow-cyan-500/25 flex flex-col overflow-hidden">
                
                {/* Ultra Hot Header */}
                <div className="flex items-center justify-between mb-10 animate-fadeIn">
                    <div className="flex items-center">
                        {/* Epic Icon */}
                        <div className="relative mr-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/40 to-blue-500/40 rounded-2xl blur-xl animate-pulse"></div>
                            <div className="relative w-16 h-16 bg-gradient-to-br from-cyan-500/30 to-blue-500/30 rounded-2xl flex items-center justify-center transition-all duration-500 hover:scale-110 hover:rotate-12 border-2 border-cyan-500/40 hover:border-cyan-400/60 shadow-2xl hover:shadow-cyan-500/40 animate-glow">
                                <i className="fas fa-server text-2xl text-cyan-300 hover:text-cyan-100 transition-colors duration-300 animate-pulse"></i>
                            </div>
                            <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full flex items-center justify-center animate-bounce border-2 border-white/20">
                                <i className="fas fa-database text-white text-xs"></i>
                            </div>
                        </div>
                        
                        <div>
                            <h3 className="text-4xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-indigo-400 bg-clip-text text-transparent hover:from-cyan-300 hover:via-blue-300 hover:to-indigo-300 transition-all duration-500 transform hover:scale-105">
                                All Servers
                            </h3>
                            <p className="text-gray-300 text-lg font-medium animate-pulse">
                                Global server registry with epic style! 🖥️
                            </p>
                        </div>
                    </div>
                    
                    {/* Epic Stats Badge */}
                    <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/30 to-green-500/30 rounded-2xl blur-lg animate-pulse group-hover:blur-xl transition-all duration-500"></div>
                        <div className="relative text-right p-4 bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-xl rounded-2xl border-2 border-emerald-500/30 hover:border-emerald-400/50 transition-all duration-500 transform hover:scale-110 hover:-translate-y-2 shadow-xl hover:shadow-2xl hover:shadow-emerald-500/30">
                            <div className="text-4xl font-bold bg-gradient-to-r from-emerald-400 to-green-400 bg-clip-text text-transparent animate-pulse">
                                {allServers.length}
                            </div>
                            <div className="text-emerald-300 text-sm font-semibold flex items-center justify-end mt-1">
                                <i className="fas fa-server mr-2 animate-bounce"></i>
                                Total Servers
                            </div>
                            <div className="flex justify-end space-x-1 mt-2">
                                <div className="w-1 h-1 bg-emerald-400 rounded-full animate-ping"></div>
                                <div className="w-1 h-1 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
                                <div className="w-1 h-1 bg-cyan-400 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Epic Search and Filter Controls */}
                <div className="flex flex-col md:flex-row gap-6 mb-8 animate-fadeIn">
                    <div className="flex-1 relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-xl blur-sm opacity-0 group-focus-within:opacity-100 transition-opacity duration-300"></div>
                        <i className="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-blue-400 z-10 group-focus-within:text-blue-300 transition-colors duration-300"></i>
                        <input
                            type="text"
                            placeholder="Search servers by name, IP, or owner... 🔍"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="relative w-full pl-12 pr-4 py-4 bg-gradient-to-r from-gray-800/80 to-gray-900/80 backdrop-blur-xl border-2 border-blue-500/20 focus:border-blue-400/50 rounded-xl text-white placeholder-gray-400 focus:outline-none transition-all duration-500 shadow-lg focus:shadow-blue-500/20 text-lg"
                        />
                    </div>
                    
                    {/* Epic Filter Buttons */}
                    <div className="flex gap-3">
                        {['all', 'online', 'offline'].map((status, index) => (
                            <button
                                key={status}
                                onClick={() => setStatusFilter(status)}
                                className={`group relative px-6 py-4 rounded-xl font-bold transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 shadow-lg overflow-hidden ${
                                    statusFilter === status 
                                        ? 'bg-gradient-to-r from-cyan-500/30 to-blue-500/30 text-cyan-300 border-2 border-cyan-500/50 hover:shadow-cyan-500/30' 
                                        : 'bg-gradient-to-r from-gray-700/50 to-gray-800/50 text-gray-400 border-2 border-gray-600/30 hover:bg-gradient-to-r hover:from-gray-600/60 hover:to-gray-700/60 hover:text-gray-200 hover:shadow-gray-500/20'
                                } backdrop-blur-sm animate-fadeIn`}
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <div className="relative z-10 flex items-center space-x-2">
                                    <i className={`fas ${
                                        status === 'online' ? 'fa-circle text-green-400' :
                                        status === 'offline' ? 'fa-times-circle text-red-400' :
                                        'fa-list text-cyan-400'
                                    } animate-pulse`}></i>
                                    <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Epic Ultra Hot Servers Table */}
                <div className="flex-grow overflow-y-auto custom-scrollbar pr-2">
                {/* Epic Ultra Hot Server Table */}
                {filteredServers.length === 0 ? (
                    <div className="flex items-center justify-center h-full animate-fadeIn">
                        <div className="text-center">
                            <div className="relative mb-8">
                                <div className="absolute inset-0 bg-gradient-to-r from-gray-500/20 to-gray-600/20 rounded-full blur-3xl animate-pulse"></div>
                                <div className="relative w-32 h-32 bg-gradient-to-br from-gray-600/20 to-gray-700/20 rounded-full flex items-center justify-center mx-auto border-4 border-gray-500/30 shadow-2xl animate-float">
                                    <i className="fas fa-server text-6xl text-gray-400/60 animate-pulse"></i>
                                </div>
                            </div>
                            <h4 className="text-3xl font-bold text-gray-400 mb-4">No Servers Found</h4>
                            <p className="text-gray-500 text-lg max-w-md">
                                {searchTerm || statusFilter !== 'all' ? 
                                    `No servers match your current search or filter criteria.` :
                                    `Looks like there are no servers registered yet.`
                                }
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="relative">
                        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-transparent to-blue-500/5 rounded-2xl animate-pulse-slow"></div>
                        
                        {/* Epic Glassmorphism Table Container */}
                        <div className="relative overflow-hidden rounded-2xl border-2 border-cyan-500/20 hover:border-cyan-400/30 transition-all duration-700 shadow-2xl hover:shadow-cyan-500/20 backdrop-blur-xl bg-gradient-to-br from-gray-800/40 to-gray-900/60">
                            <div className="overflow-x-auto">
                                <table className="min-w-full">
                                    <thead className="sticky top-0 z-10">
                                        <tr className="bg-gradient-to-r from-cyan-500/20 via-blue-500/15 to-indigo-500/20 backdrop-blur-2xl border-b-2 border-cyan-500/30">
                                            <th className="py-6 px-8 text-left text-cyan-300 font-bold text-lg animate-fadeIn relative overflow-hidden">
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-server mr-3 animate-pulse"></i>
                                                    Server
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-blue-300 font-bold text-lg animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.1s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-network-wired mr-3 animate-bounce"></i>
                                                    IP Address
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-indigo-300 font-bold text-lg animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.2s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-indigo-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-heartbeat mr-3 animate-pulse"></i>
                                                    Status
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-purple-300 font-bold text-lg animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.3s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-users mr-3 animate-bounce"></i>
                                                    Players
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-pink-300 font-bold text-lg animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.4s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-pink-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-crown mr-3 animate-pulse"></i>
                                                    Owner
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredServers.map((server, index) => (
                                            <tr 
                                                key={server.id} 
                                                className="group relative border-b border-cyan-500/10 hover:border-cyan-400/30 transition-all duration-500 hover:bg-gradient-to-r hover:from-cyan-500/10 hover:via-blue-500/5 hover:to-indigo-500/10 animate-fadeIn transform hover:scale-[1.02] hover:shadow-lg hover:shadow-cyan-500/20"
                                                style={{ animationDelay: `${index * 0.05}s` }}
                                            >
                                                {/* Server Info Cell */}
                                                <td className="py-6 px-8 relative">
                                                    {/* Epic Row Background Effects */}
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-xl -z-10"></div>
                                                    <div className="flex items-center">
                                                        <div className={`relative mr-4 transition-all duration-500 group-hover:scale-110 group-hover:-translate-y-1`}>
                                                            <div className={`absolute inset-0 ${server.status === 'online' ? 'bg-gradient-to-br from-green-400/30 to-emerald-500/30' : 'bg-gradient-to-br from-red-400/30 to-rose-500/30'} rounded-xl blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse`}></div>
                                                            <div className={`relative w-14 h-14 ${server.status === 'online' ? 'bg-gradient-to-br from-green-500/20 to-emerald-500/20 border-2 border-green-400/40' : 'bg-gradient-to-br from-red-500/20 to-rose-500/20 border-2 border-red-400/40'} rounded-xl flex items-center justify-center shadow-lg transition-all duration-500 group-hover:shadow-2xl`}>
                                                                <i className={`fas fa-server text-xl ${server.status === 'online' ? 'text-green-400 group-hover:text-green-300' : 'text-red-400 group-hover:text-red-300'} transition-colors duration-300 animate-pulse`}></i>
                                                            </div>
                                                            <div className={`absolute -top-1 -right-1 w-5 h-5 ${server.status === 'online' ? 'bg-gradient-to-r from-green-400 to-emerald-400' : 'bg-gradient-to-r from-red-400 to-rose-400'} rounded-full flex items-center justify-center animate-bounce border-2 border-white/20`}>
                                                                <div className={`w-2 h-2 ${server.status === 'online' ? 'bg-green-200' : 'bg-red-200'} rounded-full animate-pulse`}></div>
                                                            </div>
                                                        </div>
                                                        <div className="transition-all duration-300 group-hover:translate-x-2">
                                                            <div className="text-white font-bold text-lg bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent group-hover:from-cyan-200 group-hover:to-blue-200 transition-all duration-300">
                                                                {server.name}
                                                            </div>
                                                            <div className="text-gray-400 text-sm font-medium group-hover:text-gray-300 transition-colors duration-300 flex items-center">
                                                                <i className="fas fa-map-marker-alt mr-2 animate-pulse"></i>
                                                                {server.region}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Connection (IP) Cell */}
                                                <td className="py-6 px-8 relative">
                                                    <div className="relative group/ip">
                                                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-indigo-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                        <div className="relative text-white font-mono text-base font-semibold group-hover:text-blue-300 transition-colors duration-300 p-3 bg-gradient-to-r from-gray-800/50 to-gray-900/50 rounded-lg border border-blue-500/20 group-hover:border-blue-400/40 shadow-lg group-hover:shadow-blue-500/20 transform group-hover:scale-105">
                                                            {server.ip}
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Status Cell */}
                                                <td className="py-6 px-8 relative">
                                                    <div className="relative">
                                                        <span className={`relative inline-flex items-center px-6 py-3 rounded-full text-sm font-bold transition-all duration-500 transform group-hover:scale-110 group-hover:-translate-y-1 shadow-lg ${
                                                            server.status === 'online' 
                                                                ? 'bg-gradient-to-r from-green-500/30 to-emerald-500/30 text-green-300 border-2 border-green-400/50 hover:shadow-green-500/40' 
                                                                : 'bg-gradient-to-r from-red-500/30 to-rose-500/30 text-red-300 border-2 border-red-400/50 hover:shadow-red-500/40'
                                                        }`}>
                                                            <div className={`absolute inset-0 ${server.status === 'online' ? 'bg-gradient-to-r from-green-400/20 to-emerald-400/20' : 'bg-gradient-to-r from-red-400/20 to-rose-400/20'} rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
                                                            <div className={`relative z-10 flex items-center space-x-2`}>
                                                                <div className={`w-3 h-3 ${server.status === 'online' ? 'bg-green-400' : 'bg-red-400'} rounded-full animate-pulse`}></div>
                                                                <span>{server.status?.toUpperCase() || 'UNKNOWN'}</span>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Players Cell */}
                                                <td className="py-6 px-8 relative">
                                                    <div className="relative group/players">
                                                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                        <div className="relative flex items-center space-x-3 p-3 bg-gradient-to-r from-gray-800/30 to-gray-900/30 rounded-lg border border-purple-500/20 group-hover:border-purple-400/40 shadow-lg group-hover:shadow-purple-500/20 transform group-hover:scale-105 backdrop-blur-sm">
                                                            <div className="relative">
                                                                <div className="absolute inset-0 bg-gradient-to-r from-blue-400/30 to-purple-400/30 rounded-full blur-sm animate-pulse"></div>
                                                                <div className="relative w-8 h-8 bg-gradient-to-r from-blue-500/40 to-purple-500/40 rounded-full flex items-center justify-center border-2 border-blue-400/50">
                                                                    <i className="fas fa-users text-blue-300 text-sm animate-bounce"></i>
                                                                </div>
                                                            </div>
                                                            <span className="text-white font-bold text-lg bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">
                                                                {server.players || '0'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Owner Cell */}
                                                <td className="py-6 px-8 relative">
                                                    <div className="relative group/owner">
                                                        <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 to-rose-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                        <div className="relative p-3 bg-gradient-to-r from-gray-800/30 to-gray-900/30 rounded-lg border border-pink-500/20 group-hover:border-pink-400/40 shadow-lg group-hover:shadow-pink-500/20 transform group-hover:scale-105 backdrop-blur-sm">
                                                            <div className="flex items-center space-x-3">
                                                                <div className="relative">
                                                                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/30 to-orange-400/30 rounded-full blur-sm animate-pulse"></div>
                                                                    <div className="relative w-8 h-8 bg-gradient-to-r from-yellow-500/40 to-orange-500/40 rounded-full flex items-center justify-center border-2 border-yellow-400/50">
                                                                        <i className="fas fa-crown text-yellow-300 text-sm animate-pulse"></i>
                                                                    </div>
                                                                </div>
                                                                <div className="text-white font-mono text-sm font-semibold bg-gradient-to-r from-pink-300 to-rose-300 bg-clip-text text-transparent break-all max-w-40 truncate group-hover:max-w-none transition-all duration-300">
                                                                    {server.owner || 'Unknown'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
        </div>
    );
};

const AdminAllUsers = ({ db, setModalMessage }) => {
    const [allUsers, setAllUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [roleFilter, setRoleFilter] = useState('all');

    useEffect(() => {
        if (!db) return;

        const usersCollectionRef = collection(db, 'users'); // Top-level users collection
        const q = query(usersCollectionRef);

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const usersData = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setAllUsers(usersData);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching all users:", error);
            setModalMessage(`Error loading all users: ${error.message}`);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [db, setModalMessage]);

    const filteredUsers = allUsers.filter(user => {
        const matchesSearch = user.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            user.uid?.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesRole = roleFilter === 'all' || user.role === roleFilter;
        return matchesSearch && matchesRole;
    });

    if (loading) {
        return (
            <div className="relative overflow-hidden h-full">
                {/* Epic Loading Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 via-pink-500/5 to-indigo-500/10 animate-pulse-slow"></div>
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-purple-500/20 to-transparent opacity-20 animate-float"></div>
                
                {/* Floating Background Particles */}
                <div className="absolute top-10 left-10 w-2 h-2 bg-purple-400/60 rounded-full animate-ping"></div>
                <div className="absolute top-20 right-20 w-1 h-1 bg-pink-400/60 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
                <div className="absolute bottom-20 left-20 w-3 h-3 bg-indigo-400/40 rounded-full animate-bounce" style={{ animationDelay: '2s' }}></div>
                <div className="absolute bottom-10 right-40 w-1.5 h-1.5 bg-purple-300/50 rounded-full animate-ping" style={{ animationDelay: '3s' }}></div>

                <div className="relative h-full bg-gradient-to-br from-gray-900/95 via-gray-800/98 to-gray-900/95 backdrop-blur-2xl p-12 rounded-3xl border-2 border-purple-500/30 shadow-2xl flex flex-col items-center justify-center">
                    
                    {/* Epic Ultra Hot Loading Spinner */}
                    <div className="relative mb-12">
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/40 to-pink-500/40 rounded-full blur-3xl animate-pulse"></div>
                        <div className="relative">
                            {/* Outer spinning ring */}
                            <div className="w-32 h-32 border-4 border-transparent border-t-purple-500 border-r-pink-500 rounded-full animate-spin"></div>
                            {/* Middle ring */}
                            <div className="absolute inset-4 w-24 h-24 border-4 border-transparent border-t-pink-400 border-r-purple-400 rounded-full animate-spin-reverse"></div>
                            {/* Inner core */}
                            <div className="absolute inset-8 w-16 h-16 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-full flex items-center justify-center animate-pulse backdrop-blur-xl border-2 border-purple-400/50">
                                <i className="fas fa-users text-3xl text-purple-300 animate-bounce"></i>
                            </div>
                        </div>
                        {/* Floating particles around spinner */}
                        <div className="absolute -top-4 -left-4 w-4 h-4 bg-purple-400/60 rounded-full animate-ping"></div>
                        <div className="absolute -top-2 -right-6 w-2 h-2 bg-pink-400/60 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                        <div className="absolute -bottom-4 -right-4 w-3 h-3 bg-indigo-400/60 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
                        <div className="absolute -bottom-2 -left-6 w-1 h-1 bg-purple-300/60 rounded-full animate-ping" style={{ animationDelay: '1.5s' }}></div>
                    </div>

                    {/* Epic Loading Text */}
                    <div className="text-center space-y-6">
                        <h3 className="text-4xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-indigo-400 bg-clip-text text-transparent animate-pulse">
                            Loading Epic Users
                        </h3>
                        <div className="flex items-center justify-center space-x-2 text-2xl">
                            <span className="text-purple-300 animate-bounce">👥</span>
                            <span className="text-pink-300 font-semibold animate-pulse">Fetching user data...</span>
                            <span className="text-indigo-300 animate-bounce" style={{ animationDelay: '0.5s' }}>🚀</span>
                        </div>
                        
                        {/* Loading progress dots */}
                        <div className="flex justify-center space-x-2 mt-6">
                            <div className="w-3 h-3 bg-purple-500/60 rounded-full animate-bounce"></div>
                            <div className="w-3 h-3 bg-pink-500/60 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                            <div className="w-3 h-3 bg-indigo-500/60 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
                            <div className="w-3 h-3 bg-purple-400/60 rounded-full animate-bounce" style={{ animationDelay: '0.6s' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative overflow-hidden h-full">
            {/* Epic Animated Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 via-pink-500/3 to-indigo-500/5 animate-pulse-slow"></div>
            <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-purple-500/10 to-transparent opacity-30 animate-float"></div>
            
            {/* Floating Background Particles */}
            <div className="absolute top-10 left-10 w-2 h-2 bg-purple-400/60 rounded-full animate-ping"></div>
            <div className="absolute top-20 right-20 w-1 h-1 bg-pink-400/60 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
            <div className="absolute bottom-20 left-20 w-3 h-3 bg-indigo-400/40 rounded-full animate-bounce" style={{ animationDelay: '2s' }}></div>
            <div className="absolute bottom-10 right-40 w-1.5 h-1.5 bg-purple-300/50 rounded-full animate-ping" style={{ animationDelay: '3s' }}></div>

            <div className="relative h-full bg-gradient-to-br from-gray-900/95 via-gray-800/98 to-gray-900/95 backdrop-blur-2xl p-6 rounded-3xl border-2 border-purple-500/30 hover:border-purple-400/50 transition-all duration-700 shadow-2xl hover:shadow-purple-500/25 flex flex-col overflow-hidden">
                
                {/* Ultra Hot Header */}
                <div className="flex items-center justify-between mb-10 animate-fadeIn">
                    <div className="flex items-center">
                        {/* Epic Icon */}
                        <div className="relative mr-6">
                            <div className="absolute inset-0 bg-gradient-to-r from-purple-500/40 to-pink-500/40 rounded-2xl blur-xl animate-pulse"></div>
                            <div className="relative w-16 h-16 bg-gradient-to-br from-purple-500/30 to-pink-500/30 rounded-2xl flex items-center justify-center transition-all duration-500 hover:scale-110 hover:rotate-12 border-2 border-purple-500/40 hover:border-purple-400/60 shadow-2xl hover:shadow-purple-500/40 animate-glow">
                                <i className="fas fa-users text-2xl text-purple-300 hover:text-purple-100 transition-colors duration-300 animate-pulse"></i>
                            </div>
                            <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-pink-400 to-rose-400 rounded-full flex items-center justify-center animate-bounce border-2 border-white/20">
                                <i className="fas fa-user-friends text-white text-xs"></i>
                            </div>
                        </div>
                        
                        <div>
                            <h3 className="text-4xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-indigo-400 bg-clip-text text-transparent hover:from-purple-300 hover:via-pink-300 hover:to-indigo-300 transition-all duration-500 transform hover:scale-105">
                                All Users
                            </h3>
                            <p className="text-gray-300 text-lg font-medium animate-pulse">
                                User account registry with epic style! 👥
                            </p>
                        </div>
                    </div>
                    
                    {/* Epic Stats Badge */}
                    <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-2xl blur-lg animate-pulse group-hover:blur-xl transition-all duration-500"></div>
                        <div className="relative text-right p-4 bg-gradient-to-br from-gray-800/80 to-gray-900/80 backdrop-blur-xl rounded-2xl border-2 border-purple-500/30 hover:border-purple-400/50 transition-all duration-500 transform hover:scale-110 hover:-translate-y-2 shadow-xl hover:shadow-2xl hover:shadow-purple-500/30">
                            <div className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent animate-pulse">
                                {allUsers.length}
                            </div>
                            <div className="text-purple-300 text-sm font-semibold flex items-center justify-end mt-1">
                                <i className="fas fa-users mr-2 animate-bounce"></i>
                                Total Users
                            </div>
                            <div className="flex justify-end space-x-1 mt-2">
                                <div className="w-1 h-1 bg-purple-400 rounded-full animate-ping"></div>
                                <div className="w-1 h-1 bg-pink-400 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
                                <div className="w-1 h-1 bg-indigo-400 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Epic Search and Filter Controls */}
                <div className="flex flex-col md:flex-row gap-6 mb-8 animate-fadeIn">
                    <div className="flex-1 relative group">
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-xl blur-sm opacity-0 group-focus-within:opacity-100 transition-opacity duration-300"></div>
                        <i className="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-purple-400 z-10 group-focus-within:text-purple-300 transition-colors duration-300"></i>
                        <input
                            type="text"
                            placeholder="Search users by username, email, or UID... 🔍"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="relative w-full pl-12 pr-4 py-4 bg-gradient-to-r from-gray-800/80 to-gray-900/80 backdrop-blur-xl border-2 border-purple-500/20 focus:border-purple-400/50 rounded-xl text-white placeholder-gray-400 focus:outline-none transition-all duration-500 shadow-lg focus:shadow-purple-500/20 text-lg"
                        />
                    </div>
                    
                    {/* Epic Filter Buttons */}
                    <div className="flex gap-3">
                        {['all', 'admin', 'user'].map((role, index) => (
                            <button
                                key={role}
                                onClick={() => setRoleFilter(role)}
                                className={`group relative px-6 py-4 rounded-xl font-bold transition-all duration-300 transform hover:scale-110 hover:-translate-y-1 shadow-lg overflow-hidden ${
                                    roleFilter === role 
                                        ? 'bg-gradient-to-r from-purple-500/30 to-pink-500/30 text-purple-300 border-2 border-purple-500/50 hover:shadow-purple-500/30' 
                                        : 'bg-gradient-to-r from-gray-700/50 to-gray-800/50 text-gray-400 border-2 border-gray-600/30 hover:bg-gradient-to-r hover:from-gray-600/60 hover:to-gray-700/60 hover:text-gray-200 hover:shadow-gray-500/20'
                                } backdrop-blur-sm animate-fadeIn`}
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <div className="relative z-10 flex items-center space-x-2">
                                    <i className={`fas ${
                                        role === 'admin' ? 'fa-crown text-yellow-400' :
                                        role === 'user' ? 'fa-user text-blue-400' :
                                        'fa-users text-purple-400'
                                    } animate-pulse`}></i>
                                    <span>{role.charAt(0).toUpperCase() + role.slice(1)}</span>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Epic Ultra Hot Users Table */}
                {filteredUsers.length === 0 ? (
                    <div className="flex-1 flex items-center justify-center animate-fadeIn">
                        <div className="text-center">
                            <div className="relative mb-8">
                                <div className="absolute inset-0 bg-gradient-to-r from-gray-500/20 to-gray-600/20 rounded-full blur-3xl animate-pulse"></div>
                                <div className="relative w-32 h-32 bg-gradient-to-br from-gray-600/20 to-gray-700/20 rounded-full flex items-center justify-center mx-auto border-4 border-gray-500/30 shadow-2xl animate-float">
                                    <i className="fas fa-users text-6xl text-gray-400/60 animate-pulse"></i>
                                </div>
                            </div>
                            <h4 className="text-3xl font-bold text-gray-400 mb-4">No Users Found</h4>
                            <p className="text-gray-500 text-lg max-w-md">
                                {searchTerm || roleFilter !== 'all' ? 
                                    `No users match your current search or filter criteria.` :
                                    `Looks like there are no user accounts found.`
                                }
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="flex-1 relative">
                        <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 via-transparent to-pink-500/5 rounded-2xl animate-pulse-slow"></div>
                        
                        {/* Epic Glassmorphism Table Container */}
                        <div className="relative h-full overflow-hidden rounded-2xl border-2 border-purple-500/20 hover:border-purple-400/30 transition-all duration-700 shadow-2xl hover:shadow-purple-500/20 backdrop-blur-xl bg-gradient-to-br from-gray-800/40 to-gray-900/60">
                            <div className="overflow-x-auto h-full">
                                <table className="min-w-full h-full">
                                    <thead className="sticky top-0 z-10">
                                        <tr className="bg-gradient-to-r from-purple-500/20 via-pink-500/15 to-indigo-500/20 backdrop-blur-2xl border-b-2 border-purple-500/30">
                                            <th className="py-6 px-8 text-left text-purple-300 font-bold text-lg animate-fadeIn relative overflow-hidden">
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-user mr-3 animate-pulse"></i>
                                                    User
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-pink-300 font-bold text-lg animate-fadeIn relative overflow-hidden w-80" style={{ animationDelay: '0.1s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-pink-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-envelope mr-3 animate-bounce"></i>
                                                    Contact
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-indigo-300 font-bold text-lg animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.2s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-indigo-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-user-shield mr-3 animate-pulse"></i>
                                                    Role
                                                </span>
                                            </th>
                                            <th className="py-6 px-8 text-left text-cyan-300 font-bold text-lg animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.3s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500/10 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                                                <span className="relative z-10 flex items-center">
                                                    <i className="fas fa-fingerprint mr-3 animate-bounce"></i>
                                                    User ID
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUsers.map((user, index) => (
                                            <tr 
                                                key={user.id} 
                                                className="group relative border-b border-purple-500/10 hover:border-purple-400/30 transition-all duration-500 hover:bg-gradient-to-r hover:from-purple-500/10 hover:via-pink-500/5 hover:to-indigo-500/10 animate-fadeIn transform hover:scale-[1.02] hover:shadow-lg hover:shadow-purple-500/20"
                                                style={{ animationDelay: `${index * 0.05}s` }}
                                            >
                                                {/* User Info Cell */}
                                                <td className="py-6 px-8 relative">
                                                    {/* Epic Row Background Effects */}
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-xl -z-10"></div>
                                                    <div className="flex items-center">
                                                        <div className={`relative mr-4 transition-all duration-500 group-hover:scale-110 group-hover:-translate-y-1`}>
                                                            <div className={`absolute inset-0 ${user.role === 'admin' ? 'bg-gradient-to-br from-purple-400/30 to-rose-500/30' : 'bg-gradient-to-br from-blue-400/30 to-cyan-500/30'} rounded-xl blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse`}></div>
                                                            <div className={`relative w-14 h-14 ${user.role === 'admin' ? 'bg-gradient-to-br from-purple-500/20 to-rose-500/20 border-2 border-purple-400/40' : 'bg-gradient-to-br from-blue-500/20 to-cyan-500/20 border-2 border-blue-400/40'} rounded-xl flex items-center justify-center shadow-lg transition-all duration-500 group-hover:shadow-2xl`}>
                                                                <i className={`fas ${user.role === 'admin' ? 'fa-user-shield text-xl text-purple-400 group-hover:text-purple-300' : 'fa-user text-xl text-blue-400 group-hover:text-blue-300'} transition-colors duration-300 animate-pulse`}></i>
                                                            </div>
                                                            <div className={`absolute -top-1 -right-1 w-5 h-5 ${user.role === 'admin' ? 'bg-gradient-to-r from-yellow-400 to-orange-400' : 'bg-gradient-to-r from-blue-400 to-cyan-400'} rounded-full flex items-center justify-center animate-bounce border-2 border-white/20`}>
                                                                <div className={`w-2 h-2 ${user.role === 'admin' ? 'bg-yellow-200' : 'bg-blue-200'} rounded-full animate-pulse`}></div>
                                                            </div>
                                                        </div>
                                                        <div className="transition-all duration-300 group-hover:translate-x-2">
                                                            <div className="text-white font-bold text-lg bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent group-hover:from-purple-200 group-hover:to-pink-200 transition-all duration-300">
                                                                {user.username || 'No Username'}
                                                            </div>
                                                            <div className="text-gray-400 text-sm font-mono group-hover:text-gray-300 transition-colors duration-300 flex items-center">
                                                                <i className="fas fa-fingerprint mr-2 animate-pulse"></i>
                                                                {user.uid?.substring(0, 8)}...
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Contact Cell */}
                                                <td className="py-6 px-10 relative w-80">
                                                    <div className="relative group/contact">
                                                        <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 to-rose-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                        <div className="relative p-5 bg-gradient-to-r from-gray-800/50 to-gray-900/50 rounded-xl border border-pink-500/20 group-hover:border-pink-400/40 shadow-lg group-hover:shadow-pink-500/20 transform group-hover:scale-105 backdrop-blur-sm min-w-72">
                                                            <div className="flex items-center space-x-4">
                                                                <div className="relative flex-shrink-0">
                                                                    <div className="absolute inset-0 bg-gradient-to-r from-pink-400/30 to-rose-400/30 rounded-full blur-sm animate-pulse"></div>
                                                                    <div className="relative w-12 h-12 bg-gradient-to-r from-pink-500/40 to-rose-500/40 rounded-full flex items-center justify-center border-2 border-pink-400/50 shadow-lg">
                                                                        <i className="fas fa-envelope text-pink-300 text-lg animate-pulse"></i>
                                                                    </div>
                                                                </div>
                                                                <div className="flex-1 min-w-0 overflow-hidden">
                                                                    <div className="text-white font-bold text-lg bg-gradient-to-r from-pink-300 to-rose-300 bg-clip-text text-transparent break-words group-hover:from-pink-200 group-hover:to-rose-200 transition-all duration-300 leading-relaxed">
                                                                        {user.email || 'No Email'}
                                                                    </div>
                                                                    <div className="text-pink-400/70 text-sm font-medium mt-1 animate-pulse">
                                                                        📧 Contact Info
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Role Cell */}
                                                <td className="py-6 px-8 relative">
                                                    <div className="relative">
                                                        <span className={`relative inline-flex items-center px-6 py-3 rounded-full text-sm font-bold transition-all duration-500 transform group-hover:scale-110 group-hover:-translate-y-1 shadow-lg ${
                                                            user.role === 'admin' 
                                                                ? 'bg-gradient-to-r from-purple-500/30 to-rose-500/30 text-purple-300 border-2 border-purple-400/50 hover:shadow-purple-500/40' 
                                                                : 'bg-gradient-to-r from-blue-500/30 to-cyan-500/30 text-blue-300 border-2 border-blue-400/50 hover:shadow-blue-500/40'
                                                        }`}>
                                                            <div className={`absolute inset-0 ${user.role === 'admin' ? 'bg-gradient-to-r from-purple-400/20 to-rose-400/20' : 'bg-gradient-to-r from-blue-400/20 to-cyan-400/20'} rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
                                                            <div className={`relative z-10 flex items-center space-x-2`}>
                                                                <i className={`fas ${user.role === 'admin' ? 'fa-crown text-yellow-400' : 'fa-user text-blue-400'} animate-pulse`}></i>
                                                                <span>{(user.role || 'user').toUpperCase()}</span>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* User ID Cell */}
                                                <td className="py-6 px-8 relative">
                                                    <div className="relative group/uid">
                                                        <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-blue-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                        <div className="relative p-3 bg-gradient-to-r from-gray-800/30 to-gray-900/30 rounded-lg border border-cyan-500/20 group-hover:border-cyan-400/40 shadow-lg group-hover:shadow-cyan-500/20 transform group-hover:scale-105 backdrop-blur-sm" title={user.uid}>
                                                            <div className="flex items-center space-x-3">
                                                                <div className="relative">
                                                                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/30 to-blue-400/30 rounded-full blur-sm animate-pulse"></div>
                                                                    <div className="relative w-8 h-8 bg-gradient-to-r from-cyan-500/40 to-blue-500/40 rounded-full flex items-center justify-center border-2 border-cyan-400/50">
                                                                        <i className="fas fa-hashtag text-cyan-300 text-sm animate-bounce"></i>
                                                                    </div>
                                                                </div>
                                                                <div className="text-white font-mono text-sm font-semibold bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent break-all max-w-40 truncate group-hover:max-w-none transition-all duration-300">
                                                                    {user.uid || 'Unknown'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};


// AdministrationPanel Component - New screen for managing admin tools
const AdministrationPanel = ({ onBackToPanel, user, db, setModalMessage, userColor, appId, onShowTodoModal, onShowEventModal, onShowNotesModal, allAdmins }) => { // Added onShowNotesModal prop
    const [activeAdminTab, setActiveAdminTab] = useState('info'); // Default tab for admin panel

    const renderAdminContent = () => {
        switch (activeAdminTab) {
            case 'info':
                return <AdminInfo />;
            case 'calendar':
                return <AdminCalendar user={user} db={db} setModalMessage={setModalMessage} userColor={userColor} appId={appId} onShowEventModal={onShowEventModal} />; // Pass appId and onShowEventModal
            case 'todo-list':
                return <AdminTodoList user={user} db={db} setModalMessage={setModalMessage} userColor={userColor} appId={appId} onShowTodoModal={onShowTodoModal} allAdmins={allAdmins} />; // Pass userColor, appId, onShowTodoModal, and allAdmins
            case 'notes':
                return <AdminNotes user={user} db={db} setModalMessage={setModalMessage} onShowNotesModal={onShowNotesModal} />
            case 'templates':
                return <AdminTemplates user={user} db={db} setModalMessage={setModalMessage} appId={appId} />; // Pass user, db, setModalMessage, appId
            case 'custom-orders':
                return <CustomOrdersAdmin user={user} db={db} setModalMessage={setModalMessage} />;
            case 'support':
                return <AdminSupport user={user} db={db} setModalMessage={setModalMessage} />;
            case 'all-servers':
                return <AdminAllServers db={db} setModalMessage={setModalMessage} />;
            case 'all-users':
                return <AdminAllUsers db={db} setModalMessage={setModalMessage} />;
            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen w-screen flex bg-[#111111] relative overflow-hidden p-4">
            {/* Background blur circles for design aesthetic */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg w-full h-full flex relative z-10 animate-fadeIn flex-col md:flex-row">
                {/* Sidebar Navigation for Admin Panel */}
                <div className="w-full md:w-1/4 glass-card rounded-2xl p-6 md:mr-6 mb-6 md:mb-0 flex flex-col">
                    <DevcoreLogo />
                    
                    {/* Navigation Header */}
                    <div className="mt-8 mb-6">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-purple-500/20 rounded-xl flex items-center justify-center mr-3">
                                <i className="fas fa-user-shield text-purple-400"></i>
                            </div>
                            <h3 className="text-lg font-bold text-white">Admin Panel</h3>
                        </div>
                        <div className="h-px bg-gradient-to-r from-purple-500/50 to-transparent"></div>
                    </div>

                    {/* Navigation Menu */}
                    <nav className="space-y-2">
                        <button
                            onClick={() => setActiveAdminTab('info')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'info' 
                                    ? 'bg-blue-500/20 text-blue-300 border border-blue-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'info' ? 'bg-blue-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-info-circle text-sm"></i>
                            </div>
                            <span className="font-semibold">System Info</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('calendar')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'calendar' 
                                    ? 'bg-green-500/20 text-green-300 border border-green-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'calendar' ? 'bg-green-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-calendar-alt text-sm"></i>
                            </div>
                            <span className="font-semibold">Calendar</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('todo-list')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'todo-list' 
                                    ? 'bg-orange-500/20 text-orange-300 border border-orange-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'todo-list' ? 'bg-orange-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-tasks text-sm"></i>
                            </div>
                            <span className="font-semibold">Task Manager</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('notes')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'notes' 
                                    ? 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'notes' ? 'bg-yellow-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-sticky-note text-sm"></i>
                            </div>
                            <span className="font-semibold">Notes</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('templates')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'templates' 
                                    ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'templates' ? 'bg-cyan-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-file-alt text-sm"></i>
                            </div>
                            <span className="font-semibold">Templates</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('custom-orders')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'custom-orders' 
                                    ? 'bg-pink-500/20 text-pink-300 border border-pink-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'custom-orders' ? 'bg-pink-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-shopping-cart text-sm"></i>
                            </div>
                            <span className="font-semibold">Custom Orders</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('support')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'support' 
                                    ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'support' ? 'bg-purple-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-life-ring text-sm"></i>
                            </div>
                            <span className="font-semibold">Support</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('all-servers')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'all-servers' 
                                    ? 'bg-indigo-500/20 text-indigo-300 border border-indigo-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'all-servers' ? 'bg-indigo-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-server text-sm"></i>
                            </div>
                            <span className="font-semibold">All Servers</span>
                        </button>

                        <button
                            onClick={() => setActiveAdminTab('all-users')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activeAdminTab === 'all-users' 
                                    ? 'bg-teal-500/20 text-teal-300 border border-teal-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activeAdminTab === 'all-users' ? 'bg-teal-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-users-cog text-sm"></i>
                            </div>
                            <span className="font-semibold">All Users</span>
                        </button>
                    </nav>

                    {/* Spacer */}
                    <div className="flex-grow min-h-8"></div>

                    {/* Back Button */}
                    <div className="mt-6">
                        <div className="h-px bg-gradient-to-r from-gray-500/50 to-transparent mb-6"></div>
                        <button
                            onClick={onBackToPanel}
                            className="w-full px-4 py-3 bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 border border-white/10 flex items-center justify-center"
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            Back to Panel
                        </button>
                    </div>
                </div>

                {/* Main Content Area for Admin Tools */}
                <div className="w-full md:w-3/4 glass-card rounded-2xl p-6 overflow-y-auto flex flex-col">
                    <div className="flex items-center mb-8">
                        <div className="w-12 h-12 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-xl flex items-center justify-center mr-4">
                            <i className="fas fa-tools text-xl text-purple-400"></i>
                        </div>
                        <div>
                            <h2 className="text-4xl font-bold gradient-text">
                                Administration
                            </h2>
                            <p className="text-gray-400 text-lg">
                                {activeAdminTab.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} Management
                            </p>
                        </div>
                    </div>
                    {renderAdminContent()}
                </div>
            </div>
        </div>
    );
};

// --- Script Updates Modal Component ---


const Panel = ({ onNavigateHome, onLogout, onManageServer, onManageAdmin, onNavigateTodo, user, loading, db, setModalMessage, userDiscordData, setUserDiscordData, onShowClaimModal, onShowUpdatesModal, onShowCustomOrderModal, onShowCustomOrderChatModal, onShowNewTicketModal, fetchedUsername, updateFetchedUsername }) => { // Added onNavigateTodo prop
    const [activePanelTab, setActivePanelTab] = useState('my-servers'); 
    const [newUsername, setNewUsername] = useState(''); 
    const [isAdmin, setIsAdmin] = useState(false); // New state for admin role

    // Debug log to track userDiscordData prop changes (can be removed in production)

    const [isSettingsTabOpen, setIsSettingsTabOpen] = useState('profile');
    const [servers, setServers] = useState([]); // Initialize as empty, data will come from Firestore
    const [panelTheme, setPanelTheme] = useState('dark'); // Simulated setting
    const [activityLog, setActivityLog] = useState([ // Simulated activity log
        { id: 1, timestamp: '2025-07-19 10:00 AM', message: 'Logged in successfully.', type: 'login' },
        { id: 2, timestamp: '2025-07-19 10:05 AM', message: 'Script "Core Essentials" started.', type: 'script' },
        { id: 3, timestamp: '2025-07-19 10:15 AM', message: 'Generated analytics report.', type: 'analytics' },
    ]);
    const [filterActivityType, setFilterActivityType] = useState('all'); // State for activity log filter
    const [showAddServerModal, setShowAddServerModal] = useState(false); // State for new server modal

    // Fetch user role from Firestore
    useEffect(() => {
        const fetchUserData = async () => {
            if (user && db) {
                try {
                    const userDocRef = doc(db, `users/${user.uid}`);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                        const userData = userDocSnap.data();
                        setNewUsername(userData.username || ''); // Initialize newUsername with current username
                        setIsAdmin(userData.role === 'admin'); // Set isAdmin based on role
                    } else {
                        setNewUsername('');
                        setIsAdmin(false); // Default to not admin if no role found
                    }
                } catch (error) {
                    console.error("Error fetching user data from Firestore:", error);
                    setNewUsername('');
                    setIsAdmin(false);
                }
            }
        };
        fetchUserData();
    }, [user, db]); // Re-fetch if user or db instance changes

    // Firestore listener for servers
    useEffect(() => {
        if (!user || !db) {
            setServers([]); // Clear servers if not logged in or db not ready
            return;
        }

        // Fetch from the top-level 'servers' collection, filtered by owner
        const serversCollectionRef = collection(db, `servers`);
        const q = query(serversCollectionRef, where('owner', '==', user.uid));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const serversData = snapshot.docs.map(doc => ({
                id: doc.id, // Firestore document ID
                ...doc.data()
            }));
            setServers(serversData);
            console.log("Servers fetched from Firestore:", serversData);
        }, (error) => {
            console.error("Error fetching servers from Firestore:", error);
            setModalMessage(`Error loading servers: ${error.message}`);
        });

        // Cleanup listener on component unmount or user/db change
        return () => unsubscribe();
    }, [user, db, setModalMessage]); // Re-run if user or db changes

    // Firestore listener removed - scripts are handled by MyScripts component

    // Functions removed - script management is handled by MyScripts component

    // Bot status checking removed - handled elsewhere

    // claimScript function removed - handled by MyScripts component

    const handleAddServer = async (serverName, serverIp, serverRegion) => {
        if (!user || !db) {
            setModalMessage("You must be logged in to add a server.");
            return;
        }

        try {
            // Add to the global 'servers' collection
            const serversCollectionRef = collection(db, `servers`);
            const newServerData = {
                name: serverName,
                ip: serverIp,
                region: serverRegion,
                status: 'offline', // New servers start offline
                players: '0/64',
                hasNewLogs: false,
                createdAt: new Date().toISOString(), // Timestamp for creation
                owner: user.uid // Store the creator's UID as 'owner'
            };
            await addDoc(serversCollectionRef, newServerData);

            setModalMessage(`Server "${serverName}" has been added!`);
            setActivityLog(prevLog => [
                { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: `New server "${serverName}" added.`, type: 'server' },
                ...prevLog,
            ]);
        } catch (error) {
            console.error("Error adding server to Firestore:", error);
            setModalMessage(`Failed to add server: ${error.message}`);
        }
    };

    const handleUpdateUsername = async () => {
        if (!newUsername.trim()) {
            setModalMessage("Username cannot be empty.");
            return;
        }
        if (newUsername === fetchedUsername) {
            setModalMessage("New username is the same as current username.");
            return;
        }

        if (user && db) {
            try {
                const userDocRef = doc(db, `users/${user.uid}`);
                await setDoc(userDocRef, { username: newUsername }, { merge: true }); // Merge to only update username
                updateFetchedUsername(newUsername);
                setModalMessage("Username updated successfully!");
                setActivityLog(prevLog => [
                    { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: `Username updated to "${newUsername}".`, type: 'profile' },
                    ...prevLog,
                ]);
            } catch (error) {
                console.error("Error updating username:", error);
                setModalMessage(`Failed to update username: ${error.message}`);
            }
        }
    };

    const handleChangePassword = () => {
        setModalMessage("Password change functionality is under development. Please use Firebase console for now.");
        setActivityLog(prevLog => [
            { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: 'Attempted password change.', type: 'profile' },
            ...prevLog,
        ]);
    };

    const handleUploadFile = () => {
        setModalMessage("File upload functionality is under development.");
        setActivityLog(prevLog => [
            { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: 'Attempted file upload.', type: 'files' },
            ...prevLog,
        ]);
    };

    const handleDownloadFile = () => {
        setModalMessage("File download functionality is under development.");
        setActivityLog(prevLog => [
            { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: 'Attempted file download.', type: 'files' },
            ...prevLog,
        ]);
    };

    const handleClearActivityLog = () => {
        setActivityLog([]);
        setModalMessage("Activity log cleared.");
    };

    const handleSaveSettings = () => {
        // In a real application, you would save panelTheme to Firestore here
        console.log("Saving settings:", { panelTheme });
        setModalMessage(`Settings saved: Theme set to ${panelTheme}`); // Using CustomModal
        setActivityLog(prevLog => [
            { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: `Panel theme changed to ${panelTheme}.`, type: 'settings' },
            ...prevLog,
        ]);
    };

    const generateReport = () => {
        setModalMessage("Generating a detailed report..."); // Using CustomModal
        setActivityLog(prevLog => [
            { id: prevLog.length + 1, timestamp: new Date().toLocaleString(), message: 'Generated analytics report.', type: 'analytics' },
            ...prevLog,
        ]);
        // In a real app, this would trigger a backend process or data compilation
    };
    
    const filteredActivityLog = activityLog.filter(log => {
        if (filterActivityType === 'all') return true;
        return log.type === filterActivityType;
    });

    

    const renderPanelContent = () => {
        switch (activePanelTab) {
            case 'dashboard':
                return (
                    <div className="space-y-8 flex-grow">
                        {/* Quick Stats Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            <div className="group glass-card p-6 rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20 border border-white/10 hover:border-blue-400/50">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center">
                                        <i className="fas fa-server text-blue-400 text-2xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">Total Servers</p>
                                        <p className="text-2xl font-bold text-white">{servers.length}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="group glass-card p-6 rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl hover:shadow-green-500/20 border border-white/10 hover:border-green-400/50">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-green-500/20 to-blue-600/20 flex items-center justify-center">
                                        <i className="fas fa-users text-green-400 text-2xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">Online Players</p>
                                        <p className="text-2xl font-bold text-white">
                                            {servers.reduce((total, server) => {
                                                const players = server.players?.split('/')[0];
                                                return total + (parseInt(players) || 0);
                                            }, 0)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="group glass-card p-6 rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl hover:shadow-purple-500/20 border border-white/10 hover:border-purple-400/50">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-purple-500/20 to-pink-600/20 flex items-center justify-center">
                                        <i className="fas fa-chart-line text-purple-400 text-2xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">Uptime</p>
                                        <p className="text-2xl font-bold text-white">99.9%</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="group glass-card p-6 rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl hover:shadow-orange-500/20 border border-white/10 hover:border-orange-400/50">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-500/20 to-red-600/20 flex items-center justify-center">
                                        <i className="fas fa-exclamation-triangle text-orange-400 text-2xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">Alerts</p>
                                        <p className="text-2xl font-bold text-white">2</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Action Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="group glass-card p-8 rounded-2xl hover:-translate-y-2 transition-all duration-500 hover:shadow-2xl hover:shadow-blue-500/20 border border-white/10 hover:border-blue-400/50">
                                <div className="text-center">
                                    <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                        <i className="fas fa-chart-line text-4xl gradient-text"></i>
                                    </div>
                                    <h3 className="text-2xl font-bold text-white mb-3">Dashboard Overview</h3>
                                    <p className="text-gray-300 mb-6 leading-relaxed">Generate comprehensive analytics reports and monitor your server performance in real-time.</p>
                                    <button 
                                        onClick={generateReport} 
                                        className="group/btn w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                                    >
                                        <i className="fas fa-download text-sm group-hover/btn:rotate-12 transition-transform duration-300"></i>
                                        <span>Generate Report</span>
                                    </button>
                                </div>
                            </div>
                            
                            <div className="group glass-card p-8 rounded-2xl hover:-translate-y-2 transition-all duration-500 hover:shadow-2xl hover:shadow-green-500/20 border border-white/10 hover:border-green-400/50">
                                <div className="text-center">
                                    <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-green-500/20 to-blue-600/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                        <i className="fas fa-users text-4xl gradient-text"></i>
                                    </div>
                                    <h3 className="text-2xl font-bold text-white mb-3">User Management</h3>
                                    <p className="text-gray-300 mb-6 leading-relaxed">Manage user accounts, permissions, and roles across all your connected servers.</p>
                                    <button 
                                        className="group/btn w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 text-gray-300 rounded-xl transition-all duration-300 font-medium cursor-not-allowed opacity-75"
                                        disabled
                                    >
                                        <i className="fas fa-clock text-sm"></i>
                                        <span>Coming Soon</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 'my-servers':
                return (
                    <div className="glass-card p-8 rounded-2xl flex-grow min-h-[600px] animate-fadeIn">
                        {/* Enhanced Header Section */}
                        <div className="flex items-center justify-between mb-8 animate-slideInLeft">
                            <div className="relative">
                                <div className="absolute -inset-1 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-xl animate-pulse"></div>
                                <div className="relative">
                                    <h3 className="text-4xl font-black gradient-text mb-4 flex items-center animate-slideInLeft">
                                        <div className="relative mr-6">
                                            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-500/20 flex items-center justify-center shadow-lg animate-float">
                                                <i className="fas fa-server text-3xl text-blue-400 animate-pulse"></i>
                                            </div>
                                            <div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-blue-500/10 to-purple-500/10 animate-ping opacity-75"></div>
                                        </div>
                                        <div>
                                            My Servers
                                            {/* <div className="h-1 w-0 bg-gradient-to-r from-blue-400 to-purple-400 animate-[width-expand_2s_ease-out_forwards] rounded-full"></div> */}
                                        </div>
                                    </h3>
                                    <div className="flex items-center space-x-6 animate-fadeIn" style={{ animationDelay: '0.3s' }}>
                                        <div className="flex items-center space-x-2 text-gray-300">
                                            <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                                            <span className="text-sm font-medium">
                                                {servers.length > 0 ? `${servers.length} active server${servers.length > 1 ? 's' : ''}` : 'Ready to add your first server'}
                                            </span>
                                        </div>
                                        <div className="flex items-center space-x-2 text-gray-500 text-xs">
                                            <i className="fas fa-sync-alt animate-spin" style={{ animationDuration: '3s' }}></i>
                                            <span>Real-time monitoring</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={() => setShowAddServerModal(true)}
                                className="group relative overflow-hidden bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-bold py-4 px-8 rounded-2xl transition-all duration-700 shadow-lg hover:shadow-2xl hover:shadow-blue-500/30 hover:-translate-y-3 hover:scale-110 animate-bounceIn"
                                style={{ animationDelay: '0.5s' }}
                            >
                                {/* Shimmer overlay */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 animate-shimmer"></div>
                                
                                {/* Background pulse */}
                                <div className="absolute inset-0 bg-gradient-to-r from-blue-400/20 to-purple-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-heartbeat"></div>
                                
                                <div className="relative flex items-center space-x-3">
                                    <div className="w-8 h-8 rounded-xl bg-white/10 flex items-center justify-center group-hover:rotate-180 group-hover:scale-125 transition-all duration-700">
                                        <i className="fas fa-plus text-lg"></i>
                                    </div>
                                    <span className="font-black text-lg">Add New Server</span>
                                    <div className="flex space-x-1">
                                        <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover:opacity-100 animate-bounce transition-opacity duration-300"></div>
                                        <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover:opacity-100 animate-bounce transition-opacity duration-300" style={{ animationDelay: '0.1s' }}></div>
                                        <div className="w-2 h-2 rounded-full bg-white/60 opacity-0 group-hover:opacity-100 animate-bounce transition-opacity duration-300" style={{ animationDelay: '0.2s' }}></div>
                                    </div>
                                </div>
                                
                                {/* Glow effect */}
                                <div className="absolute -inset-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl opacity-0 group-hover:opacity-30 blur-2xl transition-all duration-700"></div>
                            </button>
                        </div>
                        
                        {servers.length === 0 ? (
                            <div className="flex flex-col items-center justify-center flex-grow text-center py-20 animate-fadeIn">
                                <div className="relative mb-12">
                                    {/* Multiple animated background rings */}
                                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500/10 to-purple-500/10 animate-ping" style={{ animationDuration: '4s' }}></div>
                                    <div className="absolute inset-8 rounded-full bg-gradient-to-r from-blue-500/5 to-purple-500/5 animate-ping" style={{ animationDuration: '3s', animationDelay: '0.5s' }}></div>
                                    <div className="absolute inset-12 rounded-full bg-gradient-to-r from-blue-500/3 to-purple-500/3 animate-ping" style={{ animationDuration: '2s', animationDelay: '1s' }}></div>
                                    
                                    {/* Main server icon with enhanced animation */}
                                    <div className="relative w-40 h-40 mx-auto rounded-full bg-gradient-to-br from-blue-600/20 to-purple-600/20 flex items-center justify-center animate-float border border-blue-500/20">
                                        <i className="fas fa-server text-7xl text-blue-400 animate-pulse"></i>
                                    </div>
                                    
                                    {/* Floating particles around the icon */}
                                    <div className="absolute top-8 left-8 w-3 h-3 rounded-full bg-blue-400/60 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                                    <div className="absolute top-12 right-12 w-2 h-2 rounded-full bg-purple-400/60 animate-bounce" style={{ animationDelay: '0.8s' }}></div>
                                    <div className="absolute bottom-10 left-16 w-1.5 h-1.5 rounded-full bg-cyan-400/60 animate-bounce" style={{ animationDelay: '1.2s' }}></div>
                                    <div className="absolute bottom-16 right-8 w-2.5 h-2.5 rounded-full bg-pink-400/60 animate-bounce" style={{ animationDelay: '1.6s' }}></div>
                                </div>
                                
                                <div className="space-y-6 max-w-lg">
                                    <h3 className="text-4xl font-black gradient-text animate-slideInLeft" style={{ animationDelay: '0.3s' }}>
                                        No Servers Yet
                                    </h3>
                                    <p className="text-gray-300 text-xl leading-relaxed animate-slideInLeft" style={{ animationDelay: '0.5s' }}>
                                        Ready to start your server management journey?
                                    </p>
                                    <p className="text-gray-400 text-lg leading-relaxed animate-slideInLeft" style={{ animationDelay: '0.7s' }}>
                                        Add your first server and unlock powerful monitoring, management tools, and real-time analytics.
                                    </p>
                                    
                                    {/* Enhanced feature highlights */}
                                    <div className="grid grid-cols-2 gap-6 mt-12 animate-slideInLeft" style={{ animationDelay: '0.9s' }}>
                                        <div className="group relative overflow-hidden bg-gradient-to-br from-blue-600/10 to-blue-700/5 rounded-2xl p-6 hover:bg-gradient-to-br hover:from-blue-600/20 hover:to-blue-700/10 transition-all duration-500 hover:-translate-y-2 hover:scale-105 border border-blue-500/20 hover:border-blue-400/50">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                            <div className="relative">
                                                <i className="fas fa-chart-line text-blue-400 text-3xl mb-4 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"></i>
                                                <p className="text-sm text-gray-200 font-bold">Real-time Analytics</p>
                                            </div>
                                        </div>
                                        <div className="group relative overflow-hidden bg-gradient-to-br from-purple-600/10 to-purple-700/5 rounded-2xl p-6 hover:bg-gradient-to-br hover:from-purple-600/20 hover:to-purple-700/10 transition-all duration-500 hover:-translate-y-2 hover:scale-105 border border-purple-500/20 hover:border-purple-400/50">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-400/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                            <div className="relative">
                                                <i className="fas fa-shield-alt text-purple-400 text-3xl mb-4 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"></i>
                                                <p className="text-sm text-gray-200 font-bold">Advanced Security</p>
                                            </div>
                                        </div>
                                        <div className="group relative overflow-hidden bg-gradient-to-br from-green-600/10 to-green-700/5 rounded-2xl p-6 hover:bg-gradient-to-br hover:from-green-600/20 hover:to-green-700/10 transition-all duration-500 hover:-translate-y-2 hover:scale-105 border border-green-500/20 hover:border-green-400/50">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                            <div className="relative">
                                                <i className="fas fa-cogs text-green-400 text-3xl mb-4 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"></i>
                                                <p className="text-sm text-gray-200 font-bold">Auto Management</p>
                                            </div>
                                        </div>
                                        <div className="group relative overflow-hidden bg-gradient-to-br from-orange-600/10 to-orange-700/5 rounded-2xl p-6 hover:bg-gradient-to-br hover:from-orange-600/20 hover:to-orange-700/10 transition-all duration-500 hover:-translate-y-2 hover:scale-105 border border-orange-500/20 hover:border-orange-400/50">
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                            <div className="relative">
                                                <i className="fas fa-bell text-orange-400 text-3xl mb-4 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300"></i>
                                                <p className="text-sm text-gray-200 font-bold">Smart Alerts</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                {servers.map((server, index) => (
                                    <div 
                                        key={server.id} 
                                        className="group relative overflow-hidden rounded-2xl glass-card border border-white/10 hover:border-blue-400/60 transition-all duration-700 hover:-translate-y-4 hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25 animate-fadeIn hover-lift"
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                    >
                                        {/* Enhanced Shimmer overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/8 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                        
                                        {/* Multi-layer gradient background overlay on hover */}
                                        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/15 via-purple-600/8 to-cyan-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-blue-400/5 to-purple-400/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                                        
                                        {/* Enhanced animated border glow */}
                                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-400/30 via-transparent to-purple-400/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-lg animate-pulse"></div>
                                        
                                        <div className="relative h-full flex flex-col">
                                            {/* Enhanced Server Thumbnail Section */}
                                            <div className="relative mb-6 -mx-6 -mt-6">
                                                <div className="aspect-video bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 relative overflow-hidden rounded-t-2xl group-hover:bg-gradient-to-br group-hover:from-gray-700 group-hover:via-gray-600 group-hover:to-gray-700 transition-all duration-500">
                                                    {/* Enhanced preview content with more animations */}
                                                    <div className="absolute inset-0 flex items-center justify-center">
                                                        <div className="text-center transform group-hover:scale-115 transition-transform duration-500">
                                                            <div className="relative w-24 h-24 mx-auto mb-4">
                                                                {/* Multiple animated rings */}
                                                                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 animate-pulse opacity-80 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                                <div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-blue-400 to-purple-500 animate-ping opacity-20" style={{ animationDuration: '2s' }}></div>
                                                                <div className="absolute -inset-4 rounded-2xl bg-gradient-to-br from-blue-300 to-purple-400 animate-ping opacity-10" style={{ animationDuration: '3s', animationDelay: '0.5s' }}></div>
                                                                
                                                                <div className="relative w-24 h-24 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-2xl">
                                                                    <i className="fas fa-server text-white text-3xl group-hover:rotate-12 transition-transform duration-500"></i>
                                                                </div>
                                                                
                                                                {/* Floating particles around server icon */}
                                                                <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-cyan-400/60 opacity-0 group-hover:opacity-100 animate-bounce transition-opacity duration-300" style={{ animationDelay: '0.2s' }}></div>
                                                                <div className="absolute bottom-1 left-1 w-1.5 h-1.5 rounded-full bg-pink-400/60 opacity-0 group-hover:opacity-100 animate-bounce transition-opacity duration-300" style={{ animationDelay: '0.8s' }}></div>
                                                            </div>
                                                            <p className="text-gray-300 text-sm font-bold group-hover:text-white transition-colors duration-300 animate-pulse">Server Online</p>
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Enhanced gradient overlay */}
                                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent group-hover:from-black/50 transition-all duration-500"></div>
                                                    
                                                    {/* Enhanced status indicator with more animation */}
                                                    <div className="absolute top-4 left-4">
                                                        <div className="flex items-center space-x-3 bg-black/70 backdrop-blur-lg rounded-full px-4 py-3 group-hover:bg-black/50 transition-all duration-300 border border-white/10 group-hover:border-white/20">
                                                            <div className="relative">
                                                                <span className={`inline-block w-4 h-4 rounded-full animate-pulse ${server.status === 'online' ? 'bg-green-400' : 'bg-red-400'}`}></span>
                                                                <span className={`absolute inset-0 w-4 h-4 rounded-full animate-ping opacity-75 ${server.status === 'online' ? 'bg-green-400' : 'bg-red-400'}`}></span>
                                                            </div>
                                                            <span className={`text-sm font-bold ${server.status === 'online' ? 'text-green-400' : 'text-red-400'}`}>
                                                                {server.status === 'online' ? 'ONLINE' : 'OFFLINE'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Enhanced player count badge */}
                                                    <div className="absolute top-4 right-4">
                                                        <div className="relative group/badge">
                                                            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-black px-4 py-3 rounded-full shadow-2xl group-hover:shadow-blue-500/50 transition-all duration-300 hover:scale-110 border border-white/20">
                                                                <div className="flex items-center space-x-2">
                                                                    <i className="fas fa-users animate-pulse"></i>
                                                                    <span>{server.players}</span>
                                                                </div>
                                                            </div>
                                                            <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full opacity-0 group-hover/badge:opacity-40 blur transition-all duration-300"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="px-6 pb-6 flex flex-col flex-grow">
                                                {/* Enhanced Server Title */}
                                                <div className="mb-6">
                                                    <h4 className="text-2xl font-black text-white mb-3 leading-tight line-clamp-2 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-400 group-hover:to-purple-400 group-hover:bg-clip-text transition-all duration-500 transform group-hover:scale-105">
                                                        {server.name}
                                                    </h4>
                                                    <div className="h-1 w-0 bg-gradient-to-r from-blue-400 to-purple-400 group-hover:w-full transition-all duration-700 rounded-full"></div>
                                                </div>

                                                {/* Enhanced Details Grid */}
                                                <div className="space-y-4 mb-8 flex-grow">
                                                    <div className="group/detail flex items-center space-x-4 text-sm p-4 bg-white/5 rounded-xl group-hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg">
                                                        <div className="relative">
                                                            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20 flex items-center justify-center group-hover/detail:scale-110 group-hover/detail:rotate-6 transition-all duration-300 shadow-lg">
                                                                <i className="fas fa-network-wired text-blue-400 text-lg"></i>
                                                            </div>
                                                            <div className="absolute -inset-1 bg-gradient-to-br from-blue-500/10 to-cyan-500/10 rounded-xl opacity-0 group-hover/detail:opacity-100 animate-ping transition-opacity duration-300"></div>
                                                        </div>
                                                        <div className="flex-grow">
                                                            <p className="text-blue-400 font-bold text-sm uppercase tracking-wide">IP Address</p>
                                                            <p className="text-gray-200 font-mono text-lg">{server.ip}</p>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="group/detail flex items-center space-x-4 text-sm p-4 bg-white/5 rounded-xl group-hover:bg-white/10 transition-all duration-300 hover:scale-105 hover:shadow-lg">
                                                        <div className="relative">
                                                            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center group-hover/detail:scale-110 group-hover/detail:rotate-6 transition-all duration-300 shadow-lg">
                                                                <i className="fas fa-globe text-purple-400 text-lg"></i>
                                                            </div>
                                                            <div className="absolute -inset-1 bg-gradient-to-br from-purple-500/10 to-pink-500/10 rounded-xl opacity-0 group-hover/detail:opacity-100 animate-ping transition-opacity duration-300"></div>
                                                        </div>
                                                        <div className="flex-grow">
                                                            <p className="text-purple-400 font-bold text-sm uppercase tracking-wide">Region</p>
                                                            <p className="text-gray-200 text-lg font-semibold">{server.region}</p>
                                                        </div>
                                                    </div>
                                                    
                                                    {server.hasNewLogs && (
                                                        <div className="group/detail flex items-center space-x-4 text-sm p-4 bg-gradient-to-r from-yellow-500/10 to-orange-500/10 rounded-xl border border-yellow-500/20 group-hover:border-yellow-400/50 transition-all duration-300 hover:scale-105 animate-pulse">
                                                            <div className="relative">
                                                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-yellow-500/20 to-orange-500/20 flex items-center justify-center group-hover/detail:scale-110 group-hover/detail:rotate-6 transition-all duration-300 shadow-lg animate-bounce">
                                                                    <i className="fas fa-exclamation-triangle text-yellow-400 text-lg"></i>
                                                                </div>
                                                                <div className="absolute -inset-1 bg-gradient-to-br from-yellow-500/10 to-orange-500/10 rounded-xl opacity-0 group-hover/detail:opacity-100 animate-ping transition-opacity duration-300"></div>
                                                            </div>
                                                            <div className="flex-grow">
                                                                <p className="text-yellow-400 font-bold text-sm uppercase tracking-wide animate-pulse">New Activity</p>
                                                                <p className="text-orange-300 text-lg font-semibold">Check server logs</p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Enhanced Action Button */}
                                                <button
                                                    onClick={() => onManageServer(server.id)}
                                                    className="group/btn relative overflow-hidden w-full flex items-center justify-center space-x-3 px-6 py-4 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white rounded-2xl transition-all duration-500 font-black text-lg shadow-2xl hover:shadow-blue-500/50 hover:-translate-y-2 hover:scale-105"
                                                >
                                                    {/* Enhanced shimmer effect */}
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/15 to-transparent -translate-x-full group-hover/btn:translate-x-full transition-transform duration-1000"></div>
                                                    
                                                    {/* Background animation */}
                                                    <div className="absolute inset-0 bg-gradient-to-r from-blue-400/20 to-purple-400/20 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300 animate-pulse"></div>
                                                    
                                                    <div className="relative flex items-center space-x-3">
                                                        <div className="w-8 h-8 rounded-xl bg-white/20 flex items-center justify-center group-hover/btn:rotate-180 group-hover/btn:scale-125 transition-all duration-700">
                                                            <i className="fas fa-cog text-lg"></i>
                                                        </div>
                                                        <span className="font-black">Manage Server</span>
                                                        <div className="w-8 h-8 rounded-xl bg-white/20 flex items-center justify-center group-hover/btn:translate-x-2 group-hover/btn:scale-125 transition-all duration-500">
                                                            <i className="fas fa-arrow-right text-lg"></i>
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Enhanced glow effect */}
                                                    <div className="absolute -inset-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl opacity-0 group-hover/btn:opacity-40 blur-xl transition-all duration-500"></div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            case 'server-list':
                return (
                    <div className="relative overflow-hidden h-full">
                        {/* Epic Animated Background */}
                        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/3 via-blue-500/5 to-purple-500/3 animate-pulse-slow"></div>
                        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-cyan-500/10 to-transparent opacity-30 animate-float"></div>
                        
                        {/* Floating Background Particles */}
                        <div className="absolute top-10 left-10 w-3 h-3 bg-cyan-400/60 rounded-full animate-ping"></div>
                        <div className="absolute top-20 right-20 w-2 h-2 bg-blue-400/60 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
                        <div className="absolute bottom-20 left-20 w-4 h-4 bg-purple-400/40 rounded-full animate-bounce" style={{ animationDelay: '2s' }}></div>
                        <div className="absolute bottom-10 right-40 w-2.5 h-2.5 bg-cyan-300/50 rounded-full animate-ping" style={{ animationDelay: '3s' }}></div>

                        <div className="relative z-10 glass-card p-8 rounded-3xl flex-grow min-h-[600px] border-2 border-cyan-500/30 hover:border-cyan-400/50 transition-all duration-700 shadow-2xl hover:shadow-cyan-500/25 backdrop-blur-2xl">
                            <div className="text-center animate-fadeIn">
                                {/* Ultra Hot Icon and Title */}
                                <div className="relative mb-8 animate-bounceIn">
                                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/30 to-blue-500/30 rounded-3xl blur-2xl animate-pulse"></div>
                                    <div className="relative w-32 h-32 mx-auto mb-6 rounded-3xl bg-gradient-to-br from-cyan-500/20 via-blue-500/30 to-purple-600/20 border-4 border-cyan-500/40 hover:border-cyan-400/60 flex items-center justify-center transition-all duration-500 transform hover:scale-110 hover:rotate-6 shadow-2xl hover:shadow-cyan-500/40 animate-glow">
                                        <i className="fas fa-list-alt text-6xl bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent animate-pulse"></i>
                                    </div>
                                    <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center animate-bounce border-4 border-white/20">
                                        <i className="fas fa-fire text-white text-xl"></i>
                                    </div>
                                </div>
                                
                                <div className="animate-slideInLeft" style={{ animationDelay: '0.2s' }}>
                                    <h3 className="text-5xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent mb-6 hover:from-cyan-300 hover:via-blue-300 hover:to-purple-300 transition-all duration-500 transform hover:scale-105">
                                        Epic Server Browser
                                    </h3>
                                    <p className="text-gray-300 text-xl mb-12 max-w-3xl mx-auto leading-relaxed animate-pulse">
                                        🚀 Discover legendary gaming experiences • Browse hot community servers • Join epic battles and adventures! 
                                    </p>
                                </div>
                                
                                {/* Ultra Interactive Feature Cards */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
                                    {[
                                        {
                                            icon: 'fas fa-search',
                                            title: 'AI-Powered Search',
                                            description: 'Advanced filtering with region detection, real-time player analytics, and smart recommendations',
                                            gradient: 'from-green-500/30 to-emerald-500/30',
                                            iconColor: 'text-green-400',
                                            borderColor: 'border-green-400/30',
                                            hoverColor: 'hover:border-green-400/60',
                                            delay: '0.3s'
                                        },
                                        {
                                            icon: 'fas fa-crown',
                                            title: 'Elite Server Network',
                                            description: 'Premium verified servers with top-tier performance, active communities, and exclusive content',
                                            gradient: 'from-yellow-500/30 to-orange-500/30',
                                            iconColor: 'text-yellow-400',
                                            borderColor: 'border-yellow-400/30',
                                            hoverColor: 'hover:border-yellow-400/60',
                                            delay: '0.5s'
                                        },
                                        {
                                            icon: 'fas fa-bolt',
                                            title: 'Lightning Performance',
                                            description: 'Real-time server monitoring, instant connection status, and optimized matchmaking algorithms',
                                            gradient: 'from-purple-500/30 to-pink-500/30',
                                            iconColor: 'text-purple-400',
                                            borderColor: 'border-purple-400/30',
                                            hoverColor: 'hover:border-purple-400/60',
                                            delay: '0.7s'
                                        }
                                    ].map((feature, index) => (
                                        <div key={index} className="group relative animate-slideInLeft h-96" style={{ animationDelay: feature.delay }}>
                                            <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-all duration-500`}></div>
                                            <div className={`relative glass-card p-8 rounded-2xl border-2 ${feature.borderColor} ${feature.hoverColor} transition-all duration-300 transform hover:scale-105 hover:-translate-y-2 shadow-xl group-hover:shadow-2xl backdrop-blur-xl h-full flex flex-col`}>
                                                <div className="relative mb-6">
                                                    <div className={`w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center group-hover:scale-110 transition-all duration-300 border-2 ${feature.borderColor} shadow-lg`}>
                                                        <i className={`${feature.icon} ${feature.iconColor} text-2xl group-hover:animate-pulse`}></i>
                                                    </div>
                                                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-red-400 to-pink-400 rounded-full opacity-0 group-hover:opacity-100 animate-bounce transition-opacity duration-300"></div>
                                                </div>
                                                <h4 className={`text-xl font-bold text-white mb-4 group-hover:${feature.iconColor} transition-all duration-300`}>{feature.title}</h4>
                                                <p className="text-gray-400 text-sm leading-relaxed group-hover:text-gray-300 transition-colors duration-300">{feature.description}</p>
                                                
                                                {/* Shimmer Effect */}
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 rounded-2xl pointer-events-none"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                
                                {/* Epic Coming Soon Section */}
                                <div className="relative animate-bounceIn" style={{ animationDelay: '0.8s' }}>
                                    <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-red-500/20 rounded-3xl blur-2xl animate-pulse"></div>
                                    <div className="relative inline-block group">
                                        <div className="absolute inset-0 bg-gradient-to-r from-orange-500/30 to-red-500/30 rounded-2xl blur-lg group-hover:blur-xl transition-all duration-500 animate-pulse"></div>
                                        <button 
                                            className="relative overflow-hidden px-12 py-6 bg-gradient-to-r from-orange-600/80 via-red-600/80 to-pink-600/80 hover:from-orange-500 hover:via-red-500 hover:to-pink-500 text-white rounded-2xl transition-all duration-500 font-bold text-xl shadow-2xl cursor-not-allowed transform hover:scale-105 border-4 border-orange-500/50 hover:border-orange-400/70 backdrop-blur-sm"
                                            disabled
                                        >
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000"></div>
                                            <div className="relative flex items-center space-x-4">
                                                <div className="w-8 h-8 bg-yellow-400/30 rounded-full flex items-center justify-center animate-spin">
                                                    <i className="fas fa-cog text-yellow-300"></i>
                                                </div>
                                                <span className="text-2xl">🔥 LAUNCHING SOON</span>
                                                <div className="w-8 h-8 bg-purple-400/30 rounded-full flex items-center justify-center animate-bounce">
                                                    <i className="fas fa-rocket text-purple-300"></i>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                
                                <div className="mt-8 animate-slideInRight" style={{ animationDelay: '1s' }}>
                                    <p className="text-cyan-400 text-lg font-semibold mb-4 animate-pulse">
                                        ⚡ Revolutionary server browser technology in development
                                    </p>
                                    <div className="flex justify-center space-x-6 text-sm text-gray-400">
                                        <div className="flex items-center space-x-2 animate-pulse">
                                            <div className="w-2 h-2 bg-green-400 rounded-full animate-ping"></div>
                                            <span>AI Matchmaking</span>
                                        </div>
                                        <div className="flex items-center space-x-2 animate-pulse" style={{ animationDelay: '0.5s' }}>
                                            <div className="w-2 h-2 bg-blue-400 rounded-full animate-ping"></div>
                                            <span>Real-time Analytics</span>
                                        </div>
                                        <div className="flex items-center space-x-2 animate-pulse" style={{ animationDelay: '1s' }}>
                                            <div className="w-2 h-2 bg-purple-400 rounded-full animate-ping"></div>
                                            <span>Global Network</span>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Progress Bar Animation */}
                                <div className="mt-12 max-w-md mx-auto animate-slideInLeft" style={{ animationDelay: '1.2s' }}>
                                    <div className="flex items-center justify-between text-sm text-gray-400 mb-2">
                                        <span>Development Progress</span>
                                        <span className="text-cyan-400 font-bold">78%</span>
                                    </div>
                                    <div className="w-full h-3 bg-gray-800 rounded-full overflow-hidden border border-cyan-500/30">
                                        <div className="h-full bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 rounded-full transition-all duration-2000 ease-out shadow-lg animate-shimmer" style={{ width: '78%' }}>
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Floating Action Particles */}
                            <div className="absolute top-20 left-1/4 w-1 h-1 bg-cyan-400 rounded-full animate-ping opacity-60" style={{ animationDelay: '2s' }}></div>
                            <div className="absolute bottom-32 right-1/3 w-2 h-2 bg-purple-400 rounded-full animate-pulse opacity-40" style={{ animationDelay: '3s' }}></div>
                            <div className="absolute top-1/2 right-20 w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce opacity-50" style={{ animationDelay: '1.5s' }}></div>
                        </div>
                    </div>
                );
            case 'profile': // User Profile tab content
                return (
                    <div className="glass-card p-8 rounded-2xl flex-grow">
                        <h3 className="text-3xl font-bold gradient-text mb-8">User Profile</h3>
                        
                        {/* Profile Info Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                            <div className="group bg-gray-800/50 border border-white/10 rounded-xl p-6 hover:border-blue-400/30 transition-all duration-300">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 border border-blue-500/30 flex items-center justify-center">
                                        <i className="fas fa-user text-blue-400 text-xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">Username</p>
                                        <p className="text-white font-bold text-xl">{fetchedUsername}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="group bg-gray-800/50 border border-white/10 rounded-xl p-6 hover:border-green-400/30 transition-all duration-300">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-green-500/20 to-blue-600/20 border border-green-500/30 flex items-center justify-center">
                                        <i className="fas fa-envelope text-green-400 text-xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">Email Address</p>
                                        <p className="text-white font-bold text-lg break-all">{user?.email}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="group bg-gray-800/50 border border-white/10 rounded-xl p-6 hover:border-purple-400/30 transition-all duration-300 md:col-span-2">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-600/20 border border-purple-500/30 flex items-center justify-center">
                                        <i className="fas fa-id-card text-purple-400 text-xl"></i>
                                    </div>
                                    <div>
                                        <p className="text-gray-400 text-sm font-medium">User ID</p>
                                        <p className="text-white font-mono text-sm break-all">{user?.uid}</p>
                                    </div>
                                </div>
                            </div>
                            
                            {userDiscordData && (
                                <div className="group bg-[#5865F2]/10 border border-[#5865F2]/30 rounded-xl p-6 hover:border-[#5865F2]/50 transition-all duration-300 md:col-span-2">
                                    <div className="flex items-center space-x-4 mb-4">
                                        <div className="w-14 h-14 rounded-xl bg-[#5865F2]/20 border border-[#5865F2]/30 flex items-center justify-center">
                                            <i className="fab fa-discord text-[#5865F2] text-xl"></i>
                                        </div>
                                        <div>
                                            <p className="text-[#5865F2] font-semibold text-sm">
                                                <i className="fas fa-check-circle mr-2"></i>
                                                Discord Connected
                                            </p>
                                            <p className="text-white font-bold text-lg">
                                                {userDiscordData.globalName || userDiscordData.username}
                                                {userDiscordData.discriminator !== '0' && (
                                                    <span className="text-gray-400 text-sm ml-2">#{userDiscordData.discriminator}</span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        
                        {/* Username Change Section */}
                        <div className="bg-gray-800/30 border border-white/10 rounded-xl p-6">
                            <div className="flex items-center space-x-4 mb-6">
                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500/20 to-red-600/20 border border-orange-500/30 flex items-center justify-center">
                                    <i className="fas fa-edit text-orange-400"></i>
                                </div>
                                <div>
                                    <h4 className="text-xl font-bold text-white">Change Username</h4>
                                    <p className="text-gray-400 text-sm">Update your display name across the platform</p>
                                </div>
                            </div>
                            
                            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
                                <input
                                    type="text"
                                    id="newUsername"
                                    className="flex-grow shadow appearance-none border rounded-xl py-4 px-4 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500/50 bg-gray-900/50 border-gray-700 transition-all duration-300"
                                    placeholder="Enter new username"
                                    value={newUsername}
                                    onChange={(e) => setNewUsername(e.target.value)}
                                />
                                <button
                                    onClick={handleUpdateUsername}
                                    className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center space-x-2"
                                >
                                    <i className="fas fa-save"></i>
                                    <span>Save Changes</span>
                                </button>
                            </div>
                        </div>
                        
                        {/* Additional Actions */}
                        <div className="mt-8 flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={handleChangePassword}
                                className="flex-1 flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                            >
                                <i className="fas fa-key"></i>
                                <span>Change Password</span>
                            </button>
                        </div>
                    </div>
                );
            case 'my-scripts': // Renamed from 'scripts'
                return (
                    <MyScripts 
                        user={user}
                        db={db}
                        userDiscordData={userDiscordData}
                        setModalMessage={setModalMessage}
                        setCurrentPage={(page) => setActivePanelTab(page === 'settings' ? 'settings' : page)}
                        setActivityLog={setActivityLog}
                        onShowClaimModal={onShowClaimModal}
                        onShowUpdatesModal={onShowUpdatesModal}
                    />
                );
            case 'custom-orders':
                return (
                    <CustomOrders 
                        user={user} 
                        db={db} 
                        setModalMessage={setModalMessage}
                        onShowCustomOrderModal={onShowCustomOrderModal}
                        onShowCustomOrderChatModal={onShowCustomOrderChatModal}
                    />
                );
            case 'support':
                return <ClientSupport 
                    user={user} 
                    db={db} 
                    setModalMessage={setModalMessage} 
                    fetchedUsername={fetchedUsername}
                    onShowNewTicketModal={onShowNewTicketModal}
                />;
            case 'files':
                return (
                    <div className="glass-card p-8 rounded-2xl flex-grow min-h-[600px]">
                        <div className="text-center">
                            {/* Icon and Title */}
                            <div className="w-24 h-24 mx-auto mb-6 rounded-3xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 border border-blue-500/30 flex items-center justify-center">
                                <i className="fas fa-cloud-upload-alt text-4xl gradient-text"></i>
                            </div>
                            
                            <h3 className="text-3xl font-bold gradient-text mb-4">File Management</h3>
                            <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
                                Upload, download, and manage your server files directly from the panel. Support for scripts, configurations, and resource files.
                            </p>
                            
                            {/* Feature Cards */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                                <div className="glass-card p-6 rounded-xl border border-white/10 hover:border-green-400/30 transition-all duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-gradient-to-br from-green-500/20 to-blue-600/20 flex items-center justify-center">
                                        <i className="fas fa-upload text-green-400"></i>
                                    </div>
                                    <h4 className="text-lg font-semibold text-white mb-2">Drag & Drop Upload</h4>
                                    <p className="text-gray-400 text-sm">Easily upload files with drag and drop interface, support for multiple file types</p>
                                </div>
                                
                                <div className="glass-card p-6 rounded-xl border border-white/10 hover:border-purple-400/30 transition-all duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-600/20 flex items-center justify-center">
                                        <i className="fas fa-folder-open text-purple-400"></i>
                                    </div>
                                    <h4 className="text-lg font-semibold text-white mb-2">File Browser</h4>
                                    <p className="text-gray-400 text-sm">Navigate through your server files with an intuitive file browser interface</p>
                                </div>
                                
                                <div className="glass-card p-6 rounded-xl border border-white/10 hover:border-orange-400/30 transition-all duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-gradient-to-br from-orange-500/20 to-red-600/20 flex items-center justify-center">
                                        <i className="fas fa-shield-alt text-orange-400"></i>
                                    </div>
                                    <h4 className="text-lg font-semibold text-white mb-2">Secure Transfer</h4>
                                    <p className="text-gray-400 text-sm">Encrypted file transfers with automatic backup and version control</p>
                                </div>
                            </div>
                            
                            {/* Action Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                                <button 
                                    onClick={handleUploadFile} 
                                    className="group flex-1 flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5 cursor-not-allowed opacity-75"
                                    disabled={!user}
                                >
                                    <i className="fas fa-cloud-upload-alt group-hover:scale-110 transition-transform duration-300"></i>
                                    <span>Upload Files</span>
                                </button>
                                <button 
                                    onClick={handleDownloadFile} 
                                    className="group flex-1 flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5 cursor-not-allowed opacity-75"
                                    disabled={!user}
                                >
                                    <i className="fas fa-download group-hover:scale-110 transition-transform duration-300"></i>
                                    <span>Download Files</span>
                                </button>
                            </div>
                            
                            <div className="mt-6 p-4 bg-yellow-900/20 border border-yellow-600/20 rounded-xl">
                                <div className="flex items-center justify-center space-x-2 text-yellow-400">
                                    <i className="fas fa-exclamation-triangle"></i>
                                    <span className="font-semibold">Development in Progress</span>
                                </div>
                                <p className="text-yellow-200 text-sm mt-2">
                                    File management features are currently being developed. Full functionality will be available soon!
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case 'analytics': // Analytics tab content
                return (
                    <div className="space-y-8 flex-grow">
                        {/* Real-time Analytics Chart */}
                        <div className="glass-card p-8 rounded-2xl border border-white/10">
                            <div className="flex items-center justify-between mb-6">
                                <div>
                                    <h3 className="text-2xl font-bold gradient-text">Real-time Analytics</h3>
                                    <p className="text-gray-400 mt-1">Live server performance and player activity monitoring</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                                    <span className="text-green-400 text-sm font-medium">Live</span>
                                </div>
                            </div>
                            
                            <div className="h-64 bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-xl flex items-center justify-center text-gray-400 border border-white/5">
                                <div className="text-center">
                                    <i className="fas fa-chart-area text-4xl mb-4 opacity-50"></i>
                                    <p className="text-lg font-medium mb-2">Interactive Analytics Dashboard</p>
                                    <p className="text-sm">Real-time charts powered by D3.js, Chart.js, or Recharts will be displayed here</p>
                                </div>
                            </div>
                            
                            <div className="mt-6 flex flex-wrap gap-4 text-sm text-gray-400">
                                <div className="flex items-center space-x-2">
                                    <div className="w-3 h-3 bg-blue-400 rounded-full"></div>
                                    <span>Server Performance</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                                    <span>Player Activity</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <div className="w-3 h-3 bg-purple-400 rounded-full"></div>
                                    <span>Resource Usage</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <div className="w-3 h-3 bg-orange-400 rounded-full"></div>
                                    <span>Network Traffic</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Statistics Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            <div className="group glass-card p-6 rounded-2xl border border-white/10 hover:border-blue-400/30 hover:-translate-y-1 transition-all duration-300">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 flex items-center justify-center">
                                        <i className="fas fa-users text-blue-400"></i>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-2xl font-bold text-white">1,234</p>
                                        <div className="flex items-center space-x-1 text-green-400 text-sm">
                                            <i className="fas fa-arrow-up text-xs"></i>
                                            <span>+5%</span>
                                        </div>
                                    </div>
                                </div>
                                <h4 className="text-lg font-bold text-white mb-1">Daily Active Users</h4>
                                <p className="text-gray-400 text-sm">Compared to yesterday</p>
                            </div>
                            
                            <div className="group glass-card p-6 rounded-2xl border border-white/10 hover:border-green-400/30 hover:-translate-y-1 transition-all duration-300">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-500/20 to-blue-600/20 flex items-center justify-center">
                                        <i className="fas fa-heartbeat text-green-400"></i>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-2xl font-bold text-white">99.9%</p>
                                        <div className="flex items-center space-x-1 text-green-400 text-sm">
                                            <i className="fas fa-check text-xs"></i>
                                            <span>Stable</span>
                                        </div>
                                    </div>
                                </div>
                                <h4 className="text-lg font-bold text-white mb-1">Server Uptime</h4>
                                <p className="text-gray-400 text-sm">Last 30 days</p>
                            </div>
                            
                            <div className="group glass-card p-6 rounded-2xl border border-white/10 hover:border-purple-400/30 hover:-translate-y-1 transition-all duration-300">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-600/20 flex items-center justify-center">
                                        <i className="fas fa-tachometer-alt text-purple-400"></i>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-2xl font-bold text-white">45ms</p>
                                        <div className="flex items-center space-x-1 text-green-400 text-sm">
                                            <i className="fas fa-arrow-down text-xs"></i>
                                            <span>-12%</span>
                                        </div>
                                    </div>
                                </div>
                                <h4 className="text-lg font-bold text-white mb-1">Avg Response Time</h4>
                                <p className="text-gray-400 text-sm">Server response time</p>
                            </div>
                            
                            <div className="group glass-card p-6 rounded-2xl border border-white/10 hover:border-orange-400/30 hover:-translate-y-1 transition-all duration-300">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500/20 to-red-600/20 flex items-center justify-center">
                                        <i className="fas fa-memory text-orange-400"></i>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-2xl font-bold text-white">2.4GB</p>
                                        <div className="flex items-center space-x-1 text-yellow-400 text-sm">
                                            <i className="fas fa-minus text-xs"></i>
                                            <span>Normal</span>
                                        </div>
                                    </div>
                                </div>
                                <h4 className="text-lg font-bold text-white mb-1">Memory Usage</h4>
                                <p className="text-gray-400 text-sm">Current consumption</p>
                            </div>
                        </div>

                        {/* Additional Analytics Sections */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            <div className="glass-card p-6 rounded-2xl border border-white/10">
                                <h4 className="text-xl font-bold text-white mb-4 flex items-center">
                                    <i className="fas fa-clock mr-3 text-blue-400"></i>
                                    Peak Hours Analysis
                                </h4>
                                <div className="h-40 bg-gradient-to-br from-gray-800/30 to-gray-900/30 rounded-lg flex items-center justify-center text-gray-400 border border-white/5">
                                    <div className="text-center">
                                        <i className="fas fa-chart-bar text-3xl mb-2 opacity-50"></i>
                                        <p className="text-sm">Peak activity hours visualization</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="glass-card p-6 rounded-2xl border border-white/10">
                                <h4 className="text-xl font-bold text-white mb-4 flex items-center">
                                    <i className="fas fa-globe mr-3 text-green-400"></i>
                                    Geographic Distribution
                                </h4>
                                <div className="h-40 bg-gradient-to-br from-gray-800/30 to-gray-900/30 rounded-lg flex items-center justify-center text-gray-400 border border-white/5">
                                    <div className="text-center">
                                        <i className="fas fa-map text-3xl mb-2 opacity-50"></i>
                                        <p className="text-sm">Player geographic distribution map</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 'activity': // Activity Log tab content
                return (
                    <div className="glass-card p-8 rounded-2xl flex-grow min-h-[600px]">
                        <div className="flex items-center justify-between mb-6">
                            <div>
                                <h3 className="text-3xl font-bold gradient-text">Activity Log</h3>
                                <p className="text-gray-400 mt-1">Track your account activity and system events</p>
                            </div>
                            <button
                                onClick={handleClearActivityLog}
                                className="group flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                            >
                                <i className="fas fa-trash group-hover:scale-110 transition-transform duration-300"></i>
                                <span>Clear Log</span>
                            </button>
                        </div>
                        
                        {/* Filter Tags */}
                        <div className="mb-6">
                            <p className="text-gray-400 text-sm mb-3 font-medium">Filter by activity type:</p>
                            <div className="flex flex-wrap gap-2">
                                {[
                                    { key: 'all', label: 'All Activities', icon: 'fas fa-list' },
                                    { key: 'login', label: 'Login', icon: 'fas fa-sign-in-alt' },
                                    { key: 'script', label: 'Scripts', icon: 'fas fa-code' },
                                    { key: 'profile', label: 'Profile', icon: 'fas fa-user' },
                                    { key: 'analytics', label: 'Analytics', icon: 'fas fa-chart-line' },
                                    { key: 'settings', label: 'Settings', icon: 'fas fa-cog' },
                                    { key: 'files', label: 'Files', icon: 'fas fa-folder' },
                                    { key: 'custom-orders', label: 'Orders', icon: 'fas fa-shopping-cart' },
                                    { key: 'support', label: 'Support', icon: 'fas fa-life-ring' }
                                ].map(filter => (
                                    <button
                                        key={filter.key}
                                        onClick={() => setFilterActivityType(filter.key)}
                                        className={`group flex items-center space-x-2 px-4 py-2 rounded-xl text-sm font-medium transition-all duration-300 border ${
                                            filterActivityType === filter.key 
                                                ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white border-blue-400/50 shadow-lg' 
                                                : 'bg-gray-800/50 text-gray-300 border-white/10 hover:bg-gray-700/50 hover:border-gray-600'
                                        }`}
                                    >
                                        <i className={`${filter.icon} text-xs group-hover:scale-110 transition-transform duration-300`}></i>
                                        <span>{filter.label}</span>
                                        {filterActivityType === filter.key && (
                                            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                        
                        {/* Activity List */}
                        <div className="max-h-96 overflow-y-auto custom-scrollbar pr-2">
                            {filteredActivityLog.length > 0 ? (
                                <div className="space-y-3">
                                    {filteredActivityLog.map((log) => {
                                        const getActivityIcon = (type) => {
                                            switch(type) {
                                                case 'login': return { icon: 'fas fa-sign-in-alt', color: 'text-green-400' };
                                                case 'script': return { icon: 'fas fa-code', color: 'text-blue-400' };
                                                case 'profile': return { icon: 'fas fa-user', color: 'text-purple-400' };
                                                case 'analytics': return { icon: 'fas fa-chart-line', color: 'text-orange-400' };
                                                case 'settings': return { icon: 'fas fa-cog', color: 'text-gray-400' };
                                                case 'files': return { icon: 'fas fa-folder', color: 'text-yellow-400' };
                                                case 'custom-orders': return { icon: 'fas fa-shopping-cart', color: 'text-pink-400' };
                                                case 'support': return { icon: 'fas fa-life-ring', color: 'text-red-400' };
                                                case 'server': return { icon: 'fas fa-server', color: 'text-cyan-400' };
                                                default: return { icon: 'fas fa-info-circle', color: 'text-gray-400' };
                                            }
                                        };
                                        
                                        const { icon, color } = getActivityIcon(log.type);
                                        
                                        return (
                                            <div key={log.id} className="group bg-gray-800/30 border border-white/5 hover:border-white/20 p-4 rounded-xl transition-all duration-300 hover:bg-gray-800/50">
                                                <div className="flex items-start space-x-4">
                                                    <div className={`w-10 h-10 rounded-xl bg-gray-700/50 border border-white/10 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                                                        <i className={`${icon} ${color} text-sm`}></i>
                                                    </div>
                                                    <div className="flex-grow">
                                                        <div className="flex items-center justify-between mb-1">
                                                            <span className="text-gray-400 text-sm font-medium">{log.timestamp}</span>
                                                            <span className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
                                                                log.type === 'login' ? 'bg-green-900/30 text-green-400' :
                                                                log.type === 'script' ? 'bg-blue-900/30 text-blue-400' :
                                                                log.type === 'profile' ? 'bg-purple-900/30 text-purple-400' :
                                                                log.type === 'analytics' ? 'bg-orange-900/30 text-orange-400' :
                                                                log.type === 'settings' ? 'bg-gray-900/30 text-gray-400' :
                                                                log.type === 'files' ? 'bg-yellow-900/30 text-yellow-400' :
                                                                log.type === 'custom-orders' ? 'bg-pink-900/30 text-pink-400' :
                                                                log.type === 'support' ? 'bg-red-900/30 text-red-400' :
                                                                log.type === 'server' ? 'bg-cyan-900/30 text-cyan-400' :
                                                                'bg-gray-900/30 text-gray-400'
                                                            }`}>
                                                                {log.type}
                                                            </span>
                                                        </div>
                                                        <p className="text-white text-sm leading-relaxed">{log.message}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center py-16">
                                    <div className="w-20 h-20 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-gray-700/20 to-gray-800/20 border border-white/5 flex items-center justify-center">
                                        <i className="fas fa-search text-gray-500 text-2xl"></i>
                                    </div>
                                    <p className="text-gray-400 text-lg font-medium mb-2">No activities found</p>
                                    <p className="text-gray-500 text-sm">No activities match the selected filter.</p>
                                </div>
                            )}
                        </div>
                        
                        {filteredActivityLog.length > 0 && (
                            <div className="mt-6 text-center">
                                <p className="text-gray-500 text-sm">
                                    Showing {filteredActivityLog.length} of {activityLog.length} activities
                                </p>
                            </div>
                        )}
                        
                        <style>{`
                            .custom-scrollbar::-webkit-scrollbar {
                                width: 8px;
                            }
                            .custom-scrollbar::-webkit-scrollbar-track {
                                background: rgba(255, 255, 255, 0.1);
                                border-radius: 10px;
                            }
                            .custom-scrollbar::-webkit-scrollbar-thumb {
                                background: #4d9eff;
                                border-radius: 10px;
                            }
                            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                                background: #316dae;
                            }
                        `}</style>
                    </div>
                );
            case 'settings':
                return (
                    <div className="glass-card p-6 rounded-lg flex-grow flex flex-col lg:flex-row">
                        {/* Settings Navigation Tabs */}
                        <div className="lg:w-1/4 w-full flex lg:flex-col mb-6 lg:mb-0 space-x-2 lg:space-x-0 lg:space-y-4 custom-scrollbar">
                            <button
                                onClick={() => setIsSettingsTabOpen('profile')}
                                className={`
                                    w-full text-left px-6 py-5 rounded-2xl transition-all duration-500 flex items-center transform hover:scale-105 border-2 shadow-xl hover:shadow-2xl hover:-translate-y-1 relative overflow-hidden group min-w-[200px] lg:min-w-0
                                    ${isSettingsTabOpen === 'profile' 
                                        ? 'bg-gradient-to-br from-blue-500/40 to-cyan-500/30 text-blue-50 border-blue-400/60 shadow-blue-500/25' 
                                        : 'glass-card backdrop-blur-xl bg-white/5 text-gray-300 hover:bg-gradient-to-br hover:from-blue-500/20 hover:to-cyan-500/10 hover:text-blue-100 border-white/20 hover:border-blue-400/50'
                                    }
                                `}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mr-4 shadow-lg transition-all duration-500 border-2 relative z-10 ${
                                    isSettingsTabOpen === 'profile' 
                                        ? 'bg-gradient-to-br from-blue-600/60 to-cyan-600/40 border-blue-300/50 shadow-blue-500/30' 
                                        : 'bg-gradient-to-br from-white/20 to-white/10 border-white/30 group-hover:from-blue-500/40 group-hover:to-cyan-500/30 group-hover:border-blue-300/50'
                                }`}>
                                    <i className={`fas fa-user-circle text-lg ${isSettingsTabOpen === 'profile' ? 'text-blue-100' : 'text-blue-400 group-hover:text-blue-200'}`}></i>
                                </div>
                                <div className="relative z-10">
                                    <div className="font-bold text-lg">Profile</div>
                                    <div className="text-sm opacity-80">Account details</div>
                                </div>
                            </button>
                            <button
                                onClick={() => setIsSettingsTabOpen('discord')}
                                className={`
                                    w-full text-left px-6 py-5 rounded-2xl transition-all duration-500 flex items-center transform hover:scale-105 border-2 shadow-xl hover:shadow-2xl hover:-translate-y-1 relative overflow-hidden group min-w-[200px] lg:min-w-0
                                    ${isSettingsTabOpen === 'discord' 
                                        ? 'bg-gradient-to-br from-indigo-500/40 to-purple-500/30 text-indigo-50 border-indigo-400/60 shadow-indigo-500/25' 
                                        : 'glass-card backdrop-blur-xl bg-white/5 text-gray-300 hover:bg-gradient-to-br hover:from-indigo-500/20 hover:to-purple-500/10 hover:text-indigo-100 border-white/20 hover:border-indigo-400/50'
                                    }
                                `}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mr-4 shadow-lg transition-all duration-500 border-2 relative z-10 ${
                                    isSettingsTabOpen === 'discord' 
                                        ? 'bg-gradient-to-br from-indigo-600/60 to-purple-600/40 border-indigo-300/50 shadow-indigo-500/30' 
                                        : 'bg-gradient-to-br from-white/20 to-white/10 border-white/30 group-hover:from-indigo-500/40 group-hover:to-purple-500/30 group-hover:border-indigo-300/50'
                                }`}>
                                    <i className={`fab fa-discord text-lg ${isSettingsTabOpen === 'discord' ? 'text-indigo-100' : 'text-indigo-400 group-hover:text-indigo-200'}`}></i>
                                </div>
                                <div className="relative z-10">
                                    <div className="font-bold text-lg">Discord</div>
                                    <div className="text-sm opacity-80">Integration settings</div>
                                </div>
                            </button>
                            <button
                                onClick={() => setIsSettingsTabOpen('security')}
                                className={`
                                    w-full text-left px-6 py-5 rounded-2xl transition-all duration-500 flex items-center transform hover:scale-105 border-2 shadow-xl hover:shadow-2xl hover:-translate-y-1 relative overflow-hidden group min-w-[200px] lg:min-w-0
                                    ${isSettingsTabOpen === 'security' 
                                        ? 'bg-gradient-to-br from-green-500/40 to-emerald-500/30 text-green-50 border-green-400/60 shadow-green-500/25' 
                                        : 'glass-card backdrop-blur-xl bg-white/5 text-gray-300 hover:bg-gradient-to-br hover:from-green-500/20 hover:to-emerald-500/10 hover:text-green-100 border-white/20 hover:border-green-400/50'
                                    }
                                `}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mr-4 shadow-lg transition-all duration-500 border-2 relative z-10 ${
                                    isSettingsTabOpen === 'security' 
                                        ? 'bg-gradient-to-br from-green-600/60 to-emerald-600/40 border-green-300/50 shadow-green-500/30' 
                                        : 'bg-gradient-to-br from-white/20 to-white/10 border-white/30 group-hover:from-green-500/40 group-hover:to-emerald-500/30 group-hover:border-green-300/50'
                                }`}>
                                    <i className={`fas fa-lock text-lg ${isSettingsTabOpen === 'security' ? 'text-green-100' : 'text-green-400 group-hover:text-green-200'}`}></i>
                                </div>
                                <div className="relative z-10">
                                    <div className="font-bold text-lg">Security</div>
                                    <div className="text-sm opacity-80">Password & 2FA</div>
                                </div>
                            </button>
                            <button
                                onClick={() => setIsSettingsTabOpen('account')}
                                className={`
                                    w-full text-left px-6 py-5 rounded-2xl transition-all duration-500 flex items-center transform hover:scale-105 border-2 shadow-xl hover:shadow-2xl hover:-translate-y-1 relative overflow-hidden group min-w-[200px] lg:min-w-0
                                    ${isSettingsTabOpen === 'account' 
                                        ? 'bg-gradient-to-br from-orange-500/40 to-red-500/30 text-orange-50 border-orange-400/60 shadow-orange-500/25' 
                                        : 'glass-card backdrop-blur-xl bg-white/5 text-gray-300 hover:bg-gradient-to-br hover:from-orange-500/20 hover:to-red-500/10 hover:text-orange-100 border-white/20 hover:border-orange-400/50'
                                    }
                                `}
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mr-4 shadow-lg transition-all duration-500 border-2 relative z-10 ${
                                    isSettingsTabOpen === 'account' 
                                        ? 'bg-gradient-to-br from-orange-600/60 to-red-600/40 border-orange-300/50 shadow-orange-500/30' 
                                        : 'bg-gradient-to-br from-white/20 to-white/10 border-white/30 group-hover:from-orange-500/40 group-hover:to-red-500/30 group-hover:border-orange-300/50'
                                }`}>
                                    <i className={`fas fa-cog text-lg ${isSettingsTabOpen === 'account' ? 'text-orange-100' : 'text-orange-400 group-hover:text-orange-200'}`}></i>
                                </div>
                                <div className="relative z-10">
                                    <div className="font-bold text-lg">Account</div>
                                    <div className="text-sm opacity-80">Data & deletion</div>
                                </div>
                            </button>
                        </div>
                        
                        {/* Settings Content */}
                        <div className="lg:w-3/4 w-full lg:ml-6">
                            {isSettingsTabOpen === 'profile' && (
                                <div className="glass-card p-8 rounded-2xl animate-fadeIn">
                                    <div className="animate-fadeIn" style={{ animationDelay: '0.1s' }}>
                                        <h3 className="text-3xl font-bold gradient-text mb-6">Profile Settings</h3>
                                    </div>
                                    
                                    {/* Profile Info Cards */}
                                    <div className="space-y-6 mb-8">
                                        <div className="group bg-gray-800/50 border border-white/10 rounded-xl p-6 hover:border-blue-400/30 transition-all duration-500 w-full transform hover:scale-[1.02] hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-500/10 animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.2s' }}>
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                            <div className="flex items-center space-x-4 relative z-10">
                                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 to-purple-600/20 border border-blue-500/30 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                                                    <i className="fas fa-user text-blue-400 transition-all duration-300 group-hover:text-blue-300"></i>
                                                </div>
                                                <div className="transition-all duration-300 group-hover:translate-x-1">
                                                    <p className="text-gray-400 text-sm transition-colors duration-300 group-hover:text-gray-300">Username</p>
                                                    <p className="text-white font-semibold text-lg transition-all duration-300 group-hover:text-blue-100">{fetchedUsername}</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="group bg-gray-800/50 border border-white/10 rounded-xl p-6 hover:border-green-400/30 transition-all duration-500 w-full transform hover:scale-[1.02] hover:-translate-y-1 hover:shadow-2xl hover:shadow-green-500/10 animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.3s' }}>
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                            <div className="flex items-center space-x-4 relative z-10">
                                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-500/20 to-blue-600/20 border border-green-500/30 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                                                    <i className="fas fa-envelope text-green-400 transition-all duration-300 group-hover:text-green-300"></i>
                                                </div>
                                                <div className="transition-all duration-300 group-hover:translate-x-1">
                                                    <p className="text-gray-400 text-sm transition-colors duration-300 group-hover:text-gray-300">Email Address</p>
                                                    <p className="text-white font-semibold text-lg transition-all duration-300 group-hover:text-green-100">{user?.email}</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="group bg-gray-800/50 border border-white/10 rounded-xl p-6 hover:border-purple-400/30 transition-all duration-500 w-full transform hover:scale-[1.02] hover:-translate-y-1 hover:shadow-2xl hover:shadow-purple-500/10 animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.4s' }}>
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                            <div className="flex items-center space-x-4 relative z-10">
                                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-600/20 border border-purple-500/30 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                                                    <i className="fas fa-id-card text-purple-400 transition-all duration-300 group-hover:text-purple-300"></i>
                                                </div>
                                                <div className="transition-all duration-300 group-hover:translate-x-1">
                                                    <p className="text-gray-400 text-sm transition-colors duration-300 group-hover:text-gray-300">User ID</p>
                                                    <p className="text-white font-mono text-sm break-all transition-all duration-300 group-hover:text-purple-100">{user?.uid}</p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {userDiscordData && (
                                            <div className="group bg-[#5865F2]/10 border border-[#5865F2]/30 rounded-xl p-6 hover:border-[#5865F2]/50 transition-all duration-500 w-full transform hover:scale-[1.02] hover:-translate-y-1 hover:shadow-2xl hover:shadow-[#5865F2]/10 animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.5s' }}>
                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#5865F2]/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                                                <div className="flex items-center space-x-4 relative z-10">
                                                    <div className="w-12 h-12 rounded-xl bg-[#5865F2]/20 border border-[#5865F2]/30 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                                                        <i className="fab fa-discord text-[#5865F2] transition-all duration-300 group-hover:text-[#7289da]"></i>
                                                    </div>
                                                    <div className="transition-all duration-300 group-hover:translate-x-1">
                                                        <p className="text-[#5865F2] font-semibold text-sm transition-colors duration-300 group-hover:text-[#7289da]">
                                                            <i className="fas fa-check-circle mr-2"></i>
                                                            Discord Connected
                                                        </p>
                                                        <p className="text-white font-semibold text-lg transition-all duration-300 group-hover:text-[#7289da]">
                                                            {userDiscordData.globalName || userDiscordData.username}
                                                            {userDiscordData.discriminator !== '0' && (
                                                                <span className="text-gray-400 text-sm ml-2">#{userDiscordData.discriminator}</span>
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Username Change Section */}
                                    <div className="bg-gray-800/30 border border-white/10 rounded-xl p-6 animate-fadeIn hover:border-orange-400/30 transition-all duration-500 transform hover:scale-[1.01] hover:shadow-xl hover:shadow-orange-500/10 relative overflow-hidden group" style={{ animationDelay: '0.6s' }}>
                                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400/3 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-800"></div>
                                        <div className="flex items-center space-x-3 mb-4 relative z-10">
                                            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500/20 to-red-600/20 border border-orange-500/30 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                <i className="fas fa-edit text-orange-400 transition-all duration-300 group-hover:text-orange-300"></i>
                                            </div>
                                            <h4 className="text-xl font-bold text-white transition-all duration-300 group-hover:text-orange-100">Change Username</h4>
                                        </div>
                                        <p className="text-gray-400 text-sm mb-4 relative z-10 transition-all duration-300 group-hover:text-gray-300">Update your display name across the platform</p>
                                        <div className="flex space-x-3 relative z-10">
                                            <input
                                                type="text"
                                                id="newUsername"
                                                className="flex-grow glass-card backdrop-blur-xl bg-white/5 border border-white/10 rounded-xl py-4 px-6 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-orange-400/50 focus:border-orange-400/30 hover:border-white/20 transition-all duration-300 placeholder:text-gray-400 text-lg font-medium shadow-lg focus:scale-[1.01] focus:shadow-xl focus:shadow-orange-500/10"
                                                placeholder="Enter new username"
                                                value={newUsername}
                                                onChange={(e) => setNewUsername(e.target.value)}
                                            />
                                            <button
                                                onClick={handleUpdateUsername}
                                                className="px-6 py-4 bg-gradient-to-r from-orange-500/20 to-red-600/20 border border-orange-500/30 backdrop-blur-xl hover:from-orange-500/30 hover:to-red-600/30 hover:border-orange-400/50 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-1 hover:scale-105 glass-card relative overflow-hidden group"
                                            >
                                                <div className="absolute inset-0 bg-gradient-to-r from-orange-600/20 to-red-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                                <div className="relative z-10">
                                                    <i className="fas fa-save mr-2 text-orange-400 transition-all duration-300 group-hover:text-orange-300"></i>
                                                    Save
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isSettingsTabOpen === 'discord' && (
                                <div className="animate-fadeIn" style={{ animationDelay: '0.1s' }}>
                                    <DiscordSettings 
                                        user={user} 
                                        db={db} 
                                        userDiscordData={userDiscordData}
                                        setUserDiscordData={setUserDiscordData}
                                        setModalMessage={setModalMessage}
                                    />
                                </div>
                            )}

                            {isSettingsTabOpen === 'appearance' && (
                                <div className="glass-card p-8 rounded-2xl animate-fadeIn">
                                    <h3 className="text-3xl font-bold gradient-text mb-6">Appearance Settings</h3>
                                    
                                    <div className="bg-gray-800/30 border border-white/10 rounded-xl p-6">
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-yellow-500/20 to-orange-600/20 border border-yellow-500/30 flex items-center justify-center">
                                                    <i className="fas fa-palette text-yellow-400"></i>
                                                </div>
                                                <div>
                                                    <h4 className="text-lg font-bold text-white">Panel Theme</h4>
                                                    <p className="text-gray-400 text-sm">Choose your preferred theme appearance</p>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                                <span className={`text-sm font-semibold transition-colors ${panelTheme === 'dark' ? 'text-blue-400' : 'text-gray-500'}`}>Dark</span>
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={panelTheme === 'light'}
                                                        onChange={() => setPanelTheme(panelTheme === 'dark' ? 'light' : 'dark')}
                                                        className="sr-only peer"
                                                    />
                                                    <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-blue-600 peer-checked:to-purple-600"></div>
                                                </label>
                                                <span className={`text-sm font-semibold transition-colors ${panelTheme === 'light' ? 'text-blue-400' : 'text-gray-500'}`}>Light</span>
                                            </div>
                                        </div>
                                        
                                        <div className="mt-6 pt-4 border-t border-gray-700/50">
                                            <button 
                                                onClick={handleSaveSettings} 
                                                className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                                            >
                                                <i className="fas fa-save"></i>
                                                <span>Save Theme Settings</span>
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-gray-800/20 border border-white/5 rounded-xl p-6 mt-6">
                                        <div className="flex items-center space-x-3 mb-3">
                                            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500/20 to-purple-600/20 border border-blue-500/30 flex items-center justify-center">
                                                <i className="fas fa-info-circle text-blue-400 text-sm"></i>
                                            </div>
                                            <h5 className="text-white font-semibold">Theme Information</h5>
                                        </div>
                                        <p className="text-gray-400 text-sm leading-relaxed">
                                            The theme setting controls the overall appearance of the panel. Dark theme is optimized for low-light environments and reduces eye strain during extended use.
                                        </p>
                                    </div>
                                </div>
                            )}

                            {isSettingsTabOpen === 'security' && (
                                <div className="glass-card p-8 rounded-2xl animate-fadeIn">
                                    <div className="animate-fadeIn" style={{ animationDelay: '0.1s' }}>
                                        <h3 className="text-3xl font-bold gradient-text mb-6">Security Settings</h3>
                                        <p className="text-gray-400 mb-8">Protect your account with additional security features and manage your authentication settings.</p>
                                    </div>
                                    
                                    <div className="space-y-6">
                                        {/* Change Password Card */}
                                        <div className="group bg-gray-800/30 border border-white/10 rounded-xl p-6 hover:border-red-400/30 transition-all duration-500 transform hover:scale-[1.01] hover:-translate-y-1 hover:shadow-2xl hover:shadow-red-500/10 animate-fadeIn relative overflow-hidden" style={{ animationDelay: '0.2s' }}>
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-red-400/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-800"></div>
                                            <div className="flex items-center justify-between relative z-10">
                                                <div className="flex items-center space-x-4">
                                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-red-500/20 to-orange-600/20 border border-red-500/30 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                        <i className="fas fa-key text-red-400 transition-all duration-300 group-hover:text-red-300"></i>
                                                    </div>
                                                    <div className="transition-all duration-300 group-hover:translate-x-1">
                                                        <h4 className="text-lg font-bold text-white transition-colors duration-300 group-hover:text-red-100">Change Password</h4>
                                                        <p className="text-gray-400 text-sm transition-colors duration-300 group-hover:text-gray-300">Update your account password for enhanced security</p>
                                                    </div>
                                                </div>
                                                <button 
                                                    onClick={handleChangePassword} 
                                                    className="px-6 py-3 bg-gradient-to-r from-red-600/20 to-orange-600/20 border border-red-500/30 hover:from-red-600/30 hover:to-orange-600/30 hover:border-red-400/50 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-1 hover:scale-105 group/btn relative overflow-hidden"
                                                >
                                                    <div className="absolute inset-0 bg-gradient-to-r from-red-600/30 to-orange-600/30 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
                                                    <div className="relative z-10">
                                                        <i className="fas fa-edit mr-2 transition-all duration-300 group-hover/btn:rotate-12"></i>
                                                        Update
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                        
                                        {/* Two-Factor Authentication Card (Coming Soon) */}
                                        <div className="group bg-gray-800/20 border border-white/5 rounded-xl p-6 opacity-70 animate-fadeIn transition-all duration-500 hover:opacity-80 hover:border-white/10 transform hover:scale-[1.005]" style={{ animationDelay: '0.3s' }}>
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-4">
                                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-500/20 to-blue-600/20 border border-green-500/30 flex items-center justify-center transition-all duration-300 group-hover:scale-105">
                                                        <i className="fas fa-shield-alt text-green-400 transition-all duration-300 group-hover:text-green-300"></i>
                                                    </div>
                                                    <div>
                                                        <h4 className="text-lg font-bold text-white">Two-Factor Authentication</h4>
                                                        <p className="text-gray-400 text-sm">Add an extra layer of security to your account</p>
                                                    </div>
                                                </div>
                                                <button 
                                                    className="px-6 py-3 bg-gray-700/50 text-gray-300 rounded-xl font-medium cursor-not-allowed transition-all duration-300"
                                                    disabled
                                                >
                                                    <i className="fas fa-clock mr-2"></i>
                                                    Coming Soon
                                                </button>
                                            </div>
                                        </div>
                                        
                                        {/* Security Tips */}
                                        <div className="bg-blue-900/20 border border-blue-600/20 rounded-xl p-6">
                                            <div className="flex items-start space-x-3">
                                                <div className="w-8 h-8 rounded-lg bg-blue-500/20 border border-blue-500/30 flex items-center justify-center flex-shrink-0 mt-1">
                                                    <i className="fas fa-lightbulb text-blue-400 text-sm"></i>
                                                </div>
                                                <div>
                                                    <h5 className="text-blue-400 font-semibold mb-2">Security Tips</h5>
                                                    <ul className="text-gray-300 text-sm space-y-1 list-disc list-inside">
                                                        <li>Use a strong, unique password that you don't use elsewhere</li>
                                                        <li>Enable two-factor authentication when available</li>
                                                        <li>Regularly review your account activity</li>
                                                        <li>Never share your login credentials with anyone</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {isSettingsTabOpen === 'account' && (
                                <div className="space-y-6 animate-fadeIn">
                                    <div className="animate-fadeIn" style={{ animationDelay: '0.1s' }}>
                                        <h3 className="text-3xl font-bold gradient-text mb-6">Account Settings</h3>
                                        <p className="text-gray-300">
                                            Manage your account and data. Be careful, some actions are irreversible.
                                        </p>
                                    </div>
                                    <div className="space-y-6">
                                        {/* <div className="flex items-center justify-between border border-gray-700 p-4 rounded-lg bg-gray-900 opacity-50 cursor-not-allowed">
                                            <p className="text-white font-semibold">Export User Data</p>
                                            <button className="px-5 py-2 bg-gray-700 rounded-md text-white" disabled>
                                                Coming Soon
                                            </button>
                                        </div> */}
                                        <div className="group flex items-center justify-between border border-red-700/50 p-6 rounded-xl bg-red-900/20 hover:bg-red-900/30 border-red-700 hover:border-red-600 transition-all duration-500 animate-fadeIn transform hover:scale-[1.01] hover:-translate-y-1 hover:shadow-2xl hover:shadow-red-500/20 relative overflow-hidden" style={{ animationDelay: '0.2s' }}>
                                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-red-500/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-800"></div>
                                            <div className="flex items-center space-x-4 relative z-10">
                                                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-red-600/30 to-red-800/20 border border-red-500/40 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
                                                    <i className="fas fa-exclamation-triangle text-red-400 transition-all duration-300 group-hover:text-red-300"></i>
                                                </div>
                                                <div className="transition-all duration-300 group-hover:translate-x-1">
                                                    <p className="text-red-400 font-bold text-lg transition-colors duration-300 group-hover:text-red-300">Delete Account</p>
                                                    <p className="text-red-500 text-sm transition-colors duration-300 group-hover:text-red-400">Permanently remove your account and all data</p>
                                                </div>
                                            </div>
                                            <button 
                                                onClick={() => setModalMessage("Account deletion functionality is under development.")} 
                                                className="px-6 py-3 bg-gradient-to-r from-red-600/40 to-red-800/40 border border-red-500/50 hover:from-red-600/60 hover:to-red-800/60 hover:border-red-400/70 text-white rounded-xl transition-all duration-300 font-medium shadow-lg hover:shadow-xl hover:-translate-y-1 hover:scale-105 group/btn relative overflow-hidden"
                                            >
                                                <div className="absolute inset-0 bg-gradient-to-r from-red-600/50 to-red-800/50 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
                                                <div className="relative z-10">
                                                    <i className="fas fa-trash mr-2 transition-all duration-300 group-hover/btn:rotate-12"></i>
                                                    Delete
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen w-screen flex bg-[#111111] relative overflow-hidden p-4">
            {/* Background blur circles for design aesthetic */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
            </div>

            {/* Main Panel Container - now uses flex-grow to fill available space */}
            {/* Added h-full to glass-card to ensure it fills the height of its parent (which is min-h-screen) */}
            <div className="glass-card p-8 rounded-xl shadow-lg w-full h-full flex relative z-10 animate-fadeIn flex-col md:flex-row">
                {/* Sidebar Navigation */}
                <div className="w-full md:w-1/4 glass-card rounded-2xl p-6 md:mr-6 mb-6 md:mb-0 flex flex-col">
                    <DevcoreLogo />
                    
                    {/* Navigation Header */}
                    <div className="mt-8 mb-6">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-blue-500/20 rounded-xl flex items-center justify-center mr-3">
                                <i className="fas fa-tachometer-alt text-blue-400"></i>
                            </div>
                            <h3 className="text-lg font-bold text-white">Dashboard</h3>
                        </div>
                        <div className="h-px bg-gradient-to-r from-blue-500/50 to-transparent"></div>
                    </div>

                    {/* Navigation Menu */}
                    <nav className="space-y-2">
                        <button
                            onClick={() => setActivePanelTab('my-servers')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activePanelTab === 'my-servers' 
                                    ? 'bg-blue-500/20 text-blue-300 border border-blue-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activePanelTab === 'my-servers' ? 'bg-blue-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-server text-sm"></i>
                            </div>
                            <span className="font-semibold">My Servers</span>
                        </button>

                        <button
                            onClick={() => setActivePanelTab('my-scripts')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activePanelTab === 'my-scripts' 
                                    ? 'bg-green-500/20 text-green-300 border border-green-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activePanelTab === 'my-scripts' ? 'bg-green-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-code text-sm"></i>
                            </div>
                            <span className="font-semibold">My Scripts</span>
                        </button>

                        <button
                            onClick={() => setActivePanelTab('server-list')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activePanelTab === 'server-list' 
                                    ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activePanelTab === 'server-list' ? 'bg-purple-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-list-alt text-sm"></i>
                            </div>
                            <span className="font-semibold">Server List</span>
                        </button>

                        <button
                            onClick={() => setActivePanelTab('custom-orders')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activePanelTab === 'custom-orders' 
                                    ? 'bg-orange-500/20 text-orange-300 border border-orange-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activePanelTab === 'custom-orders' ? 'bg-orange-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-shopping-cart text-sm"></i>
                            </div>
                            <span className="font-semibold">Custom Orders</span>
                        </button>

                        <button
                            onClick={() => setActivePanelTab('support')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activePanelTab === 'support' 
                                    ? 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activePanelTab === 'support' ? 'bg-cyan-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-life-ring text-sm"></i>
                            </div>
                            <span className="font-semibold">Support</span>
                        </button>

                        <button
                            onClick={() => setActivePanelTab('settings')}
                            className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 ${
                                activePanelTab === 'settings' 
                                    ? 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30' 
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white border border-transparent'
                            }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-3 ${
                                activePanelTab === 'settings' ? 'bg-yellow-500/20' : 'bg-gray-500/20'
                            }`}>
                                <i className="fas fa-cog text-sm"></i>
                            </div>
                            <span className="font-semibold">Settings</span>
                        </button>

                        {isAdmin && (
                            <button
                                onClick={() => onManageAdmin()}
                                className="w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 bg-gradient-to-r from-purple-500/20 to-pink-500/20 text-purple-300 border border-purple-500/30 hover:from-purple-500/30 hover:to-pink-500/30"
                            >
                                <div className="w-8 h-8 rounded-lg bg-purple-500/20 flex items-center justify-center mr-3">
                                    <i className="fas fa-user-shield text-sm"></i>
                                </div>
                                <span className="font-semibold">Administration</span>
                                <div className="ml-auto">
                                    <div className="w-2 h-2 bg-purple-400 rounded-full animate-pulse"></div>
                                </div>
                            </button>
                        )}

                        {isAdmin && (
                            <button
                                onClick={() => onNavigateTodo()}
                                className="w-full text-left px-4 py-3 rounded-xl transition-all duration-300 flex items-center transform hover:scale-105 bg-gradient-to-r from-orange-500/20 to-red-500/20 text-orange-300 border border-orange-500/30 hover:from-orange-500/30 hover:to-red-500/30 group"
                            >
                                <div className="w-8 h-8 rounded-lg bg-gradient-to-r from-orange-500/20 to-red-500/20 flex items-center justify-center mr-3 group-hover:rotate-12 transition-transform duration-300">
                                    <i className="fas fa-fire text-sm group-hover:animate-pulse"></i>
                                </div>
                                <div className="flex flex-col">
                                    <span className="font-bold text-lg">🔥 PANEL TODO 🔥</span>
                                    <span className="text-xs text-orange-400/80">Epic task management</span>
                                </div>
                                <div className="ml-auto flex space-x-1">
                                    <div className="w-1.5 h-1.5 bg-orange-400 rounded-full animate-bounce"></div>
                                    <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                                    <div className="w-1.5 h-1.5 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
                                </div>
                            </button>
                        )}
                    </nav>

                    {/* Spacer */}
                    <div className="flex-grow min-h-8"></div>

                    {/* User Actions */}
                    <div className="mt-6">
                        <div className="h-px bg-gradient-to-r from-gray-500/50 to-transparent mb-6"></div>
                        {user && (
                            <button
                                onClick={onLogout}
                                className="w-full px-4 py-3 bg-red-500/20 hover:bg-red-500/30 text-red-400 hover:text-red-300 font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 border border-red-500/30 flex items-center justify-center mb-3"
                                disabled={loading}
                            >
                                <i className="fas fa-sign-out-alt mr-2"></i>
                                Logout
                            </button>
                        )}
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="w-full md:w-3/4 glass-card rounded-2xl p-6 overflow-y-auto flex flex-col">
                    <div className="flex items-center mb-8">
                        <div className="w-12 h-12 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl flex items-center justify-center mr-4">
                            {/* <i className="fas fa-desktop text-xl text-blue-400"></i> */}
                            <i className='fas fa-tachometer-alt text-xl text-blue-400'></i>
                        </div>
                        <div>
                            {/* <h2 className="text-4xl font-bold gradient-text">
                                {activePanelTab.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </h2> */}
                            <h2 className='text-4xl font-bold gradient-text'>
                                Dashboard
                            </h2>
                            <p className="text-gray-400 text-lg">
                                Welcome to your control panel
                            </p>
                        </div>
                    </div>
                    {user && fetchedUsername && (
                        <div className="mb-8">
                            {/* <p className="text-gray-300 mb-2">
                                Welcome, <span className="font-semibold text-[#4d9eff]">{fetchedUsername}</span>! We're glad to have you back.
                            </p> */}
                            {userDiscordData && (
                                <div className="flex items-center text-sm text-gray-400">
                                    <i className="fab fa-discord text-[#5865F2] mr-2"></i>
                                    <span>Connected as {userDiscordData.globalName || userDiscordData.username}{userDiscordData.discriminator !== '0' ? `#${userDiscordData.discriminator}` : ''}</span>
                                    <div className="w-2 h-2 bg-green-500 rounded-full ml-2 animate-pulse"></div>
                                </div>
                            )}
                        </div>
                    )}
                    {!user && (
                        <p className="text-gray-300 mb-4">
                            You are currently not logged in.
                        </p>
                    )}
                    {/* Removed the generic "Explore the different sections..." message as it's less necessary with a personalized welcome. */}
                    
                    {renderPanelContent()}
                </div>
            </div>
            {showAddServerModal && (
                <AddNewServerModal 
                    onClose={() => setShowAddServerModal(false)} 
                    onAddServer={handleAddServer} 
                    setModalMessage={setModalMessage} // Pass setModalMessage to the new modal
                />
            )}
        </div>
    );
};

// Home Page Component (a placeholder to navigate back to if needed)
const HomePage = ({ onNavigate, user }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#111111] relative overflow-hidden">
            {/* Background blur circles for design aesthetic */}
            <div className="absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-[#316dae] filter blur-3xl opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg w-full max-w-md text-center relative z-10 animate-fadeIn">
                <DevcoreLogo /> {/* Added Logo */}
                <h2 className="text-3xl font-bold gradient-text mb-6">Welcome to DEVCORE</h2>
                <p className="text-gray-300 mb-8">
                    This is the main landing page. From here, you can access the login, registration, or the panel.
                </p>
                <div className="flex flex-col space-y-4">
                    {!user && ( // Only show login/register if not logged in
                        <>
                            <button
                                onClick={() => onNavigate('login')}
                                className="bg-[#316dae] hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
                            >
                                Login
                            </button>
                            <button
                                onClick={() => onNavigate('register')}
                                className="bg-gray-700 hover:bg-gray-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
                            >
                                Register
                            </button>
                        </>
                    )}
                    <button
                        onClick={() => onNavigate('panel')}
                        className="bg-blue-800 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md transition duration-300"
                    >
                        Go to Panel
                    </button>
                </div>
            </div>
        </div>
    );
};

// Main App Component
const App = () => {
    const [currentPage, setCurrentPage] = useState('home'); 
    const [selectedServerId, setSelectedServerId] = useState(null); 
    const [modalMessage, setModalMessage] = useState(null);
    const [loading, setLoading] = useState(true); 
    const [user, setUser] = useState(null); 
    const [auth, setAuth] = useState(null); 
    const [db, setDb] = useState(null); 
    const [userColor, setUserColor] = useState('#4d9eff');
    const [userDiscordData, setUserDiscordData] = useState(null); // Discord data state 
    const [fetchedUsername, setFetchedUsername] = useState(''); // Username fetched from Firestore
    
    // Modal states for MyScripts modals
    const [showClaimScriptModal, setShowClaimScriptModal] = useState(false);
    const [showUpdatesModal, setShowUpdatesModal] = useState(false);
    const [selectedScriptForUpdates, setSelectedScriptForUpdates] = useState(null);
    
    // Modal states for CustomOrders modals
    const [showCustomOrderModal, setShowCustomOrderModal] = useState(false);
    const [orderToEdit, setOrderToEdit] = useState(null); 
    const [showCustomOrderChatModal, setShowCustomOrderChatModal] = useState(false);
    const [selectedOrderForChat, setSelectedOrderForChat] = useState(null);
    const [showNewTicketModal, setShowNewTicketModal] = useState(false);
    
    // Modal states for TodoModal
    const [showTodoModal, setShowTodoModal] = useState(false);
    const [todoToEdit, setTodoToEdit] = useState(null);
    const [allAdmins, setAllAdmins] = useState([]); // State to store all admin users
    
    // Modal states for EventModal
    const [showEventModal, setShowEventModal] = useState(false);
    const [eventToEdit, setEventToEdit] = useState(null);

    // Modal states for NotesModal
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [noteToEdit, setNoteToEdit] = useState(null);

    // Initialize Firebase and Auth, and handle authentication state
    useEffect(() => {
        try {
            const appId = window?.__app_id ?? 'default-app-id'; 
            const initialAuthToken = window?.__initial_auth_token ?? null;

            if (!firebaseConfig || Object.keys(firebaseConfig).length === 0) {
                console.error("Firebase config is missing. Please ensure firebaseConfig.js is properly configured.");
                setModalMessage("Firebase is not configured. Please contact support."); 
                setLoading(false);
                return;
            }

            const app = initializeApp(firebaseConfig);
            const analytics = getAnalytics(app); 
            const firebaseAuth = getAuth(app);
            const firestoreDb = getFirestore(app); 
            setAuth(firebaseAuth);
            setDb(firestoreDb); 

            const signInUser = async () => {
                try {
                    if (initialAuthToken) {
                        await signInWithCustomToken(firebaseAuth, initialAuthToken);
                        console.log("Signed in with custom token."); 
                    } else {
                        console.log("No custom token found, not signing in automatically.");
                        // Don't set loading to false here - wait for onAuthStateChanged
                    }
                } catch (error) {
                    console.error("Firebase initial sign-in error:", error); 
                    let errorMessage = `Authentication error: ${error.message}`; 
                    if (error.code === 'auth/admin-restricted-operation') {
                        errorMessage += "\n\nThis might indicate an issue with custom token setup or Firebase project permissions."; 
                    }
                    setModalMessage(errorMessage);
                    setLoading(false); // Only set loading false on error
                }
            };

            signInUser();

            onAuthStateChanged(firebaseAuth, async (currentUser) => {
                setUser(currentUser);
                if (currentUser && firestoreDb) {
                    try {
                        const userDocRef = doc(firestoreDb, `users/${currentUser.uid}`);
                        const userDocSnap = await getDoc(userDocRef);
                        if (userDocSnap.exists()) {
                            const userData = userDocSnap.data();
                            setUserColor(userData.color || '#4d9eff');
                            
                            // Load Discord data if it exists
                            if (userData.discordData) {
                                setUserDiscordData(userData.discordData);
                                console.log("Discord data loaded on app init:", userData.discordData.username || userData.discordData.globalName);
                            } else {
                                setUserDiscordData(null);
                                console.log("No Discord data found for user");
                            }
                        } else {
                            setUserColor('#4d9eff');
                            setUserDiscordData(null);
                        }
                    } catch (error) {
                        console.error("Error fetching user data:", error); 
                    }
                } else {
                    setUserColor('#4d9eff'); 
                    setUserDiscordData(null);
                }
                
                // Set loading to false once we have a definitive auth state
                setLoading(false);
                
                console.log("Auth state changed:", currentUser ? currentUser.email || currentUser.uid : "Logged out"); 
            });

            const handlePopState = () => {
                const path = window.location.pathname.substring(1); 
                const urlParams = new URLSearchParams(window.location.search);
                const discordCode = urlParams.get('code');
                
                // If we have a Discord OAuth code and we're on the panel route, 
                // ensure we're staying on panel to complete the OAuth flow
                if (discordCode && (path === 'panel' || path === '')) {
                    setCurrentPage('panel');
                    return;
                }
                
                if (['login', 'register', 'forgot-password', 'panel', 'administration', 'todo'].includes(path)) {
                    setCurrentPage(path);
                } else if (path.startsWith('server-detail/')) {
                    const id = path.substring('server-detail/'.length);
                    setSelectedServerId(id);
                    setCurrentPage('server-detail');
                }
                else {
                    setCurrentPage('home'); 
                }
            };

            window.addEventListener('popstate', handlePopState);
            handlePopState(); 

            const styleSheet = document.createElement("style");
            styleSheet.type = "text/css";
            styleSheet.innerText = customGlobalStyles; 
            document.head.appendChild(styleSheet);
            console.log("Custom styles injected."); 

            const fontAwesomeLink = document.createElement('link');
            fontAwesomeLink.rel = 'stylesheet';
            fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
            document.head.appendChild(fontAwesomeLink);
            console.log("Font Awesome injected."); 

            const tailwindScript = document.createElement('script');
            tailwindScript.src = 'https://cdn.tailwindcss.com';
            document.head.appendChild(tailwindScript);
            console.log("Tailwind CSS CDN injected."); 


            return () => {
                styleSheet.remove();
                fontAwesomeLink.remove();
                tailwindScript.remove();
                window.removeEventListener('popstate', handlePopState); 
                console.log("Styles and scripts cleaned up."); 
            };
        } catch (error) {
            console.error("Error initializing Firebase:", error); 
            setModalMessage(`Firebase initialization error: ${error.message}`); 
            setLoading(false);
        }
    }, []); 

    // Fetch username when user changes
    useEffect(() => {
        if (user && db) {
            const fetchUsername = async () => {
                try {
                    const userDocRef = doc(db, 'users', user.uid);
                    const userDoc = await getDoc(userDocRef);
                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        setFetchedUsername(userData.username || user.email);
                    } else {
                        setFetchedUsername(user.email); // Fallback to email if username not found
                    }
                } catch (error) {
                    console.error("Error fetching username:", error);
                    setFetchedUsername(user.email); // Fallback on error
                }
            };
            
            fetchUsername();
        }
    }, [user, db]);

    // Fetch all admin users for TodoModal
    useEffect(() => {
        if (!db) return;

        const usersCollectionRef = collection(db, 'users');
        const q = query(usersCollectionRef, where('role', '==', 'admin'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedAdmins = snapshot.docs.map(doc => ({
                uid: doc.id,
                ...doc.data()
            }));
            setAllAdmins(fetchedAdmins);
        }, (error) => {
            console.error("Error fetching admin users:", error);
        });

        return () => unsubscribe();
    }, [db]);

    const handleNavigate = (page, serverId = null) => {
        setCurrentPage(page);
        setSelectedServerId(serverId);
        let path = '';
        if (page === 'home') {
            path = '/';
        } else if (page === 'server-detail' && serverId) {
            path = `/server-detail/${serverId}`;
        } else {
            path = `/${page}`;
        }
        window.history.pushState({}, '', path);
        window.scrollTo(0, 0); 
    };

    const updateFetchedUsername = (newUsername) => {
        setFetchedUsername(newUsername);
    };

    const handleLogin = async (email, password, setError) => {
        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
            setModalMessage('Login successful!'); 
            handleNavigate('panel');
        } catch (error) {
            console.error("Login error:", error); 
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleRegister = async (username, email, password, setError) => {
        setLoading(true);
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const registeredUser = userCredential.user;

            if (db && registeredUser) {
                const userDocRef = doc(db, `users/${registeredUser.uid}`); 
                await setDoc(userDocRef, {
                    username: username,
                    email: email,
                    uid: registeredUser.uid,
                    createdAt: new Date().toISOString(),
                    role: 'user', 
                    color: '#4d9eff' 
                });
                console.log("User data saved to Firestore:", registeredUser.uid); 
            } else {
                console.warn("Firestore or user object not available, user data not saved."); 
            }

            setModalMessage('Registration successful! Please log in.'); 
            handleNavigate('login');
        }
        catch (error) {
            console.error("Registration error:", error); 
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async (email, setMessage, setError) => {
        setLoading(true);
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('If an account with that email exists, a password reset link has been sent.'); 
        } catch (error) {
            console.error("Password reset error:", error); 
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    // Script claiming function
    const claimScript = async (purchaseId) => {
        try {
            if (!user || !db) {
                setModalMessage('Authentication required to claim scripts.');
                return;
            }

            // Import purchases data dynamically
            const purchasesData = require('./purchases.json');
            
            // Find the purchase by ID
            const foundPurchase = purchasesData.find(purchase => purchase.purchase_id === purchaseId);
            
            if (!foundPurchase) {
                setModalMessage('Purchase ID not found. Please check your purchase ID and try again.');
                return;
            }

            // Check if script already exists for this user
            const userScriptsRef = collection(db, `users/${user.uid}/my-scripts`);
            const existingScriptsQuery = query(userScriptsRef, where('purchaseId', '==', purchaseId));
            const existingScriptsSnapshot = await getDocs(existingScriptsQuery);

            if (!existingScriptsSnapshot.empty) {
                setModalMessage('This script has already been claimed with this purchase ID.');
                return;
            }

            // Create the script document
            const scriptData = {
                name: foundPurchase.name,
                packageId: foundPurchase.package_id,
                purchaseId: foundPurchase.purchase_id,
                originalPrice: foundPurchase.price.amount,
                currency: foundPurchase.price.currency,
                claimedAt: new Date().toISOString(),
                userId: user.uid
            };

            // Add script to user's my-scripts subcollection
            const newScriptRef = await addDoc(userScriptsRef, scriptData);
            
            setModalMessage(`Successfully claimed "${foundPurchase.name}"! The script has been added to your collection.`);
            setShowClaimScriptModal(false);
            
        } catch (error) {
            console.error('Error claiming script:', error);
            setModalMessage('Failed to claim script. Please try again later.');
        }
    };

    // Modal handler functions
    const handleShowClaimModal = () => {
        setShowClaimScriptModal(true);
    };

    const handleCloseClaimModal = () => {
        setShowClaimScriptModal(false);
    };

    const handleShowUpdatesModal = (script) => {
        setSelectedScriptForUpdates(script);
        setShowUpdatesModal(true);
    };

    const handleCloseUpdatesModal = () => {
        setShowUpdatesModal(false);
        setSelectedScriptForUpdates(null);
    };

    // Custom Order modal handler functions
    const handleShowCustomOrderModal = (order = null) => {
        setOrderToEdit(order);
        setShowCustomOrderModal(true);
    };

    const handleCloseCustomOrderModal = () => {
        setShowCustomOrderModal(false);
        setOrderToEdit(null);
    };

    // Custom Order Chat modal handler functions
    const handleShowCustomOrderChatModal = (order) => {
        setSelectedOrderForChat(order);
        setShowCustomOrderChatModal(true);
    };

    const handleCloseCustomOrderChatModal = () => {
        setShowCustomOrderChatModal(false);
        setSelectedOrderForChat(null);
    };

    // Todo modal handler functions
    const handleShowTodoModal = (todo = null) => {
        setTodoToEdit(todo);
        setShowTodoModal(true);
    };

    const handleCloseTodoModal = () => {
        setShowTodoModal(false);
        setTodoToEdit(null);
    };

    // Event modal handler functions
    const handleShowEventModal = (event = null) => {
        setEventToEdit(event);
        setShowEventModal(true);
    };

    const handleCloseEventModal = () => {
        setShowEventModal(false);
        setEventToEdit(null);
    };

    // Notes modal handler functions
    const handleShowNotesModal = (note = null) => {
        setNoteToEdit(note);
        setShowNotesModal(true);
    };

    const handleCloseNotesModal = () => {
        setShowNotesModal(false);
        setNoteToEdit(null);
    };

    // Todo save and delete functions
    const handleSaveTodo = async (todoDataToSave) => {
        if (!user || !db) {
            setModalMessage("User not authenticated, database not available, or app ID missing.");
            return;
        }
        try {
            const appId = window?.__app_id ?? 'default-app-id';
            const todosCollectionRef = collection(db, `artifacts/${appId}/public/data/todos`);
            if (todoDataToSave.id) {
                // Update existing todo
                const todoDocRef = doc(db, `artifacts/${appId}/public/data/todos`, todoDataToSave.id);
                await setDoc(todoDocRef, todoDataToSave, { merge: true });
                setModalMessage("Todo updated successfully!");
            } else {
                // Add new todo
                const { id, ...dataWithoutId } = todoDataToSave; // Destructure to exclude 'id'
                await addDoc(todosCollectionRef, {
                    ...dataWithoutId,
                    ownerId: user.uid,
                    createdAt: new Date().toISOString(),
                    completed: false // New todos are initially not completed
                });
                setModalMessage("Todo added successfully!");
            }
            handleCloseTodoModal();
        } catch (error) {
            console.error("Error saving task:", error);
            setModalMessage(`Failed to save task: ${error.message}`);
        }
    };

    const handleDeleteTodo = async (todoId) => {
        if (!user || !db) {
            setModalMessage("User not authenticated or database not available.");
            return;
        }
        try {
            const appId = window?.__app_id ?? 'default-app-id';
            const todoDocRef = doc(db, `artifacts/${appId}/public/data/todos`, todoId);
            await deleteDoc(todoDocRef);
            setModalMessage("Todo deleted successfully!");
            handleCloseTodoModal();
        } catch (error) {
            console.error("Error deleting todo:", error);
            setModalMessage(`Failed to delete todo: ${error.message}`);
        }
    };

    // Event save and delete functions
    const handleSaveEvent = async (eventDataToSave) => {
        if (!user || !db) {
            setModalMessage("User not authenticated or database not available.");
            return;
        }
        try {
            const appId = window?.__app_id ?? 'default-app-id';
            const eventsCollectionRef = collection(db, `artifacts/${appId}/public/data/calendarEvents`);
            if (eventDataToSave.id) {
                // Update existing event
                const eventDocRef = doc(db, `artifacts/${appId}/public/data/calendarEvents`, eventDataToSave.id);
                await setDoc(eventDocRef, eventDataToSave, { merge: true });
                setModalMessage("Event updated successfully!");
            } else {
                // Add new event
                const { id, ...dataWithoutId } = eventDataToSave;
                await addDoc(eventsCollectionRef, {
                    ...dataWithoutId,
                    ownerId: user.uid,
                    createdAt: new Date().toISOString()
                });
                setModalMessage("Event added successfully!");
            }
            handleCloseEventModal();
        } catch (error) {
            console.error("Error saving event:", error);
            setModalMessage(`Failed to save event: ${error.message}`);
        }
    };

    const handleDeleteEvent = async (eventId) => {
        if (!user || !db) {
            setModalMessage("User not authenticated or database not available.");
            return;
        }
        try {
            const appId = window?.__app_id ?? 'default-app-id';
            const eventDocRef = doc(db, `artifacts/${appId}/public/data/calendarEvents`, eventId);
            await deleteDoc(eventDocRef);
            setModalMessage("Event deleted successfully!");
            handleCloseEventModal();
        } catch (error) {
            console.error("Error deleting event:", error);
            setModalMessage(`Failed to delete event: ${error.message}`);
        }
    };

    // Notes save and delete functions
    const handleSaveNote = async (noteDataToSave) => {
        if (!user || !db) {
            setModalMessage("User not authenticated or database not available.");
            return;
        }
        try {
            const notesCollectionRef = collection(db, 'adminNotes');
            if (noteDataToSave.id) {
                // Update existing note
                const noteDocRef = doc(db, 'adminNotes', noteDataToSave.id);
                await setDoc(noteDocRef, {
                    ...noteDataToSave,
                    lastModified: new Date()
                }, { merge: true });
                setModalMessage("Note updated successfully!");
            } else {
                // Add new note
                const { id, ...dataWithoutId } = noteDataToSave;
                await addDoc(notesCollectionRef, {
                    ...dataWithoutId,
                    authorId: user.uid,
                    authorName: user.email || 'Admin User',
                    createdAt: new Date(),
                    lastModified: new Date()
                });
                setModalMessage("Note created successfully!");
            }
            handleCloseNotesModal();
        } catch (error) {
            console.error("Error saving note:", error);
            setModalMessage(`Failed to save note: ${error.message}`);
        }
    };

    const handleDeleteNote = async (noteId) => {
        if (!user || !db) {
            setModalMessage("User not authenticated or database not available.");
            return;
        }
        try {
            const noteDocRef = doc(db, 'adminNotes', noteId);
            await deleteDoc(noteDocRef);
            setModalMessage("Note deleted successfully!");
            handleCloseNotesModal();
        } catch (error) {
            console.error("Error deleting note:", error);
            setModalMessage(`Failed to delete note: ${error.message}`);
        }
    };

    // Custom Order save function
    const handleSaveCustomOrder = async (orderData) => {
        try {
            if (!user || !db) {
                setModalMessage('Authentication required to save custom orders.');
                return;
            }

            if (orderData.id) {
                // Update existing order
                const orderDocRef = doc(db, `users/${user.uid}/customOrders`, orderData.id);
                await updateDoc(orderDocRef, {
                    title: orderData.title,
                    description: orderData.description,
                    budget: orderData.budget,
                    lastUpdated: new Date(),
                });
                setModalMessage(`Custom order "${orderData.title}" updated successfully!`);
            } else {
                // Add new order
                const ordersCollectionRef = collection(db, `users/${user.uid}/customOrders`);
                await addDoc(ordersCollectionRef, {
                    title: orderData.title,
                    description: orderData.description,
                    budget: orderData.budget,
                    status: 'pending',
                    createdAt: new Date(),
                    lastUpdated: new Date(),
                    userId: user.uid,
                    userEmail: user.email
                });
                setModalMessage(`Custom order "${orderData.title}" submitted successfully!`);
            }
            setShowCustomOrderModal(false);
            setOrderToEdit(null);
        } catch (error) {
            console.error('Error saving custom order:', error);
            setModalMessage(`Failed to save order: ${error.message}`);
        }
    };

    // NewTicket modal handler functions
    const handleShowNewTicketModal = () => {
        setShowNewTicketModal(true);
    };

    const handleCloseNewTicketModal = () => {
        setShowNewTicketModal(false);
    };

    // NewTicket creation function
    const handleCreateNewTicket = async (subject, description, department, scriptName, discordLink) => {
        try {
            if (!user || !db) {
                setModalMessage("You must be logged in to create a ticket.");
                return;
            }
            if (!subject.trim() || !description.trim() || !department.trim()) {
                setModalMessage("Subject, description, and department cannot be empty.");
                return;
            }
            if (department === 'Script Support' && !scriptName.trim()) {
                setModalMessage("Please select a script for Script Support.");
                return;
            }
            if (department === 'Collaboration' && !discordLink.trim()) {
                setModalMessage("Please provide your Discord link for Collaboration.");
                return;
            }

            const ticketsCollectionRef = collection(db, 'supportTickets');
            const newTicket = {
                subject: subject.trim(),
                description: description.trim(),
                department: department.trim(),
                scriptName: department === 'Script Support' ? scriptName.trim() : null,
                discordLink: department === 'Collaboration' ? discordLink.trim() : null,
                status: 'open',
                userId: user.uid,
                userName: fetchedUsername || user.email,
                createdAt: new Date(),
                lastUpdated: new Date(),
            };
            const docRef = await addDoc(ticketsCollectionRef, newTicket);
            setModalMessage(`Ticket "${subject}" created successfully! Ticket ID: ${docRef.id}`);
            setShowNewTicketModal(false);
        } catch (error) {
            console.error("Error creating new ticket:", error);
            setModalMessage(`Failed to create ticket: ${error.message}`);
        }
    };

    const handleLogout = async () => {
        setLoading(true);
        try {
            await signOut(auth);
            setModalMessage('Logged out successfully!'); 
            handleNavigate('home');
        } catch (error) {
            console.error("Logout error:", error); 
            setModalMessage(`Logout failed: ${error.message}`); 
        } finally {
            setLoading(false);
        }
    };

    const closeModal = () => {
        setModalMessage(null);
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#111111] text-white text-xl">
                Loading application...
            </div>
        );
    }

    return (
        <div className="min-h-screen w-screen bg-[#111111]"> 
            {modalMessage && <CustomModal message={modalMessage} onClose={closeModal} />}
            {showClaimScriptModal && (
                <ClaimScriptModal
                    onClose={handleCloseClaimModal}
                    onClaim={claimScript}
                    setModalMessage={setModalMessage}
                />
            )}
            {showUpdatesModal && (
                <ScriptUpdatesModal
                    script={selectedScriptForUpdates}
                    onClose={handleCloseUpdatesModal}
                />
            )}
            {showCustomOrderModal && (
                <CustomOrderModal
                    onClose={handleCloseCustomOrderModal}
                    onSave={handleSaveCustomOrder}
                    orderToEdit={orderToEdit}
                    setModalMessage={setModalMessage}
                />
            )}
            {showCustomOrderChatModal && selectedOrderForChat && (
                <CustomOrderChatModal
                    order={selectedOrderForChat}
                    onClose={handleCloseCustomOrderChatModal}
                    db={db}
                    user={user}
                    setModalMessage={setModalMessage}
                />
            )}
            {showNewTicketModal && (
                <NewTicketModal
                    onClose={handleCloseNewTicketModal}
                    onCreate={handleCreateNewTicket}
                />
            )}
            {showTodoModal && (
                <TodoModal
                    isOpen={showTodoModal}
                    onClose={handleCloseTodoModal}
                    onSave={handleSaveTodo}
                    onDelete={handleDeleteTodo}
                    todoData={todoToEdit}
                    allAdmins={allAdmins}
                    userColor={userColor}
                    userUid={user?.uid}
                    setModalMessage={setModalMessage}
                />
            )}
            {showEventModal && (
                <EventModal
                    isOpen={showEventModal}
                    onClose={handleCloseEventModal}
                    onSave={handleSaveEvent}
                    onDelete={handleDeleteEvent}
                    eventData={eventToEdit}
                    userColor={userColor}
                    setModalMessage={setModalMessage}
                />
            )}
            {showNotesModal && (
                <NotesModal
                    isOpen={showNotesModal}
                    onClose={handleCloseNotesModal}
                    onSave={handleSaveNote}
                    onDelete={handleDeleteNote}
                    noteData={noteToEdit}
                    userColor={userColor}
                    setModalMessage={setModalMessage}
                />
            )}
            {(() => {
                switch (currentPage) {
                    case 'login':
                        return <Login onLogin={handleLogin} onSwitchToRegister={() => handleNavigate('register')} onSwitchToForgotPassword={() => handleNavigate('forgot-password')} onNavigateHome={() => handleNavigate('home')} loading={loading} />;
                    case 'register':
                        return <Register onRegister={handleRegister} onSwitchToLogin={() => handleNavigate('login')} onNavigateHome={() => handleNavigate('home')} loading={loading} />;
                    case 'forgot-password':
                        return <ForgotPassword onResetPassword={handleResetPassword} onSwitchToLogin={() => handleNavigate('login')} onNavigateHome={() => handleNavigate('home')} loading={loading} />;
                    case 'panel':
                        // Check if this is a Discord OAuth callback
                        const urlParams = new URLSearchParams(window.location.search);
                        const discordCode = urlParams.get('code');
                        
                        if (!user) {
                            // If there's a Discord code, we might be in the middle of OAuth flow
                            // Give some time for authentication state to resolve
                            if (discordCode && !loading) {
                                setTimeout(() => {
                                    if (!user) {
                                        setModalMessage("Please log in to access the panel."); 
                                        handleNavigate('login');
                                    }
                                }, 1000); // Wait 1 second for auth state to resolve
                                return (
                                    <div className="min-h-screen flex items-center justify-center bg-[#111111] text-white text-xl">
                                        <div className="text-center">
                                            <i className="fas fa-spinner fa-spin text-3xl mb-4"></i>
                                            <p>Processing Discord authentication...</p>
                                        </div>
                                    </div>
                                );
                            } else {
                                setModalMessage("Please log in to access the panel."); 
                                handleNavigate('login');
                                return null;
                            }
                        }
                        return <Panel 
                                    onNavigateHome={() => handleNavigate('home')} 
                                    onLogout={handleLogout} 
                                    onManageServer={(serverId) => handleNavigate('server-detail', serverId)} 
                                    onManageAdmin={() => handleNavigate('administration')} 
                                    onNavigateTodo={() => handleNavigate('todo')}
                                    user={user} 
                                    loading={loading} 
                                    db={db} 
                                    setModalMessage={setModalMessage} 
                                    userColor={userColor} 
                                    appId={window?.__app_id ?? 'default-app-id'}
                                    userDiscordData={userDiscordData}
                                    setUserDiscordData={setUserDiscordData}
                                    onShowClaimModal={handleShowClaimModal}
                                    onShowUpdatesModal={handleShowUpdatesModal}
                                    onShowCustomOrderModal={handleShowCustomOrderModal}
                                    onShowCustomOrderChatModal={handleShowCustomOrderChatModal}
                                    onShowNewTicketModal={handleShowNewTicketModal}
                                    fetchedUsername={fetchedUsername}
                                    updateFetchedUsername={updateFetchedUsername}
                                />;
                    case 'server-detail':
                        if (!user || !selectedServerId) {
                            setModalMessage("Invalid server access. Please log in or select a server."); 
                            handleNavigate('panel'); 
                            return null;
                        }
                        return <ServerDetail 
                                    serverId={selectedServerId} 
                                    onBackToPanel={() => handleNavigate('panel')} 
                                    user={user} 
                                    db={db} 
                                    setModalMessage={setModalMessage} 
                                />;
                    case 'administration':
                        if (!user) {
                            setModalMessage("Please log in to access the administration panel."); 
                            handleNavigate('login');
                            return null;
                        }
                        return <AdministrationPanel 
                                    onBackToPanel={() => handleNavigate('panel')} 
                                    user={user} 
                                    db={db} 
                                    setModalMessage={setModalMessage} 
                                    userColor={userColor} 
                                    appId={window?.__app_id ?? 'default-app-id'} 
                                    onShowTodoModal={handleShowTodoModal}
                                    onShowEventModal={handleShowEventModal}
                                    onShowNotesModal={handleShowNotesModal}
                                    allAdmins={allAdmins}
                                />;
                    case 'todo':
                        if (!user) {
                            setModalMessage("Please log in to access the todo page."); 
                            handleNavigate('login');
                            return null;
                        }
                        return <TodoPage 
                                    user={user} 
                                    db={db} 
                                    setModalMessage={setModalMessage} 
                                    onBackToPanel={() => handleNavigate('panel')}
                                />;
                    case 'home':
                    default:
                        return <HomePage onNavigate={handleNavigate} user={user} />;
                }
            })()}
        </div >
    );
};

export default App;